<app-headnav [user]="tempInfo" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>

<div id="task-box" #tempList class="task-box task-box2" cdkDrag>
	<div class="row" style="margin: 4px; background-color: rgb(9, 17, 33);">
		<span style="min-width: 10%; float: left; margin-top: 2px; margin-bottom: 2px;">
			<a style="cursor: pointer; color: #C2D63F;" (click)="expandcollapse(); " title="Expand/Collapse">
				<i *ngIf="!expanded" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:4px; margin-top:2px; color: #C2D63F;"><strong>Company Template(s)</strong></span>
		<span *ngIf="expanded" style="font-size: 18px; margin-left:32%; margin-top:5px; color: #C2D63F;"><strong>Company Template(s)</strong></span>
	</div>
	<div [hidden]="!expanded" class="row" style="margin: 1px; margin-top: 10px;">
		

		<div style="width:80vw;background-color:rgb(9, 17, 33)">
			<p-table #ttt styleClass="p-datatable-sm" [value]="allTemplates" [columns]="templateCols" [scrollable]="true"
            scrollHeight="calc(100vh - 250px)">
            <ng-template pTemplate="caption" >

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>

                <input type="search" pInputText placeholder="Search"
                  (input)="ttt.filterGlobal($event.target.value, 'contains')" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px;">
                <th *ngFor="let col of columns; trackBy:trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px;" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index; trackBy:trackByFuntion" style="padding:2px">
                  <input *ngIf="col.field!='CATEGORY_NAME' && col.field!='SUBCATEGORY_NAME'&& col.field!='STATUS'&&col.field!='EDIT'" class="inputHeader" pInputText type="text"
                    (input)="ttt.filter($event.target.value, col.field, col.filterMatchMode)"
                    style="margin:0 2px; font-size:12px; width:98%;background-color: rgb(9 17 33); border: 0px">
                    <select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px"  *ngIf="col.field=='SUBCATEGORY_NAME'"[(ngModel)]="selectedFilter"  (change)="filterTemplates(selectedFilter)">
                      <option [ngValue]="{'SUBCATEGORY_NAME': ''}">
    
                      </option>
                      <option *ngFor="let templatefilter of templateFilterOptions; trackBy:trackByFuntion" [ngValue]="templatefilter">
    
                        {{templatefilter.CATEGORY? templatefilter.CATEGORY: templatefilter.SUBCATEGORY_NAME}}
                      </option>
                    </select>
                    <select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px" *ngIf="col.field=='CATEGORY_NAME'" [(ngModel)]="selectedFilter2" (change)="filterTemplates2(selectedFilter2)">
                      <option [ngValue]="{'CATEGORY': ''}">
    
                      </option>
                      <option *ngFor="let templatefilter of templateFilterOptions2; trackBy:trackByFuntion" [ngValue]="templatefilter">
    
                        {{templatefilter.CATEGORY? templatefilter.CATEGORY: templatefilter.SUBCATEGORY_NAME}}
                      </option>
                    </select>
					<select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px" *ngIf="col.field=='STATUS'" [(ngModel)]="selectedFilter3" (change)="filterTemplates3(selectedFilter3)">
						<option [ngValue]="''">
	  
						</option>
						<option [ngValue]="'Active'">
	  
						  Active
						</option>
						<option [ngValue]="'Inactive'">
	  
							Inactive
						  </option>
					  </select>
      
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy:trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 4px solid rgb(9 17 33); border-width: 0px 4px 4px 4px; background-color: rgb(28 36 51)">
                  <span class="line-clamp1" *ngIf="col.field!='SUBCATEGORY_NAME' && col.field!='TEMPLATE_TITLE' && col.field!='STATUS'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                  <span *ngIf="col.field=='STATUS'">
                    {{user.STATUS}}
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS=='Active'"
                      (click)=changeStatus(user)>
                      <i class="erisIconColor fas fa-toggle-on"></i>
                    </a>
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS!='Active'"
                      (click)=changeStatus(user)>
                      <i class="erisIconColor fas fa-toggle-off"></i>
                    </a>
                    </span>
                  <span class="line-clamp1" *ngIf="col.field=='TEMPLATE_TITLE'">
                    <a style="color:rgb(195,212,47); cursor: pointer; margin-right:19px; text-overflow: ellipsis;" [href]="'template/'+user.TEMPLATE_ID" target=_blank
													
														title="Edit">{{user.TEMPLATE_TITLE}}</a><span>({{user.TEMPLATE_VERSION_NO}})</span>
							<a *ngIf="companyGroupIndicator"  class="ml-1" [ngClass]="{'disabled':!user.GROUP_LIST}" style="cursor:pointer; float:right; margin:3px;" (click)="op123.toggle($event);" title="List of Groups"><i class="erisIconColor fab fa-google"></i></a>
                            <a class="ml-1"    style="cursor:pointer; float:right; margin:3px;" (click)="getAllTempByTypeID(user.TEMPLATE_ID); op1.toggle($event);"
													
                            title="List of Reports"><i class="erisIconColor fas fa-registered"></i></a>
                            <a class="ml-1"    style="cursor:pointer; float:right; margin:3px;" (click)="checkUpdateTemplateTitlePermission();resetTypeList(); op2.toggle($event);"
                            title="Edit Template title"><i class="erisIconColor fas fa-pen"></i></a>

                            <p-overlayPanel #op2 [appendTo]="'body'">
								<ng-template pTemplate> 
									<input class="rptInfo" style="width:300px" type="text" [(ngModel)]="user[col.field]" [disabled]="!updateTemplateTitlePermission">
										<button (click)="updateTemplateTitle(user); op2.hide()"
										class="btn m-0 uploadBtn">Submit</button>
								</ng-template>
                            </p-overlayPanel>
							<p-overlayPanel #op123 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true">
								<ng-template pTemplate> 
									<label class="popheader" style="color:#C2D63F">Group List:</label>
									<ng-container *ngFor="let group of user.GROUP_LIST.split(',')">
										<hr class="line1"><label style="font-size: 12px;">{{group}}</label>
									</ng-container>
								</ng-template>
                            </p-overlayPanel>
                            <p-overlayPanel #op1 [appendTo]="'body'"  [style]="{'max-width':'70vw'}">
                              <ng-template pTemplate>
                                <span  style="font-size:.8em; color: #C2D63F;" *ngIf="typeList.length==0">
                                  No Reports Were Found
                                </span>
                                <ng-container>
                              
                                    <p-table *ngIf="typeList.length!=0" #dt [value]="typeList">
                                      <ng-template pTemplate="caption">
                                        <i class="pi pi-search"></i>
                                                  <input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" style="font-size:11px; padding:2px"/>
                                      </ng-template>
                                          <ng-template pTemplate="header">
                                                          <tr>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Report Title
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Project Number
        
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property Name
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property Address
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property City
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property State <br> Province
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property Zip <br> Postal Code
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Transaction Type
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Protocol
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Status
                                                              <p-sortIcon field="code"></p-sortIcon>  
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Last Edited
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
															<th *ngIf="companyGroupIndicator" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Report Group
																<p-sortIcon field="code"></p-sortIcon>   
															  </th>
                                                          </tr>
                                                      </ng-template>
                                                      <ng-template pTemplate="body" let-rowData>
                                                          <tr>
                                                            <td style="padding:1px; font-size:11px"><a  target="_blank" 
                                                              [attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID"
                                                                style="font-size:.8em; color: #C2D63F;"
>{{rowData.REPORT_TITLE}}</a>
                                                              </td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROJECT_NUMBER}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROPERTY_NAME}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.ADDRESS_LINE1}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.CITY}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROVSTATE}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.POSTALZIP}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.TRANSACTION_TYPE}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROTOCOL}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.STATUS}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.LAST_UPDATED}}</td>
                                                              <td *ngIf="companyGroupIndicator" style="padding:1px; font-size:11px">{{rowData.REPORT_GROUP.GROUP_NAME}}</td>
                                                          </tr>
                                                      </ng-template>
                                                  </p-table>			
                                </ng-container>
                              </ng-template>
                            </p-overlayPanel>
                  </span>
                  <span class="line-clamp1" *ngIf="col.field=='SUBCATEGORY_NAME'" style="float:left"> 
                   {{user[col.field]}} ({{templateCountDict[user[col.field]]? templateCountDict[user[col.field]]:0  }})
                   
                  </span>
                  <span *ngIf="col.field=='EDIT'">
                    <a style="cursor:pointer" class="ml-1"   data-target='#copyWith' data-toggle="modal" (click)="templateRow=user;">
                      <i class="fas fa-copy erisIconColor"></i></a>
                    
                  </span>
                  <span *ngIf="col.field=='DATE_UPDATED'">
										<a (click)="getTemplateHistory2(user); op1.toggle($event)"  style="cursor:pointer; color:rgb(195,212,47)"> {{user[col.field]}}</a>
										<p-overlayPanel #op1 [appendTo]="'body'" [style]="{'z-index':'999999', 'min-width':'300px'}">

											<ng-template pTemplate>
												<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
													<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
													<br>
												</span> -->
												<table  style="padding:1px; font-size:11px" [pSortableColumn]="col.field" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
													<thead>
													  <tr style="color:rgb(195,212,47); font-size:12px">
									
													  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Edited By</th>
													  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Edit Date</th>
													  </tr>
													</thead>
													<tbody>
													  <ng-container *ngFor="let history of user.RW_TEMPLATE_HISTORY; let i=index; trackBy:trackByFuntion">
														<tr style="color:rgb(195,212,47); font-size:12px">
														<td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{history.UPDATED_BY}}</td>
														<td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{history.DATE_UPDATED}}</td>
														
														</tr>
													  </ng-container>
													</tbody>
													</table>
											</ng-template>
										</p-overlayPanel>
									</span>
                </td>
              </tr>
            </ng-template>
          </p-table>
		</div>
	</div>
</div>
<div class="modal fade" id="deleteTempConfirm" tabindex="-1" role="dialog"
aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered " role="document">
  <div class="modal-content">
	<div class="modal-header">
	  <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
		delete the Template?</h5>
	  <button type="button" (click)="dismissConfirm3($event);" class="close"
		aria-label="Close">
		<span aria-hidden="true">&times;</span>
	  </button>
	</div>
	<div class="modal-body ">
	  <button type="button" class="btn btn-secondary"
		(click)="dismissConfirm3($event);">Go Back</button>
	  <button style="float:right" type="button" class="btn btn-primary"
		(click)="dismissConfirm3($event); deleteTemplate()">Delete</button>
	</div>
  </div>
</div>
</div>
<div class="modal fade" id="copyWith" tabindex="-1" role="dialog"
aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered " role="document">
  <div class="modal-content">
	<div class="modal-header">
	  <h5 class="modal-title" id="exampleModalLabel">Copy With Repeat Fields?</h5>
	  <button type="button" (click)="dismissConfirm4($event);" class="close"
		aria-label="Close">
		<span aria-hidden="true">&times;</span>
	  </button>
	</div>
	<div class="modal-body ">
	  <button type="button" class="btn btn-secondary"
		(click)="dismissConfirm4($event); copyTemplate('N')">No</button>
	  <button style="float:right" type="button" class="btn btn-primary"
		(click)="dismissConfirm4($event); copyTemplate('Y')">Yes</button>
	</div>
  </div>
</div>
</div>
<div *ngIf="!userId" class="studio">
</div>
<div id="overlay" style="background: black url('/assets/images/loader.gif') center center no-repeat;"></div>
<div id="overlay2" style="display:none; background: transparent url('/assets/images/loader.gif') center center no-repeat;"></div>
<div *ngIf="userId" class="studio">
	<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="dashboard" title="Dashboard" target=_blank>
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" class="active"><i class="icon-Template" style="font-size:32px"></i>
				<span aria-hidden="true" style="position: absolute; left: 86px">Templates</span>

			</a>
			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>





			
		</div>

<div class="main">

<div class="row container-fluid p-0 m-0" style="height:100%; overflow:auto">
<div class="col-md-3 contentContainer">

	<ul class="nav nav-tabs">
    <li class="nav-item">
		<a class="nav-link active" data-toggle="tab" href="#content">Sections</a>		
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#app">Appendices</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#slot" title="Repeat Field">Re-Fields<span *ngIf="curTemp">( {{ curTemp.TOTAL_TEMPLATE_SLOTS}} /{{curTemp.TOTAL_SLOTS}}  )</span></a>
    </li>
	<li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#lib" title="Libraries" (click)="checkLib()">LIB</a>
    </li>
	<li class="nav-item" *ngIf="tempInfo?.PCA_INDICATOR=='Y'||tempInfo?.PCA_INDICATOR=='4099e'||tempInfo?.PCA_INDICATOR=='frm1105'">
      <a class="nav-link" data-toggle="tab" href="#pca" title="PCA" (click)="getPCAData()">PCA</a>
    </li>
  </ul>
  <!-- Tab panes -->
  <div  *ngIf="tempInfo" class="tab-content">
    <div id="content" class="container tab-pane active"  style="padding:0; position:relative" [style.pointer-events]="tableShow ? 'none' : 'auto'">	
	
		<div style="position:fixed; top:116px; background-color:rgb(9, 17, 33); width:24.11%">
			<select class="expandSel">
				<option class="expandOp" value='1'>1</option>
				<option class="expandOp" value='2'>2</option>				
			</select>
			<button class="btn btn-outline-dark btn-list" *ngIf="sections&&sections.length>0" (click)="op222.toggle($event);loading=false;">ERIS Suggests</button>
			<button class="btn btn-black btn-list" (click)='op201.toggle($event);loading=false;'> + </button>
			<button class="btn btn-black btn-list" (click)='addFSections()' [disabled]="tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103'">Add Section</button>
			<p-overlayPanel #op201 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '300px'}">
                <ng-template pTemplate>
					<div style="max-height:100px; overflow-y:auto">
						<button  type="button" class="btn btn-black btn-list1 " (click)='addFPage()'>Add Section Before TOC</button>
						<button  *ngIf="allowPhase1PS=='Y'" type="button" class="btn btn-black btn-list1 " (click)='preSetSummary("pre")'>Add Project Summary Before TOC</button>
					</div>					
				</ng-template>
            </p-overlayPanel>
			<button class="btn btn-black btn-list" (click)='expandToggle($event)'>Expand</button>
			</div>
			<p-overlayPanel #op222 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="false" [style]="{width: '400px'}">
                <ng-template pTemplate>
					<div style="max-height:600px; overflow-y:auto">
					<ng-container *ngFor="let sec of sections; let i=index; trackBy:trackByFuntion">
						<a class="dropdown-item listItem1" href="javascript:void(0)" (click)="selectSec(i)">
							{{sec.SECTION_TITLE}}
							<i *ngIf="sec.SUB_SECTIONS.length>0" class="btn-outline-light btn-small fas fa-angle-down p-2" (click)="toggleChild($event)"></i>
							<i class="btn-outline-light btn-small fas fa-plus p-2 float-right" (click)="addSec(sec)"></i>
						</a>
						<div style="display:none">
							<ng-container *ngIf="sec.SUB_SECTIONS.length>0">
								<ng-container *ngFor="let sec1 of sec.SUB_SECTIONS; trackBy:trackByFuntion">
									<a class="dropdown-item listItem1" href="javascript:void(0)"> . {{sec1.SECTION_TITLE}}</a>
									<ng-container *ngIf="sec1.SUB_SECTIONS?.length>0">
										<ng-container *ngFor="let sec2 of sec1.SUB_SECTIONS; trackBy:trackByFuntion">
											<a class="dropdown-item listItem1" href="javascript:void(0)"> . . {{sec2.SECTION_TITLE}}</a>
										</ng-container>	
									</ng-container>	
								</ng-container>	
							</ng-container>	
						</div>						
					</ng-container>	
					</div>					
				</ng-template>
            </p-overlayPanel>
	<div class='fixContent' >		
	<div cdkDropList [cdkDropListData]="frontpages" (cdkDropListDropped)="dropFront($event)">
	<div class="example-list" cdkDrag [cdkDragData]="page" *ngFor="let page of frontpages;let s=index; trackBy:trackByFuntion" style="background:#000; color:white;">
		<a  [id]="page.id+'list'" class="dropdown-item listItem" [ngClass]="{'active':listid==page.id}" href="javascript:void(0)" style="font-weight:bold" (click)="getFListPosition(page.id, $event, s);selectedRow=-1;selectedCell=null">
			<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;" (click)="addLib=false; getFPosition(page.id, $event,s)">
			{{page.SECTION_TITLE}}	</label>					
			<i class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removePage(s)" style="color:#F78181"></i>
			<a *ngIf="page.pdf&&page.pdf.length>0" class="float-md-right" [href]="page.pdf" target=_blank ><i class="btn-outline-dark btn-small far fa-file-pdf p-2" style="color:#C2D63F"></i></a>
			<i *ngIf="page.SUB_SECTIONS&&page.SUB_SECTIONS.length>0" class="btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" style="color:#ccc" (click)="toggleChild($event)"></i>
			<app-edit-input class="float-md-right" [text]="page.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s)"></app-edit-input>
		</a>
		<div cdkDropList class="example-list exDiv1" [attr.data-id]="page.id+'panel'" [cdkDropListData]="page.SUB_SECTIONS" 
			(cdkDropListDropped)="dropFItem($event)"	[cdkDropListConnectedTo]="getFConnectedList()" style="display:none; background:#000000; clear: right">
			<div class="example-box" 
				*ngFor="let page1 of page.SUB_SECTIONS;let t=index; trackBy:trackByFuntion" 
				cdkDrag [cdkDragData]="page1"  style="background:#000;">
					<a  [id]="page1.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':page1.id==listid}" (click)="getFListPosition(page1.id, $event,s,t);selectedRow=-1;selectedCell=null">
						<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;"> . {{page1.SECTION_TITLE}}</label>
						<i *ngIf="page1['TYPE']!='PITABLE'" class=" btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('front',page1,s, t)"  style="color:#F78181"></i>
						<i *ngIf="page1['TYPE']=='PITABLE'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section can not be delete." style="color:#666; pointer-events:none"></i>
						
						<app-edit-input  class="float-md-right" [text]="page1.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s,t)"></app-edit-input>
					</a>
			</div>
		</div>
	</div>
	<div class="example-list" style="background:#000; color:white;">
		<a class="dropdown-item listItem" href="javascript:void(0)" style="font-weight:bold">
			<label style="max-width: 70%; white-space: normal;color:#999;pointer-events: none;">
			Table of Contents</label>					
			
		</a>
	</div>
	</div>
	<div cdkDropList [cdkDropListData]="contents" (cdkDropListDropped)="dropGroups($event)">
		
	<div cdkDropListGroup class="example-list"   *ngFor="let group of contents;let i=index; trackBy:trackByFuntion" cdkDrag [cdkDragData]="group"  style="background:#000; color:white;">
		<a [id]="group.id+'list'" class="dropdown-item listItem" [ngClass]="{'active':curIndex[0]==i&&(curIndex[1]===undefined)&&(curIndex[2]===undefined)}" href="javascript:void(0)" style="font-weight:bold" (click)="getListPosition(group,$event,i);selectedRow=-1;selectedCell=null">
							<!--<app-editable [text]="group.SECTION_TITLE" (edited)="changeTitle('content',$event,i)"></app-editable>-->
							<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;">{{group.SECTION_SEQUENCE}} {{group.SECTION_TITLE}}</label>
							<i *ngIf="group.TYPE!='COST'&&group.TYPE!='4099e'&&group.TYPE!='1105'&&group.TYPE!='frm1104'&&group.TYPE!='frm1103'" class="brn btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('content',group,i)" style="color:#F78181"></i>
							<i *ngIf="group.TYPE=='COST'||group.TYPE=='4099e'||group.TYPE=='1105'||group.TYPE=='frm1104'||group.TYPE=='frm1103'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="Section can not be delete." style="color:#666; pointer-events:none"></i>
							<!--<i *ngIf="group.TYPE!='COST'&&group.TYPE!='4099e'&&group.TYPE!='SUMMARY'" class="brn btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('content',group,i)" style="color:#F78181"></i>
							<i *ngIf="group.TYPE=='COST'||group.TYPE=='4099e'||group.TYPE=='SUMMARY'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section can not be delete." style="color:#666; pointer-events:none"></i>
							-->
							<i *ngIf='group.TYPE=="PISUMMARY"||group.TYPE=="PCASUMMARY"||group.TYPE=="frm1104"||group.TYPE=="frm1103"' class="brn btn-outline-dark btn-small fas fa-plus p-2 float-md-right" style="color:#666"></i>
							<i *ngIf='group.TYPE!="PISUMMARY"&&group.TYPE!="PCASUMMARY"&&group.TYPE!="frm1104"&&group.TYPE!="frm1103"' class="brn btn-outline-dark btn-small fas fa-plus p-2 float-md-right" (click)="addChild($event,'content',group,i)" style="color:#ccc"></i>
							<i *ngIf="group.SUB_SECTIONS.length>0" class="brn btn-outline-dark btn-small fas fa-angle-down p-2 float-md-right" (click)="toggleChild($event)" style="color:#ccc"></i>
							<app-edit-input  class="float-md-right" [text]="group.SECTION_TITLE" (edited)="changeTitle('content',$event,i)"></app-edit-input>
					
						</a>
		<div cdkDropList class="exDiv1"  [attr.data-id]="group.id+'panel'" [cdkDropListData]="group.SUB_SECTIONS" (cdkDropListDropped)="dropGroup($event,i)"  style="display:none; background:#000;margin:0; padding:0;clear: right">
	<div cdkDropListGroup class="example-list"   *ngFor="let items of group.SUB_SECTIONS;let j=index; trackBy:trackByFuntion" cdkDrag [cdkDragData]="items" style="background:#000; color:white" [cdkDragDisabled]="tempInfo?.PCA_INDICATOR.indexOf('frm')>-1">
		<a [id]="items.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':curIndex[0]==i&&curIndex[1]==j&&(curIndex[2]===undefined)}"  (click)="getListPosition(items,$event,i,j);selectedRow=-1;selectedCell=null">  
			<!--<app-editable [text]="items.SECTION_TITLE" (edited)="changeTitle('content',$event,i, j)"></app-editable>-->
										<label style="max-width: 70%; white-space: normal;color:white;pointer-events: none;"> . {{items.SECTION_SEQUENCE}} {{items.SECTION_TITLE}}</label>
									 	<i *ngIf="items.TYPE!='PCATABLE'&&items.TYPE!='4099e'&&items.TYPE!='PITABLE'&&(!items['tableClass'])&&items.TYPE!='frm1104'&&items.TYPE!='frm1103'" class="brn btn-outline-dark btn-small fas fa-trash p-2  float-md-right" (click)="removeSec('content',items,i, j)" style="color:#F78181"></i>
										<i *ngIf="items.TYPE=='PCATABLE'||items.TYPE=='4099e'||items.TYPE=='PITABLE'||items['tableClass']||items.TYPE=='frm1104'||items.TYPE=='frm1103'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section can not be delete." style="color:#666; pointer-events:none"></i>
										<i *ngIf='items.TYPE=="PITABLE"||items["tableClass"]||items.TYPE=="frm1104"||items.TYPE=="frm1103"' class="brn btn-outline-dark btn-small fas fa-plus p-2  float-md-right" style="color:#666"></i>
										<i *ngIf='items.TYPE!="PITABLE"&&(!items["tableClass"])&&items.TYPE!="frm1104"&&items.TYPE!="frm1103"' class="brn btn-outline-dark btn-small fas fa-plus p-2  float-md-right" (click)="addChild($event,'content',items,i, j)" style="color:#ccc"></i>
										<i *ngIf="items.SUB_SECTIONS?.length>0" class="brn btn-outline-dark btn-small fas fa-angle-down p-2  float-md-right" (click)="toggleChild($event)" style="color:#ccc"></i>
										<app-edit-input class="float-md-right" [text]="items.SECTION_TITLE" (edited)="changeTitle('content',$event,i,j)"></app-edit-input>
										
										<label   *ngIf="items.app" style="pointer-events: none;">( {{items?.app?.name}}{{items?.app?.text}} )</label>
										
									</a>
		<div cdkDropList class="example-list exDiv2" [attr.data-id]="items.id+'panel'" [cdkDropListData]="items.SUB_SECTIONS" 
    (cdkDropListDropped)="dropItem($event)"
		[cdkDropListConnectedTo]="getConnectedList()"  style="display:none; background:#000000; clear: right">
			<div class="example-box" 
				*ngFor="let item of items.SUB_SECTIONS;let k=index; trackBy:trackByFuntion" 
				cdkDrag [cdkDragData]="item"   style="background:#000;"  [cdkDragDisabled]="tempInfo?.PCA_INDICATOR.indexOf('frm')>-1">
					<a [id]="item.id+'list'" class="dropdown-item listItem" href="javascript:void(0)" [ngClass]="{'active':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}" (click)="getListPosition(item, $event,i,j,k);selectedRow=-1;selectedCell=null">
					<!--<app-editable [text]="item.SECTION_TITLE" (edited)="changeTitle('content',$event,i, j, k)"></app-editable>-->
						<label style="max-width: 70%; white-space: normal;color:white; pointer-events: none;"> . . {{item.SECTION_SEQUENCE}} {{item.SECTION_TITLE}}</label>
						<i *ngIf="item.TYPE=='4099e'||item.TYPE=='frm1104'||item.TYPE=='frm1103'" class="btn-outline-dark btn-small fas fa-trash p-2 float-md-right" title="PCA Section can not be delete." style="color:#666; pointer-events:none"></i>
						<i *ngIf="item.TYPE!='4099e'&&item.TYPE!='frm1104'&&item.TYPE!='frm1103'" class="brn btn-outline-dark btn-small fas fa-trash p-2 float-md-right" (click)="removeSec('content',item,i, j, k)"  style="color:#F78181"></i>
						<app-edit-input class="float-md-right" [text]="item.SECTION_TITLE" (edited)="changeTitle('content',$event,i,j,k)"></app-edit-input>
						<!--<i class="brn btn-outline-dark btn-small fas fa-plus p-2" (click)="addChild(temp2,i, j, k)"></i>-->
					</a>
			</div>
		</div>
	</div>
</div>
</div>
	</div>
</div>
</div>
<div id="app" class="container tab-pane fade" style="padding:0" [style.pointer-events]="tableShow ? 'none' : 'auto'">
	<div class="fixContent1">	
	<div *ngIf="appendices" class="example-list dropdown-item listItem" style="font-weight:bold; background:#444;">
	<!--<app-editable [text]="appendices?.SECTION_TITLE" (edited)="changeTitle('app',$event)"></app-editable>-->
		<label style="max-width:50%;  white-space: normal;color:white;pointer-events: none;">{{appendices?.SECTION_TITLE}}</label>
		<a *ngIf="tempAppendices&&tempAppendices.SUB_SECTIONS.length>0" class="btn btn-outline-dark float-md-right pt-1 pb-1 " style="font-size:12px" (click)="op121.toggle($event);loading=false;">ERIS Suggests</a>
	     <i class="brn btn-outline-dark btn-small fas fa-plus p-2 float-md-right" (click)="addChild($event,'app','')"   style="color:#ccc"></i>
		<app-edit-input   class="float-md-right" [text]="appendices?.SECTION_TITLE" (edited)="changeTitle('app',$event)"></app-edit-input>
		  <p-overlayPanel #op121 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="false" [style]="{width: '240px'}">
                <ng-template pTemplate>
					<ng-container *ngFor="let app of tempAppendices.SUB_SECTIONS;; trackBy:trackByFuntion">
						<div><label style="color:rgb(195,212,47) !important;font-size:11px !important;	padding-left:10px;">{{app.SECTION_TITLE}}</label>
							<i class="btn-outline-light btn-small fas fa-plus p-2" style="font-size:11px; float:right" (click)="addChild($event,'app',app)"></i>
						
						</div>
					</ng-container>					
				</ng-template>
            </p-overlayPanel>
			<br><label class="applabel"><input type="checkbox" name="printnodata" [checked]="printnodataforAppendix=='N'" (change)="noDataConfig($event)">Disable "No Data Available" Message</label>
		
	</div>

	<div *ngIf="appendices" cdkDropList class="example-list"  [cdkDropListData]="appendices.SUB_SECTIONS" (cdkDropListDropped)="dropApp($event)">
			<div cdkDropListGroup class="example-list" *ngFor="let item of appendices.SUB_SECTIONS;let i=index; trackBy:trackByFuntion" cdkDrag [cdkDragData]="item"  style="background:#444;">
					<a class="dropdown-item listItem" href="javascript:void(0)">. {{item.SECTION_SEQUENCE}}
					<!--<app-editable [text]="item.SECTION_TITLE" (edited)="changeTitle('app',$event,i)"></app-editable>-->
						<label style="max-width:65%; white-space: normal; color:white;pointer-events: none;">{{item.SECTION_TITLE}}</label>
						
						
						<i class="brn btn-outline-dark btn-small fas fa-trash p-2  float-md-right" (click)="removeSec('app',item,i)" style="color:#F78181"></i>
						<i class=" btn-outline-dark btn-small fas fa-cog p-2 mr-1 float-md-right" (click)="op30.toggle($event)"  style="color:#ccc"></i>
						
						<i class="brn btn-outline-dark btn-small fas fa-plus p-2  float-md-right" (click)="addPdfs($event, i)" style="color:#ccc"></i>
						<app-edit-input  class="float-md-right" [text]="item.SECTION_TITLE" (edited)="changeTitle('app',$event,i)"></app-edit-input>
						<label style="max-width:65%; white-space: normal; color:white;pointer-events: none;" *ngIf='item.app'>( {{item?.app?.name}}{{item?.app?.text}} )</label>
						<p-overlayPanel #op30 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '300px'}">
                            <ng-template pTemplate>
                                <div style="width: 280px; margin: 10px; padding-right:0; color:#C2D63F;max-height:60vh"> 
									<span style="font-size:.8em;margin-right: 4px;"><input type="checkbox" [(ngModel)]='item.omit'/>Omit Appendix from Report<i class="fas fa-info-circle iconBtn" title="This appendix will not print in the report PDF."></i></span><br>
									<span style="font-size:.8em;margin-right: 4px"><input type="checkbox" [(ngModel)]='item["resume"]' (click)="resumeSec($event, item)"/>Set as Resume Section<i class="fas fa-info-circle iconBtn" title="This section will only for resume files."></i></span>
								</div>
                            </ng-template>
                        </p-overlayPanel>
						<i *ngIf='item["resume"]' title="Resume Section" class="brn btn-outline-dark btn-small pt-0 pl-2 pr-2 mr-2 float-md-right" style="color:#C2D63F; font-weight: bolder; font-size: 14px;">R</i>
					</a>	
					<div class="example-list"  cdkDropList [cdkDropListData]="item.RF" (cdkDropListDropped)="dropItem($event)"  style="background:#000;clear: right">
						<div  cdkDrag [cdkDragData]="pdfs" class="example-box" *ngFor="let pdfs of item.RF;let k=index; trackBy:trackByFuntion" style="background:#444;">
							<a class="dropdown-item listItem" href="javascript:void(0)"> 
								<ng-select *ngIf='pdfSlots?.length>0' class="rptInfo ml-4 float-md-left" style="width:80%" [ngModel]="appendices.SUB_SECTIONS[i].RF? appendices.SUB_SECTIONS[i].RF[k].KEY:''" [clearable]="false"	[ngModelOptions]="{standalone: true}" (change)='addPdf($event, i, k)' (click)="getTableSlots('File')">
									<ng-option *ngFor="let pdf of pdfSlots;let j = index; trackBy:trackByFuntion" [value]='j'>{{pdf.KEY}} <span *ngIf="pdf.ERIS_FILE=='Y'" style="color:#C2D63F">( ERIS )</span></ng-option>
								</ng-select>  
								<i class="brn btn-outline-dark btn-small fas fa-trash p-2  float-md-right" (click)="removePdf(i, k)"  style="color:#F78181"></i>
								
							</a>
	
						</div>
					</div>

			</div>
		</div>
		</div>
</div>
<div id="slot" class="container tab-pane fade" style="padding:0">
	<div *ngIf="slotGroup=='S'">
	<label class="group-title">Selection Slots</label>
		<p-table [value]="selSlots" [paginator]="false" [globalFilterFields]="['KEY','CONTENT']"  (onFilter)="onFilter($event, dt1)">
				<!--<ng-template pTemplate="header" let-columns>
					<tr>
						<th>
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="20" placeholder="Filter" (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width:auto">
			
						</th>
					</tr>		
				</ng-template>-->
				<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.KEY">
						<td style="background-color:rgb(28, 36, 51)">
							<div  *ngIf="rowData.STATUS=='Active'" class="card"> 						
								<div class="row"  style="width:100%">
									<label style="width:85%; margin-top:8px;margin-left:16px;color:rgb(195,212,47)">{{rowData.KEY}}<span style="color:#04B486; margin:0 2px">({{rowData.TYPE}})</span></label>
									<a *ngIf="rowData.CONTENT.length>0" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i></a>					
									<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('choice', rowData)"><i *ngIf="addLib" class="fas fa-arrow-right"></i></a>	
									</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
									<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{rowData.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{rowData.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{rowData.TYPE}}</span><br>
														<div *ngIf="rowData.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="rowData.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="rowData.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
														
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span  style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>														
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
															
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	
	</div>
	<div *ngIf="slotGroup!='S'" class="fixTable">
	<p-table #tb [columns]="cols2" [value]="groupSlots" dataKey="CATEGORY" sortMode="single" [expandedRowKeys]="expandedRows"><!-- (onPage)="onPage($event)" (onRowExpand)="onRowExpand()" (onRowCollapse)="onRowCollapse()"-->
    <ng-template pTemplate="caption">
	<div style="display:inline-block">
		<a style="cursor: pointer;font-size: 16px; color:rgb(195,212,47);" (click)="expandAll()">
			<i *ngIf="!isExpanded" class="fas fa-angle-double-right"></i>
			<i *ngIf="isExpanded" class="fas fa-angle-double-down"></i>
		</a>
		<i class="pi pi-refresh" style="margin:4px 4px 0 20px" pTooltip="Reload Repeat Fields" (click)='refreshSlots()'></i>

	</div>
        <div style="float: right; display:inline-block">        
            
            <input type="text" pInputText size="10" placeholder="Filter" (change)="filterSlot($event)" style="width:auto">
			<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterSlot($event)'></i>
			<a style="cursor: pointer; font-size: 16px;" (click)="op2.toggle($event);" title="Add Repeat Field">
                                                <i class="pi pi-plus" style="margin: 5px;"></i>
                                            </a>
                        
                                            <p-overlayPanel #op2 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '500px'}" (onShow)="resetNewSlot()">
                                                <ng-template pTemplate>
                                                    <div style="width: 440px; margin: 10px; padding-right:0; color:#C2D63F;"> 
													<h6>Add Repeat Field</h6>
													<hr>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0 ">Title:<span style="font-weight:bold" [ngStyle]="{'color':newSlotLabel.trim()=== '' ? 'red' : 'white' }">*</span>
													</label>
														
														<input class="col-md-8 ml-0" type="text" [(ngModel)]='newSlotLabel'/>
														
													</div>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0">Category :<span style="font-weight:bold" [ngStyle]="{'color':newSlotCat.trim()=== '' ? 'red' : 'white' }">*</span>
														 </label>
														<input type='text' class="col-md-7" [(ngModel)]='newSlotCat'>
														<select class="col-md-1  ml-0" [(ngModel)]='newSlotCat'  (mousedown)="getSlotPara()">
															<ng-container *ngFor="let cat of slotCategories; trackBy:trackByFuntion">
																<option [value]="cat.CATEGORY">{{cat.CATEGORY}}</option>				
															</ng-container>
														</select>
														
													</div>
													<div class="row p-1" style="font-size:.9em">
														<label class="col-md-3  ml-0">Type :<span style="font-weight:bold" [ngStyle]="{'color':newSlotType=== '' ? 'red' : 'white' }">*</span>
														 </label>
														<select [ngClass]="newSlotType=='Selection'? 'col-md-4':'col-md-8'" [(ngModel)]='newSlotType'>
															<ng-container *ngFor="let type of slotTypes">
																<option [value]="type.SLOT_TYPE"><label class="mr-2">{{type.SLOT_TYPE}}</label></option>				
															</ng-container>
														</select>
														<select *ngIf="newSlotType=='Selection'" class="col-md-4" [(ngModel)]='newSlotMultiple' style="padding-left:0">
															<option value="N">Single Choice</option>
															<option value="Y">Multiple Choice</option>																
														</select>
														
													</div>
													<div class="row p-1" style="font-size:.9em; max-height:300px">
														<label class="col-md-3  ml-0">Content: 	</label>
														<textarea *ngIf="newSlotType!='Selection'&&newSlotType!='File'" class="col-md-8  ml-0" rows="10" [(ngModel)]='newSlotContent'></textarea>
														<input *ngIf="newSlotType=='Selection'" class="col-md-7  mt-1" [(ngModel)]='newSlotOp'>
														<a href="javascript:void(0)" *ngIf="newSlotType=='Selection'" class="col-md-1 ml-0 mt-1 mr-0 slotBtn" (click)="addOpItem($event)"><i class="fas fa-plus"></i></a>
														<!--<a href="javascript:void(0)" class="ml-0 btn btn-link btn-sm slotBtn" title="Create Repeat Field" data-target='#libraryModal' data-toggle="modal" (click)="libToSlot=true;filteredData=null">
															LIB
														</a>-->
														<ng-container *ngIf="newSlotType=='File'">
															<button  class="btn btn-outline-light btn-op ml-0 mr-2" (click)="upload('slot')">Upload File</button>
															<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
															<br>
															<a [href]="newSlotFile.url"  style="margin-left:25%; width:70%; word-break: break-all;" target=_black>{{newSlotFile.name}}</a>															
																												
														</ng-container>
														<label class="col-md-3  ml-0"></label>
														<button  *ngIf="newSlotType!='Selection'&&newSlotType!='File'" class="btn btn-outline-light rf-btn m-1  slotBtn" data-target='#libraryModal' data-toggle="modal" (click)="checkLib();libToSlot=true;filteredData=null">Libraries</button>		
														<ng-container *ngIf="newSlotType=='Selection'&&newSlotOps.length>0">
															<div  class="selInput col-md-12" style="max-height:300px; overflow:auto; font-size:.9em; border:1px solid gray; padding:0; margin:4px; width:90%">
																<ng-container *ngFor="let item of newSlotOps; let i=index; trackBy:trackByFuntion">
																	<div class="row" style="width:100%; margin:4px 0; padding:0"><label class="col-md-10 ml-1 mb-0">. {{item}}</label>
																	<span class="small"><i class="fas fa-arrow-up float-right"  title="Move Up" (click)="selUp(i)"></i></span>
																	<span class="small"><i class="fas fa-arrow-down float-right" title="Move Down" (click)="selDown(i)"></i></span>
																	<span class="small"><i class="far fa-trash-alt float-right"  title="Remove" (click)="selRemove(i)"></i></span>
																	</div>
																</ng-container>
															</div>
															<!--<a href="javascript:void(0)" (click)="clearOpItem()">Clear</a>-->
														</ng-container>
														 <!--<a style="cursor: pointer; font-size: 16px;" title="Add Tag" (click)='op2.hide();'>op2.hide();
                                                            <i class="pi pi-plus-circle" style="margin: 5px;"></i>
                                                        </a>-->
														</div>
														<label *ngIf="missingSlot==true" style="color: red; width:100%; font-size:.8em">&nbsp;{{missingSlotMessage}}</label>
														
														<button type="button"  class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createSlot($event, op2);">Save</button>
														<button type="button"  class="btn btn-outline-light btn-sm float-md-right m-4"  (click)="createSlot($event);">Save and Create New</button>
			                                           
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
		</div>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr style="font-size:12px"><!-- [pSelectableRow]="rowData" -->
            <td style="background-color:rgb(28, 36, 51)">
                <a href="#" [pRowToggler]="rowData">
                    <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                </a>
            </td>
            <td *ngFor="let col of columns; trackBy:trackByFuntion"  style="padding:6px;background-color:rgb(28, 36, 51)"  [ngStyle]="{'width': col.width}">
				<ng-container *ngIf="col.field=='CATEGORY'">
					{{rowData[col.field]}}
					<span *ngIf="rowData.TOTAL_SLOTS">( {{ rowData.TOTAL_TEMPLATE_SLOTS}} /{{rowData.TOTAL_SLOTS}}  )</span>
					<a href="javascript:void(0)" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 ml-1" title="Check All"  style="float:right; font-size:.9em;color:rgb(195,212,47)" [ngStyle]="{'color':rowData.RW_SLOTS.length>0?'white':'rgb(195,212,47)'}" (click)="slotChkToggle(rowData)">
						Check All
					</a>
				</ng-container>               
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="cols3">
        <tr>
            
				<td [attr.colspan]="cols2.length + 1" style="padding:0 20px;background-color:rgb(28, 36, 51)">
				<ng-container *ngFor="let r of rowData.RW_TEMPLATE_SLOTS">
					<div *ngIf="r.STATUS=='Active'" class="card" style="margin:10px 0; "> 
						<div class="row"  style="width:100%; padding:0 0 0 16px;">
						<label style="width:85%; margin-top:8px;color:rgb(195,212,47)">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i>
							<span *ngIf="r.STATUS!='Active'" class="inaciveMsg">{{r.STATUS}}</span></label>
							<input *ngIf="curTemp?.TEMPLATE_ID" style="width:5%; margin-top:8px" type="checkbox" [checked]="r.TEMPLATE_IND=='Y'" (change)="addSlotToTemp($event, r, rowData.CATEGORY)"/>
							<a *ngIf="r.CONTENT.length>0&&r.TYPE!='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op10.toggle($event);"><i class="fas fa-eye"></i></a>					
							<a *ngIf="r.SELECTION_CHOICES.length>0&&r.TYPE=='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op10.toggle($event);"><i class="far fa-list-alt"></i></a>
							<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px" class="btn btn-link btn-sm pt-0 pb-0 pl-1 pr-1" title="Delete Item" (click)="deleteSlot(r, rowData)"><i class="far fa-trash-alt"></i></a>-->					
							<a *ngIf="addLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'"  href="javascript:void(0)" style="width:5%; line-height: 20px;vertical-align: middle; float:right" (click)="addRepeat('slot', r)"><i class="fas fa-arrow-right"></i></a>	
							<a *ngIf="newLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', r)"><i class="fas fa-arrow-right"></i></a>
							</div>
							<span style="color:white">{{r.SHORT_CONTENT}}</span>
							<p-overlayPanel #op10 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<!--<hr>
														<strong>Content :</strong>
														<span *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">{{r.CONTENT}}</span>-->
														<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong   *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content : </strong> 
														<span  *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')&&(r.TYPE!='File')" style="color:white">{{r.CONTENT}}</span><br>
														<a *ngIf="r.TYPE=='File'" [href]="r.CONTENT" target=_blank style="color:#C2D63F; width:100%; word-break:break-all">{{r.FILE_NAME}}</a>	
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="r.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="r.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
														
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="width:90%; border: 1px solid black;  border-collapse: collapse; color:white">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index; trackBy:trackByFuntion">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
										
										
					</div>
				</ng-container>
				<ng-container *ngFor="let r of rowData.RW_SLOTS">
					<div  *ngIf="r.STATUS=='Active'" class="card" style="margin:10px 0; "> 
						<div class="row"  style="width:100%; padding:0 0 0 16px;">
							<label style="width:85%; margin-top:8px;color:rgb(195,212,47)">{{r.KEY}}<span style="color:#04B486; margin:0 2px">({{r.TYPE}})</span>
							<i *ngIf="r.SYSTEM_IND=='Y'" class="fas fa-globe"></i>
							<i *ngIf="r.SYSTEM_IND=='N'" class="fas fa-cog"></i>
							<span *ngIf="r.STATUS!='Active'" class="inaciveMsg">{{r.STATUS}}</span></label>
							<input *ngIf="curTemp?.TEMPLATE_ID" style="width:5%; margin-top:8px" type="checkbox" [disabled]="r.STATUS!='Active'" [checked]="r.TEMPLATE_IND=='Y'" (change)="addSlotToTemp($event, r, rowData.CATEGORY)"/>
							<a *ngIf="r.CONTENT.length>0&&r.TYPE!='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op11.toggle($event);"><i class="fas fa-eye"></i></a>
							<a *ngIf="r.SELECTION_CHOICES.length>0&&r.TYPE=='Selection'" href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Content" (click)="op11.toggle($event);"><i class="far fa-list-alt"></i></a>
							<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px" class="btn btn-link btn-sm pt-0 pb-0 pl-1 pr-1" title="Delete Item" (click)="deleteSlot(r, rowData)"><i class="far fa-trash-alt"></i></a>-->					
							<a *ngIf="addLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('slot', r, rowData.CATEGORY)"><i class="fas fa-arrow-right"></i></a>
							<a *ngIf="newLib&&r.TYPE!='Table'&&r.TYPE!='PDF'&&r.TYPE!='File'&&r.STATUS=='Active'"  href="javascript:void(0)" style="width:5%;  float:right" (click)="addRepeat('newLib', r, rowData.CATEGORY)"><i class="fas fa-arrow-right"></i></a>		
							</div>
							<span style="color:white">{{r.SHORT_CONTENT}}</span>
						<p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(r)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{r.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{r.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{r.TYPE}}</span><br>
														<strong   *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">Content : </strong> 
														<span  *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')&&(r.TYPE!='File')" style="color:white">{{r.CONTENT}}</span><br>
														<a *ngIf="r.TYPE=='File'" [href]="r.CONTENT" target=_blank style="color:#C2D63F; width:100%; word-break:break-all">{{r.FILE_NAME}}</a>	
														<!--<strong>Content :</strong>
														<span *ngIf="(r.TYPE!='Table')&&(r.TYPE!='Selection')">{{r.CONTENT}}</span>-->
														<div *ngIf="r.TYPE=='Selection'">
															<strong>Options</strong>
															<span *ngIf="r.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Selection )</span><span *ngIf="r.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Selection ) </span><br>
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>
														<div *ngIf="r.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="width:90%; border: 1px solid black;  border-collapse: collapse; color:white">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index; trackBy:trackByFuntion">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
											
										
					</div>
				</ng-container>
				
            </td>
           
        </tr>
    </ng-template>
</p-table>
	</div>
</div>
<div id="lib" class="container tab-pane fade" style="padding:0; color:white">
	<div class="fixTable">
	<p-table #dt2 [value]="libraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']"  (onFilter)="onFilter($event, dt2)">
				<!--<ng-template pTemplate="caption">
					<div style="text-align: right">        
						<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
						<input type="text" pInputText size="20" placeholder="Filter" (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width:auto">
			
					</div>
				</ng-template>-->
				<ng-template pTemplate="caption">
					
						<div style="display:inline-block; padding:0">   
							<!--<p-dropdown [options]="libLabels"  placeholder="Identifier" [style]="{'width':'70px','minWidth':'50px', 'minHeight':'26px', 'height':'30px'}" (onChange)="dt2.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>-->
						<select style="margin-bottom:2px;margin-top:4px; width:90px;min-width:50px;  padding:0;font-size:14px; background-color:rgb(28, 36, 51); color:#ccc" (change)="filterLibs($event)">
						<option value="">Identifier
						</option>
						<ng-container *ngFor="let label of libLabels">
						<option [value]="label.value">{{label.value}}
						</option>
						</ng-container>
						</select>
						
						</div>
						<div style="float: right; display:inline-block">
							<i class="pi pi-refresh" style="margin-right: 20px " pTooltip="Reload Libraries" (click)='refreshLibs()'></i>
							<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47)"></span>								
							<input type="text" pInputText size="10" placeholder="Filter" (change)="filterLibs($event)" style="width:auto">
							<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterLibs($event)'></i>							
							<a href="javascript:void(0)" style="cursor: pointer; font-size: 16px;" title="Add Libraries" (click)="toNewLib();"><!--data-toggle="modal" data-target="#createLibModal" -->
                                                <i class="pi pi-plus" style="margin: 5px;"></i>
                            </a>
                        
						</div>
	
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.STATUS=='Active'">
						<td style="background-color:rgb(28, 36, 51)">
							<div class="card" [ngClass]="{'active':addedLibs.indexOf(rowData.LIBRARY_ID)>-1}"> 						
								<div class="row">
								<p style="width:75%; margin-left:16px;color:rgb(195,212,47);">{{rowData.ITEM_TITLE}} <span *ngIf="rowData.STATUS!='Active'" class="inaciveMsg">({{rowData.STATUS}})</span></p>
								<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op1.toggle($event);"><i class="fas fa-eye"></i></a>					
								<!--<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right"  title="Delete Library" (click)="deleteLib(rowData)"><i class="fas fa-trash"></i></a>-->		
								<a *ngIf="addLib&&rowData.STATUS=='Active'"  href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('lib', rowData)" title="Add library to Defined"><i class="fas fa-arrow-right"></i></a>
								<a *ngIf="addLib&&rowData.STATUS=='Active'"  href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('lib', rowData, 'topara')" title="Add library to Defined and content"><i class="fas fa-angle-double-right"></i></a>
							</div>
								<span>{{rowData.SHORT_CONTENT}}</span>
								
								<p-overlayPanel #op1 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '600px'}" (onShow)="getSftContent(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<h6>{{rowData.ITEM_TITLE}}</h6>
													<ng-container *ngFor="let label of rowData.LABELS.split(';'); trackBy:trackByFuntion">
														<label class="tag">{{label}}</label>
													</ng-container>
													<div>
														<strong>Instruction: </strong>
														<span style="color:white">{{rowData.INSTRUCTIONS}}</span>
													</div>
													<div>
														<strong>Content: </strong>
														<span *ngIf="!rowData.CONTENT_HTML||rowData.CONTENT_HTML.length==0" style="color:white">{{rowData.CONTENT}}</span>
														<div *ngIf="rowData.CONTENT_HTML&&rowData.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="rowData.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
													</div>
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
							</div>
										
						</td>
					</tr>            
				</ng-template>
	
			</p-table>
	</div>
</div>
<div  *ngIf="tempInfo?.PCA_INDICATOR=='Y'||tempInfo?.PCA_INDICATOR=='4099e'||tempInfo?.PCA_INDICATOR=='frm1105'" id="pca" class="container tab-pane fade" style="padding:0;">
	<div class="pca">
		<label>Short Term</label>
		<select [(ngModel)]="pcaOp.term" (change)="setCostTableTitle()">
			<option>Include</option>
			<option *ngIf="tempInfo.PCA_INDICATOR!='4099e'">Exclude</option>
		</select>
		<label>Cost Table Multiplier</label>
		<select [(ngModel)]="pcaOp.multiplier" (change)="changeOpItem()">
			<option></option>
			<option *ngFor="let item of multipliers; trackBy:trackByFuntion" [value]="item.LABEL">{{item.LABEL}}</option>
		</select>
		<label>Quantity for Cost Table Multiplier</label>
		<input disabled min="0" max="1000000000" type="number"/>
		<label>Reserve Term</label>
		<input *ngIf="tempInfo?.PCA_INDICATOR!='4099e'" [disabled]="tempInfo?.PCA_INDICATOR=='frm1105'" [(ngModel)]="pcaOp.reserve" min="1" max="30" type="number" (blur)="changeFactor(pcaOp.reserve, 'reserve')" (change)="changeOpItem()"/>
		<input *ngIf="tempInfo?.PCA_INDICATOR=='4099e'" [(ngModel)]="pcaOp.reserve" min="1" max="15" title="usually 10 or 12" type="number" (blur)="changeFactor(pcaOp.reserve, 'reserve')" (change)="changeOpItem()"/>
		<label>Effective Age of Property</label>
		<input disabled min="0" max="1000" type="number"/>
		<hr class="line mt-4 mb-4">
		<label>Display Decimal Places</label>
		<select  [(ngModel)]="pcaOp.decimal">
		<option *ngIf="tempInfo.PCA_INDICATOR!='4099e'">0</option>
		<option>2</option>
		</select>		
		<label>Round Options</label>
		<select  [(ngModel)]="pcaOp.round">
		<option>Round</option>
		<option>Round Up</option>
		<option>Round Down</option>
		</select>
		<hr class="line mt-4 mb-4">
		<label>Currency to be used for Calculations</label>
		<select  [(ngModel)]="pcaOp.currency">
			<option *ngFor="let item of currencies; trackBy:trackByFuntion" [value]="item.CURRENCY">{{item.CURRENCY}}</option>
		</select>
		<label>Inflation Rate</label>
		<select [(ngModel)]="pcaOp.inflation" [disabled]="tempInfo.PCA_INDICATOR=='frm1105'" (change)="changeOpItem()">
		<option *ngIf="tempInfo.PCA_INDICATOR!='4099e'" value="2.5">2.5%</option>
		<option value="3">3%</option>
		</select>
	</div>
	
	<div>	
	<!--<p-table #dt4 [value]="pcaLibraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','IDENTIFIERS']">
				<ng-template pTemplate="caption">
						<div style="float: right; display:inline-block">   
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="10" placeholder="Filter" (input)="dt4.filterGlobal($event.target.value, 'contains')" style="width:auto">
						</div>					
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr>
						<td>
							<div class="card"> 						
								<div class="row">
								<p style="width:75%; margin-left:16px;color:rgb(195,212,47);">{{rowData.ITEM_TITLE}}</p>
								<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op14.toggle($event);"><i class="fas fa-eye"></i></a>					
								<a *ngIf="addLib"  href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('lib', rowData)"><i class="fas fa-arrow-right"></i></a>
								</div>
								<span>Cost: {{rowData.COST}}</span>
								<p-overlayPanel #op14 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '340px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<ng-container *ngFor="let label of rowData.IDENTIFIERS.split(';')">
												<label class="tag">{{label}}</label>
											</ng-container>
											<div>
												<strong>Cost: </strong> <span style="color:white">{{rowData.COST}}</span><br>
												<strong>EUL: </strong> <span style="color:white">{{rowData.EUL}}</span><br>
												<strong>Unit: </strong> <span style="color:white">{{rowData.UNIT}}</span><br>
											</div>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
							</div>
										
						</td>
					</tr>            
				</ng-template>
	
			</p-table>-->
	</div>
</div>
</div>
	
	
</div>
<div class="col-md-7 editContainer">

<div class="tool sticky-top">
<button class="btn btn-black btn-sm mr-1" title="Portrait" [ngStyle]="{'border':selectpage.type==='portrait'? '1px solid yellow':'none'}" (click)="selectPage('portrait')"><i class="fas fa-arrows-alt-v"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Landscape" [ngStyle]="{'border':selectpage.type==='landscape'? '1px solid yellow':'none'}" (click)="selectPage('landscape')"><i class="fas fa-arrows-alt-h"></i>
</button>
<button class="btn btn-black btn-sm mr-1" title="Margin" data-target='#marginModal' data-toggle="modal"><i class="fas fa-arrows-alt"></i>
</button>
<lable class="toplabel">Template Edits will reflect/update future reports set up with this template.</lable>
<a title='Find & Replace' class="ml-3 spellIcon" [ngClass]="{'spellOn':replaceShow,'spellOff':!replaceShow}" (click)="replaceToggle()"><i class="fas fa-search"></i></a>
<!--<a title='Turn On/Off Spelling Check' class="mr-2 ml-2 spellIcon" [ngClass]="{'spellOn':checkOn,'spellOff':!checkOn}" (click)="spellCheck()"><img style='height:24px; width:18px' src="/assets/images/spell-check.svg"></a>-->
<a title='Spell Check Whole Template Excludes !@#$%^&*()+=\[\]{}:\\|<>\/?~.' class="mr-2 ml-2 spellIcon1 spellOn" [ngClass]="{'spellOn':checkOnAll,'spellOff':!checkOnAll}"  (click)="spellCheckAll()"><img style='height:24px; width:24px' src="/assets/images/spell-check.png"></a>
<a *ngIf="companyGroupIndicator" title='Group Information' class="ml-1 btn btn-black btn-sm groupBtn" (click)="getTempGroup(); groupShow=!groupShow">G</a>

</div>



<a class="sticky-right btn btn-outline-success btn-sm" title="Save Template" (click)="saveTemplate()"><i class="far fa-save"></i>
</a>
<div class="pageContainer">

<div *ngIf="tempInfo"  class="example-list"  #viewer [style.padding-top.px]="pageMargin.top" [style.padding-bottom.px]="pageMargin.bottom" [style.padding-left.px]="pageMargin.left" [style.padding-right.px]="pageMargin.right" [style.width.px]="selectpage.size.width"  [style.min-height.px]="selectpage.size.height"><!-- [style.height.px]="selectpage.size.height"-->
	<div *ngIf="matchShow" class="lib-box2" cdkDrag>
		<!--<i class="iconBtn far fa-window-close mr-3 mt-0 float-right" style="float:right" (click)="matchShow=false;"></i>-->
		<span *ngIf="!checking&&allMatch>0" class="spellmsg">Spelling Errors Underlined Below in Red</span>
		<span *ngIf="!checking&&allMatch==0" class="spellmsg1">Spelling Check Complete - No Errors Found</span>
		<span *ngIf="checking" class="spellmsg1">Spell Check is Currently Running</span> 
		<span *ngIf="checking" class="fa fa-spinner fa-spin ml-2" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span>
	</div>
	<div *ngIf="groupShow" id="lib-box1" class="lib-box1" cdkDrag [cdkDragDisabled]="dragDisabled">
		<label class="popheader ml-1">Group Information</label>
		<i class="iconBtn far fa-window-close mr-3 mt-2 float-right" style="float:right" (click)="groupShow=false;"></i>
		<hr class="line1">
		<div style="width: 350px;padding: 0 10px;">
			<label class="applabel">Group<span [ngStyle]="{'color':groupList.length==0 ? 'red' : 'white' }">*</span></label>
			<label class="savedLabel"><input type="checkbox" class="ml-3" [disabled]="!groupEditPermission" [(ngModel)]="groupAll" (change)="setGroupList($event, 'all')">Select All</label>
			<label class="savedLabel ml-3"><input type="checkbox" [disabled]="!groupEditPermission" [(ngModel)]="groupNone" (change)="setGroupList($event, 'none')">Unselect  All</label><br>
			<!--<ng-select
				[items]="groups"
				[multiple]="true"
				bindLabel="GROUP_NAME"
				class="col-md-9 groupInfo"
				style="display: inline-block" 
				[closeOnSelect]="false"
				bindValue="GROUP_ID"
				[(ngModel)]="groupList"
				[ngModelOptions]="{standalone: true}">
				<ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
					<input [id]="item.GROUP_ID" type="checkbox" [ngModel]="item$.selected" /> {{ item.GROUP_NAME }}
				</ng-template>
			</ng-select>-->	
			<div style="width: 100%;max-height:300px; border: #C2D63F 1px solid;overflow: auto;">
				<ng-container *ngFor="let group of groups">
					<label class="savedLabel"><input type="checkbox" class="ml-1" [disabled]="!groupEditPermission||groupAll" [checked]="groupList.indexOf(group.GROUP_ID)>-1" (change)="setGroupList($event, group.GROUP_ID)"> {{group.GROUP_NAME}}</label><br>
				</ng-container>
			</div>			
		</div>
		<button *ngIf="(groupList.length>0||groupAll)&&groupEditPermission" class="btn btn-black btn-small toolBtn float-right mr-4" (click)="updateTempGroup()">Update</button>
		
	</div>
	<div *ngIf="replaceShow" id="lib-box1" class="lib-box1" cdkDrag [cdkDragDisabled]="dragDisabled">
		<i class="iconBtn far fa-window-close mr-3 mt-2 float-right" style="float:right" (click)="replaceShow=false;searchText=''"></i>
		<div  style="display: flex; flex-flow: row wrap; justify-content: start;">
			<!--<i (click)='replaceShow1=!replaceShow1;selectedCell=null; curId=null;' class="fas fas fa-angle-down iconBtn" title="To Replace"></i>-->
			<input type='search' width="260px" maxlength="100" placeholder="Find" style="width:150px;margin-left: 10px;" [(ngModel)]="searchText" (keydown)="curId=null; listid=null">
			<a title='Match Case' class="ml-3 spellIcon" [ngClass]="{'spellOn':caseOn,'spellOff':!caseOn}" (click)="caseOn=!caseOn"><img  style='height:24px; width:18px' src="/assets/images/case-sensitive.svg"></a>
			<a title='Find Next' class="btn btn-black btn-sm p-0 m-1" (click)="findNext()"><i class="fas fa-arrow-down fa-sm"></i></a>
			<a title='Find Previous' class="btn btn-black btn-sm p-0 m-1" (click)="findPrev()"><i class="fas fa-arrow-up fa-sm"></i></a>			
		</div>
		<div style="display: flex; flex-flow: row wrap; justify-content: start;">
			<input type='search' width="260px" maxlength="100" placeholder="Replace" style="width:150px; margin-left: 10px;" [(ngModel)]="replaceText" (keydown)="curId=null; listid=null">
			<button class="btn btn-black btn-small ml-3 toolBtn p-1" (click)="replaceSingle()">Replace</button>
			<button class="btn btn-black btn-small ml-3 toolBtn p-1" (click)="replaceAllText()">Replace All</button>
			<span *ngIf="replacing" class="fa fa-spinner fa-spin ml-2" style="color:rgb(195,212,47);"></span>
		</div>
	</div>
	<div *ngIf="addLibShow" id="lib-box" class="lib-box" cdkDrag [cdkDragDisabled]="dragDisabled">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.9em"> 
			<div style="width: 500px; margin: 10px; padding-right:0; color:white;"> 
														<h6>Add Library</h6>
														<hr>
														<label class="col-md-3">Title: </label>
														<input class="col-md-7 ml-2" type="text" id="libTitle" /><span style="color:red">*</span>
														<br>
														<label class="col-md-3">Identifier: <i class="fas fa-info-circle iconBtn" (click)="op302.toggle($event)"></i>
														</label>
														<input type="text" class="col-md-7  ml-2" id="libLabel" placeholder="separate your identifier by ;"/>
														<button (click)="getLibLabels(); op301.toggle($event);"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
														<i class="fas fa-plus iconBtn" (click)="addLabel($event)"></i>
														<p-overlayPanel #op301 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
															<ng-template pTemplate>
																<div style="margin:0; max-height:400px; padding:4px; width:220px; overflow:auto">
																	<ng-container *ngFor="let label of libLabels; trackBy: trackByFuntion">
																		<div class="listItem2" style="margin:0; width:180px; border:1px ridge black" >
																			<a href="javascript:void(0)" style="color:rgb(195,212,47); font-size:.8em; margin:2px" (click)="addToIden(label.label, 'libLabel')">{{label.label}}</a><br>
																		</div>
																	</ng-container>
																</div>																
															</ng-template>
														</p-overlayPanel>
														<p-overlayPanel #op302 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '420px'}">
															<ng-template pTemplate>
																<div style="max-height:400px; padding:0; width:380px; overflow:auto;">
																	<ul>
																		<li class="instr">You may select multiple Identifiers from the dropdown list.</li>
																		<li class="instr">If the Identifier required is not in the dropdown list, you may create a new one by typing it into the “Identifier” field (under the “Title” field).</li>
																	</ul>
																</div>																
															</ng-template>
														</p-overlayPanel>
														<div  class="col-md-2"></div>
														<div class="col-md-9 ml-2">
															<ng-container *ngFor="let label of inputLabels.split(';') let i=index; trackBy:trackByFuntion">
																<label *ngIf="label.trim().length>0" class="tag">{{label}}<i class="fas fa-times iconBtn" (click)='removeLabel(i)'></i></label>
															</ng-container>
														</div>
														<label class="col-md-5">Instruction: </label>
														<div class="ml-3 mr-4 ckContainer"   style="min-height:150px; max-height:200px; overflow-y:auto; cursor:auto">
															<app-paragraph [srcViewer]="'N'" [editorType]="'lite'" [content]="newLibPara[4]" (outText)="libPara($event, 0)"  (onExit)="libPara($event, 1)"  (mouseleave)='dragDisabled=false' (mouseenter)="dragDisabled=true"></app-paragraph>
														</div>
														<label class="col-md-2">Content: </label>
														<div class="ml-3 mr-4 ckContainer"  style="min-height:150px; max-height:250px; overflow:auto; cursor:auto">
															<app-paragraph [srcViewer]="'Y'" [editorType]="'lite'" [content]="newLibPara[5]" [addedSlot]="addedItem" (outText)="libPara($event, 2)" [getText]="itemIndex" (onExit)="libPara($event, 3)"  (mouseleave)='dragDisabled=false' (mouseenter)="dragDisabled=true;"></app-paragraph>
														</div>
														<button  class="btn btn-outline-light rf-btn ml-1" (click)="showSlots(); addSlotPrep('new') ">Repeat Fields</button>		
																												
														
														<span *ngIf="addLibWarn" style="color:red">* Title not valid</span>	
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createLibrary($event, 'new');">Save</button>
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createLibrary($event);">Save and Create New</button>				                                           
														<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="addLibShow=false">Cancel</button>															
								
												   </div>
		</div>					
	</div>
	<div *ngIf="headerShow" id="task-box" class="task-box1"  style="width:710px" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;"> 
		<label>Header Content</label>
		<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="headerShow=false; closeCol()"></i>
		<div *ngIf="curSec" class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto">
			<app-paragraph class="docItem"  [editorType]="'temp'" [content]="curCol.NAME"  [getText]="curSec['reqIndex']" (onExit)='colData($event, curSec.id)' (outText)="colText($event)"></app-paragraph> <!--(outHtml)="getPosition($event,i);textData($event)"-->
			
		</div>
		<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCol(curSec.id);headerShow=false">Save</button>
	</div>					
	</div>
	<div *ngIf="moveShow" id="task-box" class="task-box1"  style="width:210px" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;"> 
			<label>Move Section To</label>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="moveShow=false;"></i>
			<div style="min-height:160px; max-height:250px; overflow:auto; cursor:auto">
				<span style="font-size:.9em;">Current Position: </span>
				<span class="ml-2">{{curIndex[0]+1}}</span>
				<span *ngIf='curIndex[1]>-1' class="ml-2">{{curIndex[1]+1}}</span>
				<span *ngIf='curIndex[2]>-1' class="ml-2">{{curIndex[2]+1}}</span><br>
				<p style="margin-left: 10px;color:white; font-weight: bold;">{{tomoveTitle}}</p><br>
				<span style="font-size:.8em;">Move To: </span>
				<input type="number" class="moveIndex" [(ngModel)]="toIndex[0]" min="1" max="1000" (mouseenter)='intext=true' (mouseleave)='intext=false'>
				<input type="number" [disabled]='!(curIndex[1]>-1)' class="moveIndex" [(ngModel)]="toIndex[1]" min="1" max="1000" (mouseenter)='intext=true' (mouseleave)='intext=false'>
				<input type="number"  [disabled]='!(curIndex[2]>-1)' class="moveIndex" [(ngModel)]="toIndex[2]" min="0" max="1000" (mouseenter)='intext=true' (mouseleave)='intext=false'>
	
			</div>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="moveTo(curSec.id);moveShow=false">Move</button>		
		</div>					
	</div>
	<div *ngIf="cellShow" id="task-box" class="task-box1"  style="width:710px" cdkDrag [cdkDragDisabled]="intext">
	<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
		<label>Cell Content</label>
		<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="cellShow=false; closeCell()"></i>
		<div class="cplabel" *ngIf="!curSec['tableClass']">
		<label>Background:</label>
		<input class="cpicker"				
       [style.background]="curCell.bkcolor"
       [(colorPicker)]="curCell.bkcolor"/>
	   <input type="checkbox" [(ngModel)]="allCol">Apply to Entire Column
	   <input type="checkbox" [(ngModel)]="allRow">Apply to Entire row
	  <!-- <label>Font Color:</label>
		<input class="cpicker" 
       [style.background]="curCell.fcolor"
       [(colorPicker)]="curCell.fcolor"/>
	   <input type="checkbox">Apply to Entire Column
	   <input type="checkbox">Apply to Entire row-->
	   <ng-container *ngIf="(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)">
			<a class="btnRound1" [ngStyle]="{'color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999','border-color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" style='float:none; margin-left: 60px;' (click)="op0.toggle($event)">Field Options</a>
								<p-overlayPanel #op0 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{'width': '340px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>Choose Field Value(s)</h6>
												<!--<input type="text" class="col-md-6" placeholder="Input your Domain here"/>
												<i class="fas fa-plus iconBtn" title="Add Item to Action" (click)="addDomainItem($event, item)"></i>-->
												<div *ngIf='curCol.FO&&curCol.FO.length>0' class="col-md-10">
													<ng-container *ngFor="let label of curCol.FO; let i=index; trackBy:trackByFuntion">
														<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(label)'></i></label><br>
													</ng-container>
												</div>							
												<ng-container *ngIf="curCol.DefaultFO&&curCol.DefaultFO.html">
													<p class="savedLabel">Default Value:</p>
													<div style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="curCol.DefaultFO.secHtml?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div><br>
													<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(curCol.DefaultFO)'></i>						
												</ng-container>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
	   </ng-container>
	   </div>

		<div *ngIf="curSec" class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto; width:100%">

			<app-paragraph [addedSlot]="curSec.addedItem" [editorType]="'temp'"  class="docItem"  [content]="curCell.htmltext"  [getText]="curSec['reqIndex']"  (selected)="selectedRow=-1;getPosition(curSec.id, $event);addLib=true;selectedEditor='C' " (onExit)='cellData($event, curSec.id)' (outText)="curCell.data=$event"></app-paragraph> <!--(outHtml)="getPosition($event,i);textData($event)"-->
			<button  [ngClass]="{'hasLibs':curCell.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;getPosition(curSec.id, $event);  filteredData=null;selectedRow=-1;showLibs(curCell);op63.toggle($event);">Libraries</button>
			<button  [ngClass]="{'hasLibs':curCell.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getPosition(curSec.id, $event); filteredData=null;selectedRow=-1;showSlots()">Repeat Fields</button>					
			<p-overlayPanel #op63 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
				<div *ngIf="curCell.libs"  cdkDropList [cdkDropListData]="curCell.libs" (cdkDropListDropped)="dropLib($event,curCell.libs )">
				<div *ngFor="let item of curCell.libs; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="item" class="libItem">
					<div class="listItem2">
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op631.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Delete" (click)="getPosition(curSec.id,$event);removeLib(item)"><i class="fas fa-trash" style='font-size:.8em'></i></a>
					</div>
					<p-overlayPanel #op631 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</div>
				</div>						
				</div>
				</ng-template>
			</p-overlayPanel>
		</div>
		<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCell(curSec.id);cellShow=false">Save</button>
		<!--<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="cellShow=false;curCell=null">Close Window</button>-->								
	</div>					
	</div>
	<div *ngIf="tableShow" id="task-box" class="task-box"  style="width:45vw;right:5vw; top:5vh; background: #4C4C4C;" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em;max-height: 90vh;position: relative;">
			<label>Table Content</label>
			<i #hotkeyIcon class="iconBtn fas fa-info-circle mt-2" style="float:right; margin-right: -16px;" (click)="op99.toggle($event)"></i>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="tableShow=false; curHeader=false; tableToolShow=false;customizedTablesave()"></i>
			<i class="iconBtn fas fa-toolbox mr-3 mt-2" style="color:white;float:right" title="Table Tools" (click)="tableToolShow=true"></i>
			<p-overlayPanel #op99 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
				<ng-template pTemplate>
					<div style="margin: 10px; color:#C2D63F;overflow:auto; font-size:11px"> 
						<h6>Hot Key:</h6>
						<div class="m-0 p-0 tableInfo" style="color: white;">
							<div style="padding-left: 4px; margin: 0;">
								<label>Navigation Before a Table Cell is Opened: </label>
								<ul>
									<li>
										Ctrl + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell.
									</li>
									<li>
										Ctrl + Enter key will <span>open Editor</span> with currrent cell content.
									</li>
									<li>							
										Ctrl + C key will <span>copy</span> currrent cell content.
									</li>
									<li>
										Ctrl + V key will <span>paste</span> to currrent cell.
									</li>
									<li>
										Ctrl + Space key will <span>clear</span> currrent cell content.
									</li>
								</ul>
							</div>
							<div style="padding-left: 4px;">
								<label>Table Navigation While Editing Cell Data: </label>
								<ul>
									<li>
										Alt + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell with Editor opening <span>after saving</span> current content.
									</li>
									<li>
										Alt + S key will <span>close Editor after saving</span> current content.
									</li>
									<!--<li>
										Alt + C key will <span>close Editor without save</span>.
									</li>-->
								</ul>
							</div>
							
						</div>
					</div>
				</ng-template>
			</p-overlayPanel>
			<div style="min-height: 264px;border:solid 1px #C2D63F;padding:2px;position: relative;">
				<div *ngIf="!curHeader&&(!curCell)" class="row m-0 p-0 tableInfo" style="font-size: 12px; color: white;">
					<div style="width: 50%;margin: 0;padding: 20px;line-height:150%;">
						<label>Navigation Before a Table Cell is Opened: </label>
						<ul>
							<li>
								Ctrl + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell.
							</li>
							<li>
								Ctrl + Enter key will <span>open Editor</span> with currrent cell content.
							</li>
							<li>							
								Ctrl + C key will <span>copy</span> currrent cell content.
							</li>
							<li>
								Ctrl + V key will <span>paste</span> to currrent cell.
							</li>
							<li>
								Ctrl + Space key will <span>clear</span> currrent cell content.
							</li>
						</ul>
					</div>
					<div style="width: 50%; padding: 20px;line-height:150%;">
						<label>Table Navigation While Editing Cell Data: </label>
						<ul>
							<li>
								Alt + ➡️⬆️⬅️⬇️ will <span>move</span> to adjacent cell with Editor opening <span>after saving</span> current content.
							</li>
							<li>
								Alt + S key will <span>close Editor after saving</span> current content.
							</li>
							<!--<li>
								Alt + C key will <span>close Editor without save</span>.
							</li>-->
						</ul>
					</div>
					<div style="padding:24px 42px; width:100%; border-top: #C2D63F solid 1px;vertical-align: middle;"><span style="font-weight:bold; color:orange">*</span> <span  class="tableInfo ml-2">Vertical Header</span> can be set in table setting</div>
				</div>
				<!--<div class="cplabel" *ngIf="!selectedHeaderType&&curCap" style="cursor:auto;margin:auto">
					<label><input type="checkbox" [(ngModel)]="curCap['border']">With Border</label>
					<label class="ml-3">Text Alignment:</label>
					<select [(ngModel)]="curCap['align']">
						<option value="Center">Center</option>
						<option value="Left">Left</option>
						<option value="Right">Right</option>
					</select>
				</div>
				<div pFocusTrap *ngIf="!selectedHeaderType&&curCap" >
					<div class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto;">
						<app-paragraph [addedSlot]="curCap['addedItem']"  class="docItem" [content]="curCap.NAME" [getText]="curCap['reqIndex']"  (selected)="selectedRow=-1;addLib=true" (onExit)='capData($event, curSec.id)' (outText)="capText($event,curSec.id)" (rfSelected)="selectedRF($event)"></app-paragraph>
					</div>
					<div style="float: right;position: relative;">
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCap();">Close</button>
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCap(curSec.id);">Save</button>
					</div>
				</div>-->
				
				<div pFocusTrap *ngIf="!selectedHeaderType&&curHeader">
					<div class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto;">
						<app-paragraph [editorType]="'temp'" [addedSlot]="curCol.addedItem"  class="docItem" [content]="curCol.NAME" [getText]="curSec['reqIndex']"  (selected)="selectedRow=-1;addLib=true;" (onExit)='colData($event, curSec.id)' (outText)="colText($event)" (rfSelected)="selectedRF($event)"></app-paragraph>
					</div>
					<div style="float: right;position: relative;">
						<!--<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCol(); curHeader=false">Close</button>-->
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCol(curSec.id); curHeader=false">Save</button>
					</div>
				</div>
				<div pFocusTrap *ngIf="selectedHeaderType&&curHeader">
					
					<div class="ckContainer"  [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto;">
						<app-paragraph [editorType]="'temp'" [addedSlot]="curCol.addedItem" class="docItem" [content]="curCol.NAME" [getText]="curSec['reqIndex']"  (selected)="selectedRow=-1;addLib=true;" (onExit)='colData($event, curSec.id,selectedHeaderType)' (outText)="colText($event,selectedHeaderType)" (rfSelected)="selectedRF($event)"></app-paragraph>
					</div>
					<div style="float: right;position: relative;">
						<!--<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCol(selectedHeaderType); curHeader=false">Close</button>-->
						<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCol(curSec.id,selectedHeaderType); curHeader=false">Save</button>
					</div>
				</div>
			<div *ngIf="curCell&&selectedCell">
				<div class="cplabel" style="max-height:360px; overflow:auto; cursor:auto;margin:auto">
					<label>Background:</label>
					<input class="cpicker" [disabled]="(curCol['lock'])||(curSec.data['locked']&&curSec.data.rows[selectedCell.row]['lock'])"				
				   [style.background]="curCell.bkcolor"
				   [(colorPicker)]="curCell.bkcolor"/>
				   <input type="checkbox" [disabled]="(curCol['lock'])||(curSec.data['locked']&&curSec.data.rows[selectedCell.row]['lock'])" [(ngModel)]="allCol">Apply to Entire Column
				   <input type="checkbox" [disabled]="(curCol['lock'])||(curSec.data['locked']&&curSec.data.rows[selectedCell.row]['lock'])" [(ngModel)]="allRow">Apply to Entire row
				   <ng-container *ngIf="(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)">
						<a class="btnRound1" [ngStyle]="{'color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999','border-color':(curCol.FO&&curCol.FO.length>0)||(curCol.DefaultFO&&curCol.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" style='float:none; margin-left: 60px;' (click)="op0.toggle($event)">Field Options</a>
										<p-overlayPanel #op0 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
											<ng-template pTemplate>
												<div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
													<h6>Choose Field Value(s)</h6>
														<div *ngIf='curCol.FO&&curCol.FO.length>0' class="col-md-10">
															<ng-container *ngFor="let label of curCol.FO; let i=index; trackBy:trackByFuntion">
																<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(label)'></i></label><br>
															</ng-container>
														</div>
														<ng-container *ngIf="curCol.DefaultFO&&curCol.DefaultFO.html">
															<p class="savedLabel">Default Value:</p>
															<div style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="curCol.DefaultFO.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div><br>
															<i class="fas fa-plus iconBtn ml-2" (click)='insertFOItem(curCol.DefaultFO)'></i>						
														</ng-container>
												</div>
											</ng-template>
										</p-overlayPanel>					
					</ng-container>
					<label class="ml-3"><input type="checkbox" [(ngModel)]="curCell['lock']" (change)="setLock($event, curCell)">Lock Content from Editing</label>
			    </div>
				<div *ngIf="!curHeader" pFocusTrap >
				<div *ngIf="!curCell['lock']&&(!(selectedCell&&curSec.data.rows[selectedCell.row]['lock']))&&(!curCol['lock']||curCell['colspan'])" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto">  
				<app-paragraph [editorType]="'temp'" [addedSlot]="curSec.addedItem"  class="docItem" [content]="curCell.htmltext" [getText]="curCell['reqIndex']"  (selected)="selectedRow=-1;addLib=true;" (onExit)='cellData($event, curSec.id)'  (rfSelected)="selectedRF($event)" (outText)="curCell.data=$event"></app-paragraph>
				</div> 
				<div *ngIf="curCell['lock']||(selectedCell&&curSec.data.rows[selectedCell.row]['lock'])||(!curCell['colspan']&&curCol['lock'])" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:100px; max-height:300px; overflow-y:auto; overflow-x:hidden; cursor:auto;margin:auto; background-color: white;color:black">  
					<span *ngIf="curCell.DATA" class="innerCell" [innerHTML]="curCell.DATA?.changingThisBreaksApplicationSecurity|safeHtml"></span>
				</div> 
				<button tabindex="-1" [disabled]="curCell['lock']||(selectedCell&&curSec.data.rows[selectedCell.row]['lock'])" [ngClass]="{'hasLibs':curCell.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;filteredData=null;selectedRow=-1; showLibs(curSec);op42.toggle($event);">Libraries</button>
				<button tabindex="-1" [disabled]="curCell['lock']||(selectedCell&&curSec.data.rows[selectedCell.row]['lock'])" [ngClass]="{'hasLibs':curCell.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; filteredData=null;selectedRow=-1;showSlots()">Repeat Fields</button>					
				<div style="float: right;position: relative;">
					<span *ngIf="cellsaveErr" style="color:orange; margin-top: 4px;">Saving not Successful, Please try again!</span> 
					<button type="button" class="btn btn-outline-light btn-sm mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="toCell(curSec.id)">Save</button>
					<!--<button type="button" class="btn btn-outline-light btn-sm mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="closeCell()">Close</button>-->
				</div>			
			</div>
				<p-overlayPanel #op42 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
					<ng-template pTemplate>
					<div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
						<ng-container *ngFor="let item of curCell.libs; trackBy:trackByFuntion"> 
						<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
						<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op421.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
						<a *ngIf="item.STATUS=='Active'" class="float-right p-0 mr-3" href="javascript:void(0)" title="Add" (click)="addRepeat('lib', item)"><i class="fas fa-arrow-right" style='font-size:.8em'></i></a>
						
						<p-overlayPanel #op421 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																	<ng-template pTemplate>
																		<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																			<h6>{{item.ITEM_TITLE}}</h6>
																			<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																				<label class="tag">{{label}}</label>
																			</ng-container>	
																			<div *ngIf="item.LIBRARY_ID>-1">
																				<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																			</div>
																			<div *ngIf="!item.COST_LIBRARY_ID">
																				<strong>Content :</strong>
																				<span *ngIf="item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																				<div *ngIf="item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																			</div>
																			<div *ngIf="item.COST_LIBRARY_ID>-1">
																				<strong>Cost :</strong> {{item.COST}}
																			</div>
																		</div>																	
																	</ng-template>
							</p-overlayPanel>
						</ng-container>										
					</div>
					</ng-template>
				</p-overlayPanel>
			</div>
		</div>
		<div class="m-0 p-0" style="position: relative;width: 100%;">
			
		</div>
		
				<div *ngIf="curSec" #edittableContainer style="max-height: 500px;overflow: auto;margin-top: 10px;" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false'>
					<!--<table *ngIf="curSec.data['caption']" style="width: 100%;margin: 0;color:#333"  (click)="selectCap(curSec)">
						<tr>
						  <th [ngStyle]="{'border':curSec.data['caption']['border']?'solid 1px black':'none', 'text-align':curSec.data['caption']['align']?curSec.data['caption']['align']:'center'}" style="font-size: 11px;margin: 0;background-color: white;">{{curSec.data['caption']['text']}}	</th>						  
						</tr>
					</table>-->
					<p-table [value]="curSec.data.rows" [columns]="curSec.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, curSec.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, curSec)">
						<ng-template pTemplate="header" let-columns>
							<ng-container *ngFor="let brow of curSec.data.beforeHeaders; let bindex=index">
							<tr>
								<th style="color:#555; background:#dedede; padding:4px; font-size:11px; cursor: pointer;" (click)="selectToggle($event, curSec, bindex, 'beforeHeaders');selectedCell=null;" title="Right click to lock/unlock header." (contextmenu)="setrowLock($event, 'beforeHeaders', bindex)" [ngClass]="{'selected':brow['selected']}" >
									<span *ngIf="!(curSec.data['locked']&&curSec.data['locked']['beforeHeaders'].indexOf(bindex)>-1)" class="pi pi-bars"></span>
									<span *ngIf="curSec.data['locked']&&curSec.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="pi pi-lock"></span>
								</th>
								<ng-container *ngFor="let col of brow; let u=index">
									<th *ngIf="!col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='beforeHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}"  class="cellItem">
										<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										<a (click)="selectCol(curSec, u, col, 'beforeHeaders', bindex)" class="editicon" title="Edit"><i style="color:#ccc" class="far fa-edit"></i></a>
									</th>
									<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='beforeHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}" class="cellItem">
										<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										<a (click)="selectCol(curSec, u, col, 'beforeHeaders', bindex)" class="editicon" title="Edit"><i style="color:#ccc" class="far fa-edit"></i></a>
									</th>
								</ng-container>
							</tr>
							</ng-container>
							<tr>
								<th class="cellItem" style="width:24px; background:white !important;vertical-align:middle" title="Right click to lock/unlock header." (contextmenu)="setrowLock($event, 'header')">
									<span *ngIf="curSec.data['locked']&&curSec.data['locked']['header']" class="pi pi-lock"></span>
								</th>
								<th *ngFor="let col of columns; let u=index" style="background:white !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" [ngClass]="{'highlightCell':!selectedHeaderType&&curHeader&&colIndex==u}" pReorderableColumn pResizableColumn [pResizableColumnDisabled]="curSec.data['locked']&&curSec.data['locked']['header']" [pReorderableColumnDisabled]="curSec.data['locked']&&curSec.data['locked']['header']" class="cellItem highlightCell">
									<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" [ngStyle]="{'color':curSec.OHEADER?'#C4C4C4':'#444'}"></span>
									<a (click)="selectCol(curSec, u, col)" class="editicon" title="Edit"><i style="color:#ccc" class="far fa-edit"></i></a>
								</th>
							</tr>
							<ng-container *ngFor="let brow of curSec.data.afterHeaders; let bindex=index">
								<tr>
									<th class="cellItem" style="color:#555; background:#dedede; padding:4px; font-size:11px; cursor: pointer;" (click)="selectToggle($event, curSec, bindex, 'afterHeaders');selectedCell=null;" title="Right click to lock/unlock header."  (contextmenu)="setrowLock($event, 'afterHeaders', bindex)" [ngClass]="{'selected':brow['selected']}" >
										<!--<span class="pi pi-bars"></span>-->
										<span *ngIf="!(curSec.data['locked']&&curSec.data['locked']['afterHeaders'].indexOf(bindex)>-1)" class="pi pi-bars"></span>
										<span *ngIf="curSec.data['locked']&&curSec.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="pi pi-lock"></span>
									</th>
									<ng-container *ngFor="let col of brow; let u=index">
										<th *ngIf="!col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='afterHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}" class="cellItem">
											<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
											<a (click)="selectCol(curSec, u, col, 'afterHeaders', bindex)" class="editicon" title="Edit"><i style="color:#ccc" class="far fa-edit"></i></a>
										</th>
										<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="background:#dedede !important;vertical-align:middle;" [ngStyle]="{'text-align':col.colAlign}" [ngClass]="{'highlightCell':selectedHeaderType=='afterHeaders'&&curHeader&&colIndex==u&&bindex==headerIndex}" class="cellItem">
											<span class="headerCell" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
											<a (click)="selectCol(curSec, u, col, 'afterHeaders', bindex)" class="editicon" title="Edit"><i style="color:#ccc" class="far fa-edit"></i></a>
										</th>
									</ng-container>
								</tr>
							</ng-container>
						</ng-template>
						<ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
							<tr [pReorderableRow]="index" class="editrow">
								<td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, curSec, index);selectedCell=null;" title="Right click to lock/unlock row." (contextmenu)="setrowLock($event, 'row',index)" [ngClass]="{'selected':rowData.selected}">
									<!--<span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>-->
									<span *ngIf="!rowData['lock']" class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>
									<span *ngIf="rowData['lock']" class="pi pi-lock" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>				
								</td>			
								 <ng-container *ngIf="rowData.items[0].colspan">
									<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(curSec, index, columns[0], rowData.items[0])" (click)="toEditCell(curSec, index, columns[0], rowData.items[0])" [ngClass]="{'rowHide':rowData.hide, 'highlightCell':!curHeader&&preCell.row==index&&preCell.col==0, 'normalCell':preCell.row!=index||preCell.col!=0}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
										<span class="innerCell" *ngIf="rowData.items[0].DATA" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='index' data-y="0" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										<i *ngIf="rowData.items[0]['lock']||rowData['lock']" class="fas fa-lock lockicon"  title="Cell/row Locked" ></i>
										<a *ngIf="!(rowData['lock']||rowData.items[0]['lock'])" (click)="op504.toggle($event)" class="toolicon" [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
										<p-overlayPanel #op504 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
									<ng-template pTemplate>
										<div style="max-height:160px; overflow-y:auto">
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0]); op504.hide()">Copy</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0]); op504.hide()">Paste</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0]); op504.hide()">Checkmark</a>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0]); op504.hide()">Clear</a>
										</div>					
									</ng-template>
								</p-overlayPanel>
									</td>
								</ng-container>	
								<ng-container *ngIf="!rowData.items[0].colspan">
									<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (click)="toEditCell(curSec, index, col, rowData.items[u])" [ngClass]="{'rowHide':rowData.hide, 'highlightCell':!curHeader&&preCell.row==index&&preCell.col==u, 'normalCell':preCell.row!=index||preCell.col!=u}">
										<span class="innerCell" *ngIf="rowData.items[u].DATA" [attr.data-id]="curSec.id" data-type="table" [attr.data-x]='index'[attr.data-y] ="u" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
										<i  class="fas fa-lock lockicon" *ngIf="col['lock']||rowData['lock']" title="Column/row Locked" ></i>
										<ng-container *ngIf="!(col['lock']||rowData['lock'])">
											<i *ngIf="rowData.items[u]['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>
											<a *ngIf="!rowData.items[u]['lock']" (click)="op501.toggle($event)" class="toolicon" title="Edit"><i class="fas fa-cog"></i></a>
										</ng-container>
										
										<p-overlayPanel #op501 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
									<ng-template pTemplate>
										<div style="max-height:160px; overflow-y:auto">
											<!--<a (click)="getFPosition(page1,$event,s,t); selectCell(page1, index, col, rowData.items[u]);" class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;" [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit">Edit</a><br>-->
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[u]); op501.hide()">Copy</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[u]); op501.hide()">Paste</a><br>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[u]); op501.hide()">Checkmark</a>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[u]); op501.hide()">Clear</a>
										</div>					
									</ng-template>
								</p-overlayPanel>
									</td>
								</ng-container>			
							</tr>
						</ng-template>
					</p-table> 
				
			</div>
			
		</div>					
		</div>
		<div *ngIf="tableToolShow" class="task-box" style="width:700px; top:30vh;  right:250px; max-height:60vh; background: #4C4C4C;" cdkDrag [cdkDragDisabled]="intext">
			<div style="margin:0 10px; padding:10px; color:#C2D63F;"> 
			<label style="font-weight:bold">Table Tools</label>
			<a href="javascript:void(0)" class="float-sm-right m-1 iconBtn" pTooltip="Close" tooltipZIndex='auto' (click)="tableToolShow=false;"><i  titie='close' class="far fa-window-close" style="pointer-events:none"></i></a>
			<!--<div  class="cplabel" style="padding:10px; color:#C2D63F;width: 100%;font-size: 12px;text-align: center;">
				<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="resetProp(curSec,'beforeHeaders'); resetProp(curSec,'afterHeaders'); resetProp(curSec)">Clear Selection</button>
			</div>-->						
			<div class="row" style="width:100%; font-size: .9em;">
				<!--<div  class="cplabel" style="padding:10px; color:#C2D63F;width: 100%;font-size: 12px;">
					<label class="col-md-7"><input type="checkbox" name='caption' [checked]="curSec.data['caption']" (change)="addCap($event, curSec)">Display Caption</label>
					<label class="col-md-5"><input type="radio" name='caption' [checked]="curSec.data['caption']&&(!curSec.data['caption']['border'])" (change)="addCap(curSec)">Display Caption without Border</label>
					<label class="col-md-4"><input type="radio" name='caption' [checked]="curSec.data['caption']&&curSec.data['caption']['border']" (change)="addCap(curSec, true)">Display Caption with Border</label>
					<label class="col-md-3"><input type="radio" name='caption' [checked]="!curSec.data['caption']" (change)="deleteCap(curSec)">No Caption</label>
					<button type="button" [disabled]="curSec.data['caption']" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addCap(curSec)">Add Caption without Border</button>
					<button type="button" [disabled]="curSec.data['caption']" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addCap(curSec, true)">Add Caption with Border</button>
					<button type="button" [disabled]="!curSec.data['caption']" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="deleteCap(curSec)">Delete Caption</button>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="resetProp(curSec,'beforeHeaders'); resetProp(curSec,'afterHeaders'); resetProp(curSec)">Clear Selection</button>
					<br>
				</div>-->
				<div style="padding:10px 20px; color:#C2D63F;width: 50%;"> 
					<label style="font-weight:bold;text-align: center;display: block;">Additional Header Rows</label>
						<!--<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(curSec,'beforeHeaders'); resetProp(curSec,'afterHeaders')">Clear Addtional Header Selection</button>-->
						<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 mb-2" style="font-size: .9em;" (click)="deleteHeaders(curSec)">Delete Addtional Header(s)</button><br>						
						<div style="color:#C2D63F; font-size: .9em;">
								<input type="checkbox" [checked]="addHBefore" style="margin-right: 4px;" (change)="addHBefore=!addHBefore">Insert Header Above<br>
									<!--<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>-->
									<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 mt-2 mb-3" (click)="addHeaders($event)"><span style="font-size:.9em; pointer-events:none">Add Additional Header For Each Column</span></a><br>
									<select style="width:70px; height:20px;">
										<option>Left</option>
										<option selected>Center</option>
										<option>Right</option>
									</select>
									<a href="javascript:void(0)"  [ngClass]="{'disabled':curSec.id=='pca_summary_0'}" class="btn btn-sm btn-outline-light pb-0 pt-0 ml-1 " (click)="addHSub($event)"><span style="font-size:.9em; pointer-events:none">Add Header Across All Rows</span></a>
									<!--<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 mt-3" style="font-size: .95em; margin-left: 20%;" (click)="deleteHeaders(curSec)">Delete Addtional Header(s)</button><br>-->

							</div>
				</div>
				<div style="padding:10px 30px; color:#C2D63F;width: 50%;border-left: 2px solid #C2D63F"> 
					<label style="font-weight:bold;text-align: center;display: block;">Add/Delete/Edit Table Rows</label>		
					<button type="button"  [ngClass]="{'disabled':curSec.id=='pca_summary_0'}" class="btn btn-outline-light btn-sm mr-4 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="hideRows(curSec)">Hide / Unhide Row(s)</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="deleteRows(curSec)">Delete Row(s)</button><br>
							<!--<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(curSec)">Clear Row Selection</button>-->
					<div style="font-size:.9em; color:#C2D63F; ">
						<input type="checkbox" style="margin-right: 4px;" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCRows($event)"><span style="font-size:.9em; pointer-events:none">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)"  [ngClass]="{'disabled':curSec.id=='pca_summary_0'}" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCSub($event)"><span style="font-size:.9em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>
			</div>
		</div>					
		</div>
	<div *ngIf="summaryColsShow" id="task-box" class="task-box1"  style="width:510px; right:20vw" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<h6>Set Project Summary Table Columns<i class="iconBtn far fa-window-close mr-3 mt-2 float-md-right"  (click)="summaryColsShow=false;"></i></h6>
			
			<hr class="line3">
			<input id='scolInput' type="text" class="col-md-7">
			<i class="fas fa-plus iconBtn mr-2 ml-1 " title='Add to Project Summary Table column' (click)="addPICol($event)"></i>
			<button (click)="op154.toggle($event);" title="Add from existing list"><i class="fas fa-chevron-down"  style="pointer-events:none; color:#C2D63F"></i></button>
			<p-overlayPanel #op154 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [style]="{'width': '500px'}">
                <ng-template pTemplate>
					<ng-container *ngFor="let op of presummaryCols|slice:2:presummaryCols.length">
                    	<a href="javascript:void(0)" style="font-size: 10px;" title='Add to Project Summary Table column' (click)="addPICol($event, op)">{{op}}</a><br>
                	</ng-container>
                </ng-template>
             </p-overlayPanel>
			<hr class="line3">
			<ng-container *ngFor="let col of summaryCols; let i=index">
				<select  [disabled]="i==0" class='mr-2'(change)="addColType($event, i)">
					<option value='Checkmark' [selected]="summaryColsType[i]=='Checkmark'">Checkmark</option>
					<option value='text' [selected]="summaryColsType[i]=='text'">Text</option>					
				</select>
				<label *ngIf='i==0'>1. {{col}}<br></label>	
				<label *ngIf='i>0'>{{i+1}}. {{col}}</label>			
				<i *ngIf='i>0' class="fas fa-times iconBtn ml-2" (click)="removeSummaryCol(i)"></i><br>
			</ng-container>
			
			<hr class="line3">
			<!--<button type="button" class="btn btn-outline-light btn-sm mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="summaryCols=summaryCols.slice(0,1)">clear</button>-->
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="addSummary();summaryColsShow=false">Save and Add Project Summary</button>
						
		</div>					
	</div>
	<div *ngIf="signShow" class="task-box1" style="width:350px; top:400px;  right:300px; max-height:50vh" cdkDrag>
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<label>Signature Setting</label><i class="iconBtn far fa-window-close mr-2 mt-1" style="float:right" (click)="signShow=false;"></i>
			<hr class="line2">
			<div style="width:100%;position: relative;">
				<div>
					<label  class="col-md-5 pl-0">Signature Label: </label>
					<span>{{curSign['label']}}</span>
					<app-edit-input [text]="curSign['label']" (edited)="curSign['label']=$event"></app-edit-input><br>
				</div>
				<div>
					<label  class="col-md-5 pl-0">Signature Role:</label>
					<select  class="col-md-7" [(ngModel)]="curSign['role']" (click)="setSignRoleName($event)">
						<option *ngFor="let role of signInfo.RW_SIGNATURE_LABELS" [value]="role.SIGNATURE_LABEL_ID">{{role.SIGNATURE_LABEL_NAME}}</option>
					</select>
				</div>					
				<div>
					<label class="col-md-5 pl-0">Align</label>
					<select [(ngModel)]="curSign['ALIGN']"  class="col-md-7">
						<option value="D">Default(2 per line)</option>
						<option value="L">Left(1 per line)</option>
						<option value="C">Center(1 per line)</option>
					</select>	
				</div>
				<hr class="line1">			
				<button type="button" class="btn btn-outline-light btn-sm float-sm-right btn-op m-2" (click)="saveSign()">Save</button>									
			</div>		
		</div>					
	</div>
	<div *ngIf="frmShow" id="task-box" class="task-box1"  style="width:710px" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<label>Freddie Mac Content Input</label>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="frmShow=false;"></i>
			<div class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto; width:100%">
				<app-paragraph [addedSlot]="curFrm.addedItem" [editorType]="'temp'" class="docItem"  [content]="curFrm.html"  [getText]="curFrm['reqIndex']"  (selected)="selectedRow=-1;addLib=true;selectedEditor='C' " (onExit)='frmData($event, curFrm)' (outText)="curFrm.text=$event"></app-paragraph> <!--(outHtml)="getPosition($event,i);textData($event)"-->
				<button  class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; selectedRow=-1;showSlots()">Repeat Fields</button>				
			</div>
			<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="curFrm=null;frmShow=false">Save</button>
						
		</div>					
		</div>
		
			<div *ngIf="pisummaryShow" class="task-box1"  style="width:510px; z-index: 2000;" cdkDrag [cdkDragDisabled]="intext">
				<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
					<label>Project Summary Content Input</label>
					<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="pisummaryShow=false;"></i>
					<div class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:450px; overflow:auto; cursor:auto; width:100%">
						<app-paragraph [addedSlot]="picurSummaryItem.addedItem" [editorType]="'temp'" class="docItem"  [content]="picurSummaryItem.html" [getText]="picurSummaryItem['reqIndex']"  (selected)="selectedRow=-1;addLib=true;selectedEditor='C' " (onExit)='pisummaryData($event)' (outText)="pisummaryText($event)"></app-paragraph> <!--(outHtml)="getPosition($event,i);textData($event)"-->
						<button  class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; selectedRow=-1;showSlots()">Repeat Fields</button>				
					</div>
					<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="curSummary=null;pisummaryShow=false">Save</button>
								
				</div>					
			</div>
				
				<div *ngIf="psShow" class="task-box1"  style="width:510px; top:20vh; right:20w" cdkDrag [cdkDragDisabled]="intext">
					<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
						<label>Set Project Summary Columns</label>
						<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="psShow=false;"></i>
						<hr class="line3">
						<div *ngIf="this.summaryType=='PHASE I'" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:400px; max-height:550px; overflow:auto; cursor:auto; width:100%">
								<ng-container *ngFor="let item of picurSummary; let i=index">
									<ng-container *ngIf="i>0">
										<label>{{item.col}}</label><i *ngIf='item.inputType=="text"' class="far fa-edit iconBtn" (click)="toSummaryEdit(item)"></i><br>
										<!--<textarea *ngIf='item.inputType=="text"' cols=2 class='colInput col-md-12' [(ngModel)]="item.data"></textarea>-->
										<input *ngIf='item.inputType=="Checkmark"' class='colInput col-md-4'  type='text' [(ngModel)]="item.data"/>
										<a *ngIf='summaryColsType[i]=="Checkmark"' class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;" (click)="item.data='✓'">Check On</a>
										<a *ngIf='summaryColsType[i]=="Checkmark"' class="btn btn-outline-light  pb-0 pt-0 ml-2 mb-1" style="font-size:.7em;" (click)="item.data=''">Clear</a><br>
										<div *ngIf='item.inputType=="text"&&item.secHtml' style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="item.secHtml?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
									</ng-container>							
								</ng-container>
							
							</div>
							<div *ngIf="this.summaryType=='PCA'" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:360px; max-height:550px; overflow:auto; cursor:auto; width:100%">
						
						
								<ng-container *ngFor="let item of pcacurSummary; let i=index">
										<label>{{item.col}}</label>
										<i *ngIf='item.inputType=="text"' class="far fa-edit iconBtn" (click)="toSummaryEdit(item)"></i><br>
										
										<ng-container *ngIf='item.inputType=="option"'>
											<select *ngIf='!item.ops' [(ngModel)]="item.cat" [ngStyle]="{'border':item.cat.length>0? 'none':'2px solid #F78181'}">
												<option *ngFor='let op of summaryCategory' [selected]="item.cat==op" [value]="op">{{op}}</option>
											</select><span *ngIf='i==0' style="color:#F78181">*</span>
											<ng-container *ngIf='item.ops'>
											<input type="text" class="col-md-6" id="actionItem" placeholder="Input your Action here"/>
											<button (click)="op333.toggle($event);" title="Select Item"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
											<i class="fas fa-plus iconBtn" title="Add Item to Action" (click)="addActionItem(item)"></i>
											<p-overlayPanel #op333 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
												<ng-template pTemplate>
													<div style="margin:0; max-height:400px; padding:4px; width:220px; overflow:auto">
														<ng-container *ngFor="let label of item.ops; trackBy: trackByFuntion">
															<div class="listItem2" style="margin:0; width:180px; border:1px ridge black" >
																<a href="javascript:void(0)" style="color:rgb(195,212,47); margin:2px" (click)="addToAction(label)">{{label}}</a><br>
															</div>
														</ng-container>
													</div>																
												</ng-template>
											</p-overlayPanel>
											<div class="col-md-10">
												<ng-container *ngFor="let label of item.ACTION let i=index; trackBy:trackByFuntion">
													<label class='mr-2'*ngIf="label.trim().length>0">{{label}}<i class="fas fa-times iconBtn ml-2" (click)='removeActionItem(i)'></i></label>
												</ng-container>
											</div>
										
										</ng-container><br>
											<!--<select *ngIf='item.ops' [(ngModel)]="item.data">
												<option>Please select Action</option>
												<option *ngFor='let op of item.ops' [selected]="item.cat==op" [value]="op">{{op}}</option>
											</select><br>-->
										</ng-container>
										<ng-container *ngIf='item.inputType=="Checkmark"'>
											<input class='colInput col-md-4'  type='text' [(ngModel)]="item.data"/>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;" (click)="item.data='✓'">Check On</a>
											<a class="btn btn-outline-light  pb-0 pt-0 ml-2 mb-1" style="font-size:.7em;" (click)="item.data=''">Clear</a><br>
											<!--<div *ngIf='item.inputType=="text"&&item.secHtml' style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="item.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>-->
										</ng-container>					
								</ng-container>
							</div>
								
						<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1 float-md-right" (click)="savePISummay();">Add and Save Section to PS</button>
						<span *ngIf="catReq" style="color:#F78181" class="float-sm-right mr-1">{{catReq}}</span>
						<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1" (click)="removePISummay(); psShow=false;">Remove Section from PS</button>			
								
									
					</div>
				</div>
			<div *ngIf="catShow" id="task-box" class="task-box1"  style="width:400px; font-size: 12px;" cdkDrag [cdkDragDisabled]="intext">
				<div style="margin:0 10px; padding:10px; color:#C2D63F;"> 
					<label>Edit Project Summary Category</label>
					<i class="iconBtn far fa-window-close mr-1 mt-2" style="float:right" (click)="catShow=false;"></i>
					<hr>
					<div style="min-height:160px; max-height:450px; overflow:auto; cursor:auto">
						<input type="text" class="col-md-10  ml-2" id="catItem" placeholder="Input your category here"/>
						<button (click)="op333.toggle($event);" title="Select Item"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
						<i class="fas fa-plus iconBtn" title="Add Item to Category" (click)="addCatItem()"></i>
						<p-overlayPanel #op333 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
							<ng-template pTemplate>
								<div style="margin:0; max-height:400px; padding:4px; width:220px; overflow:auto">
									<ng-container *ngFor="let label of summaryCategory; trackBy: trackByFuntion">
										<div class="listItem2" style="margin:0; width:180px; border:1px ridge black" >
											<a href="javascript:void(0)" style="color:rgb(195,212,47); margin:2px" (click)="addToCat(label)">{{label}}</a><br>
										</div>
									</ng-container>
								</div>																
							</ng-template>
						</p-overlayPanel>
						<div class="col-md-10 ml-2">
							<ng-container *ngFor="let label of catItems.split(',') let i=index; trackBy:trackByFuntion">
								<label *ngIf="label.trim().length>0">{{label}}<i class="fas fa-times iconBtn ml-2" (click)='removeCatItem(i)'></i></label><br>
							</ng-container>
						</div>
					</div>
					<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="saveCategory()">Save</button>
					<span *ngIf="catInfo" [ngStyle]="{'color':catInfo.status=='Y'?'#2fd45b':'#e27676'}" class="float-sm-right mr-3">{{catInfo.msg}}</span>
					<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47)"></span>		
				</div>					
			</div>
	<div *ngFor="let page of frontpages; let s=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':page.HIDE}" style="position: relative;" [style.pointer-events]="tableShow ? 'none' : 'auto'">
		
		<button  *ngIf="page.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
		<label [id]="page.id+'content'" style="font-weight:bold;width: 80%;"  [ngClass]="{'blue':listid==page.id, 'hideSec':page.OSNAME}" (click)="addLib=false; getFPosition(page.id, $event,s)"><span style="color:white">.</span>
			<span *ngIf="page.SECTION_TITLE&&page.SECTION_TITLE.length>0"  class="replaceContainer" [attr.data-id]="page.id" data-type="title"  [innerHTML]="page.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
			<app-edit-input  [text]="page.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s)"></app-edit-input>
		</label>
		<span class="opBtn" (click)="op50.toggle($event);">Options <i class="fas fa-angle-down"></i></span>
		
		<p-overlayPanel #op50  [appendTo]="'body'" [showCloseIcon]="true" [dismissable]="false" [style]="{width: '250px'}">
            <ng-template pTemplate>
                <div style="width: 240px; margin:0; padding-right:0; color:white;font-size:.8em"> 
					<label style="font-weight:bold; font-size:14px">Set Section Rules</label><br>
					<input type="checkbox" [(ngModel)]="page.OSNAME">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle  ml-1"></i>
					<hr class="line3">
					<label style="font-weight:bold">Page Content Setting</label><br>
					<input type="checkbox" [checked]="page.pageSrc=='pdf'" (change)="changeSrc($event, page, 'pdf')">Upload PDF<br>
					<hr class="line3">
					<div *ngIf="page.pageSrc!='pdf'">
					<label style="font-weight:bold">Page Header and Footer Setting</label><br>
					<input type="radio" name="hfSetting" [checked]="page.pageSrc=='report'" (change)="changeSrc($event, page, 'report')">Use Same Header & Footer as Report<br>
					<input type="radio" name="hfSetting" [checked]="page.pageSrc=='letter_style'" (change)="changeSrc($event, page, 'letter_style')">Set Letter Style Header and Footer<br>
					<div *ngIf="page.pageSrc=='letter_style'">
						<label>Header: </label>
						<a class="ml-1" (click)="getAllHeader(); op90.toggle($event);" title="Choose Header"><i class="pi pi-angle-down"></i></a>
						<a class="ml-2" *ngIf="page.header" href="javascript:void(0)" (click)="openHFPage(page.header.HEADERFOOTER_ID)">{{page.header.HF_TITLE}}</a>
						<br>
						<p-overlayPanel #op90 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
							<ng-template pTemplate>
								<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
									<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="page.header=null;page['fHeader']=null;op90.hide();">
										None
									</a><br>
									<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
										<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="page.header=header; op90.hide();">
											{{header.HF_TITLE}}
										</a>
										<br>
									</ng-container>
								</div>
							</ng-template>
						</p-overlayPanel>
						<ng-container *ngIf="page['header']">
							<label>First Page Header: </label>
							<a class="ml-1" (click)="getAllHeader(); op902.toggle($event);" title="Choose Header" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
							<a class="ml-2" *ngIf="page['fHeader']" href="javascript:void(0)" (click)="openHFPage(page['fHeader']['HEADERFOOTER_ID'])">{{page['fHeader']['HF_TITLE']}}</a>
							<br>
							<p-overlayPanel #op902 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
								<ng-template pTemplate>
									<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="page['fHeader']=null;op902.hide();">
											None
										</a><br>
										<ng-container *ngFor="let header of headers; trackBy:trackByFuntion">
											<a href="javascript:void(0)" style="color: #C2D63F;" (click)="page['fHeader']=header; op902.hide();">
												{{header.HF_TITLE}}
											</a>
											<br>
										</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
						</ng-container>
						<label>Footer: </label>
						<a class="ml-1" (click)="getAllFooter(); op91.toggle($event);" title="Choose Footer"><i class="pi pi-angle-down"></i></a>
						<a class="ml-2" *ngIf="page.footer" href="javascript:void(0)" (click)="openHFPage(page.footer.HEADERFOOTER_ID)">{{page.footer.HF_TITLE}}</a>
						<br>
						<p-overlayPanel #op91 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
							<ng-template pTemplate>
								<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
									<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="page.footer=null;page['fFooter']=null;op91.hide();">
										None
									</a><br>
									<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
										<a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="page.footer=footer; op91.hide();">
											{{footer.HF_TITLE}}
										</a>
										<br>
									</ng-container>
								</div>
							</ng-template>
						</p-overlayPanel>
						<ng-container *ngIf="page['footer']">
							<label>First Page Footer: </label>
							<a class="ml-1" (click)="getAllFooter(); op912.toggle($event);" title="Choose Footer" style="cursor: pointer;"><i class="pi pi-angle-down"></i></a>
							<a class="ml-2" *ngIf="page['fFooter']" href="javascript:void(0)" (click)="openHFPage(page['fFooter']['HEADERFOOTER_ID'])">{{page['fFooter']['HF_TITLE']}}</a>
							<br>
							<p-overlayPanel #op912 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
								<ng-template pTemplate>
									<div style="padding:4px; max-height:400px; overflow:auto; width:200px">
										<a href="javascript:void(0)" style="color: #C2D63F;" (click)="page['fFooter']=null;op912.hide();">
											None
										</a><br>
										<ng-container *ngFor="let footer of footers; trackBy:trackByFuntion">
											<a href="javascript:void(0)" style="color: #C2D63F;" (click)="page['fFooter']=footer; op912.hide();">
												{{footer.HF_TITLE}}
											</a>
											<br>
										</ng-container>
									</div>
								</ng-template>
							</p-overlayPanel>
						</ng-container>
					</div>
					</div>
					<ng-container *ngIf="page.pageSrc=='pdf'">
						<!--<p class="opBtn1" (click)="upload('pdf'); selectIndex=s">Upload PDF</p>-->
						<i class="fas fa-cloud-upload-alt iconBtn" (click)="upload('pdf'); selectIndex=s; curDoc=null"></i>
						<a *ngIf="page.pdf&&page.pdf.length>0" [href]="page.pdf" target=_blank ><label style="width:200px; font-size:11px">{{page.pdfName}}</label></a>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span><br>
					</ng-container>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="showPages(); op50.hide();"><span style="font-size:.8em;">Save</span></button>
					<!--<i *ngIf="(doc.text&&doc.text.length>0&&!doc.intro)||(doc.TYPE=='TABLE')" class="btn-blue fas fa-history float-md-right" pTooltip="Get History" tooltipZIndex='auto' (click)="getHistory(doc)"></i>autoSave('Front Page Setting',page.id);-->
					</div>
            </ng-template>
        </p-overlayPanel>
		<ng-container *ngIf="page.id==listid">
			
		<div *ngIf="page.pageSrc!='pdf'" class="ckContainer" >
			<app-paragraph [ifReadOnly]='page.READ_ONLY=="Y"' [editorType]="'temp'" (click)="getFPosition(page.id, $event,s);" [insertSign]='selectedInsert[s]' [addedSlot]="page.addedItem"  class="docItem"  [content]="page.text"  [getText]="page['reqIndex']"  (selected)="selectedRow=-1;selectedCell=null;listid=page.id;addLib=true; selectedEditor='F'; selectIndex=s;" (onExit)='pageData($event, s);'></app-paragraph>
			<button [ngClass]="{'hasLibs':page.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;getFPosition(page.id, $event,s);  filteredData=null;selectedRow=-1;selectedCell=null;showLibs(page);op80.toggle($event);">Libraries</button>
					<button [ngClass]="{'hasLibs':page.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getFPosition(page.id, $event,s); filteredData=null;selectedRow=-1;selectedCell=null; showSlots()">Repeat Fields</button>					
					<p-overlayPanel #op80 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; margin:0; max-height: 300px; overflow:auto; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<div *ngIf="page.libs"  cdkDropList [cdkDropListData]="page.libs" (cdkDropListDropped)="dropLib($event,page.libs )">
					<div *ngFor="let item of page.libs; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="item" class="libItem">
					<div class="listItem2">
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op801.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Delete" (click)="getFPosition(page.id,$event,s);removeLib(item)"><i class="fas fa-trash" style='font-size:.8em'></i></a>
					</div>
					<p-overlayPanel #op801 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</div>
					</div>					
				</div>
				</ng-template>
			</p-overlayPanel>			
		</div>
		</ng-container>
		<div *ngIf="page.id!=listid" class="puretext" (click)="getFPosition(page.id, $event,s);">
				<div *ngIf='page.text&&page.text.length>0' style="width:100%; padding:10px; margin:0" class="replaceContainer" [attr.data-id]="page.id" data-type="text" [innerHTML]="page.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
				</div>
			</div>
<div *ngFor="let page1 of page.SUB_SECTIONS; let t=index; trackBy:trackByFuntion" style="position:relative">
			<label [id]="page1.id+'content'" style="font-weight:bold;width: 80%;"  [ngClass]="{'blue':listid==page1.id, 'hideSec':(page1.TYPE=='TABLE'&&page1.OTNAME)||(page1.TYPE=='PHOTOS'&&page1.OPNAME)||(page1.TYPE=='PARA'&&page1.OSNAME)||((page1.TYPE=='SEALS'||page1.TYPE=='SIGNS')&&page1.OSNAME)}" (click)="addLib=false; getFPosition(page1.id, $event,s, t)"><span style="color:white">.</span>
				<span *ngIf="page1.SECTION_TITLE&&page1.SECTION_TITLE.length>0"  class="replaceContainer" [attr.data-id]="page1.id" data-type="title"  [innerHTML]="page1.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
				<app-edit-input *ngIf="page1.TYPE!='SEALS'&&page1.TYPE!='SIGNS'" [text]="page1.SECTION_TITLE" (edited)="addLib=false; changeTitle('front',$event,s, t)"></app-edit-input>
				<i *ngIf="(!(page1.text&&page1.text.length>0))&&(!(allEditor.indexOf(page1.id)>-1))&&otherTypes.indexOf(page1.TYPE)==-1"  class=" btn-blue far fa-edit " (click)="getFPosition(page1.id,$event,s, t);addEditor(page1.id)"></i>
				<i *ngIf="page1.TYPE=='PHOTOS'" class="btn-blue fas fa-camera-retro" (click)="getFPosition(page1.id, $event, s,t);"></i>
				<i *ngIf="page1.TYPE=='TABLE'" data-toggle='modal' data-target="#tableModal" title="Table Property" class="btn-blue fas fa-table" (click)="selectedRow=-1;selectedCell=null;getFPosition(page1.id,$event,s, t); toCreateTable(s,t)"></i>
				<i *ngIf="page1.TYPE=='TABLE'&&(!page1.data?.erisName)"  class="btn-blue" title='Modify Table' (click)="getFPosition(page1.id,$event,s, t);modifyTable(page1); selectedEditor='F'"><img src="/assets/images/icons8-edit-property-32.png" class="imageIcon"></i>

			</label>
			<span *ngIf='page1.TYPE!="PITABLE"' class="opBtn" (click)="op87.toggle($event);">Options <i class="fas fa-angle-down"></i></span>
			<!--<i *ngIf="(!page1?.data?.erisName&&page1.TYPE=='TABLE')&&(listid==page1.id)" class="btn-blue fas fa-toolbox tablebtn" (click)="op170.toggle($event); curSec=page1"></i>
			<p-overlayPanel #op170  [appendTo]="'body'" [showCloseIcon]="true"  [dismissable]="true" [style]="{width: '190px'}">
            <ng-template pTemplate>
                <div style="width: 200px; margin:0; padding-right:0; color:#C2D63F;font-size:.8em"> 
					<label style="font-weight:bold">Tools</label><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="hideRows(page1)">Hide Rows</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="deleteRows(page1)">Delete Rows</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(page1)">Clear Selection</button>
					<div style="font-size:.8em; color:#C2D63F; ">
							<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
							<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
							<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
							<select style="width:70px; height:20px;">
								<option>Left</option>
								<option selected>Center</option>
								<option>Right</option>
							</select>
							<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>                                       
				</div>
            </ng-template>
        </p-overlayPanel>-->
		<p-overlayPanel #op87  [appendTo]="'body'" [showCloseIcon]="true" [dismissable]="false" [style]="{width: '250px'}">
            <ng-template pTemplate>
                <div style="width: 240px; margin:0; padding-right:0; color:white;font-size:.8em"> 
					<label style="font-weight:bold">Set Section Rules</label><br>
						<ng-container *ngIf="page1.TYPE!='TABLE'"><input type="checkbox" [checked]="page1.DISPLAY_SEQUENCE=='N'" disabled>Omit Section Number<i title="The section number will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
						<ng-container *ngIf="!page1['tableClass']&&page1.TYPE!='TABLE'&&page1.TYPE!='PHOTOS'"><input type="checkbox" [(ngModel)]="page1.OSNAME">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle  ml-1"></i><br></ng-container>
						<ng-container *ngIf="!page1['tableClass']&&page1.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='page1.OTNAME'>Omit Table Name <i title="The table name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
						<ng-container *ngIf="page1.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='page1.OTABLE'>Hide Table<i title="The table will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
						<ng-container *ngIf="!page1['tableClass']&&page1.TYPE=='TABLE'"><input type="checkbox" [disabled]="page1['data']&&page1['data']['locked']&&page1['data']['locked']['header']" [(ngModel)]='page1.OHEADER'>Omit Table Header<i title="Table header will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
						<ng-container *ngIf="!page1['tableClass']"><input type="checkbox" [(ngModel)]='page1.TOC' disabled>Hide from TOC<i title="The section/table name will not print in TOC but will print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>	
						<ng-container *ngIf="page1.TYPE!='TABLE'"><input type="checkbox" [disabled]='page1.required' [(ngModel)]='page1.HIDE'>Hide Section<i title="The entire section will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>			
						<input type="checkbox" [(ngModel)]='page1.NEW'>Add Page Break<i title="Section will print on a new page." class="fas fa-info-circle ml-1"></i><br>
						<ng-container *ngIf="page1.TYPE=='TABLE'">		
							<label style="width:50%" >Table border class</label><input type="text" maxlength="20" [(ngModel)]='page1.borderClass'style="width:40%" (change)="addTableClass($event, page1)">							
						</ng-container>
						<button type="button" class="btn btn-outline-light btn-sm mr-4 mb-1 pt-0 pb-0 pl-1 pr-1" (click)="saveTemplate(); op87.hide();"><span style="font-size:.8em;">Save</span></button>
						<ng-container *ngIf="page1.TYPE=='TABLE'&&(!page1.data?.erisName)">	
							<hr class="line3">	
							<p class="opBtn1" (click)="copyTableData(page1); optionShow=false;">Copy Table</p>
							<p class="opBtn1" (click)="getFPosition(page1.id, $event,s, t); pasteTableData('F',page1.id ); op87.hide();">Paste Table</p>
						</ng-container>
				</div>
            </ng-template>
        </p-overlayPanel>
			<div *ngIf="page1.id==listid" [ngClass]="{'hideSec':page1.HIDE}">
				<button  *ngIf="page1.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
				<div *ngIf="page1.TYPE=='PARA'" class="ckContainer">
					<app-paragraph [addedSlot]="page1.addedItem" [editorType]="'temp'" [insertSign]='page1.insert' class="docItem"  [content]="page1.text"  [getText]="page1['reqIndex']"  (selected)="selectedRow=-1;selectedCell=null;getFPosition(page1.id, $event,s, t);addLib=true;selectedEditor='F';" (onExit)='pageData($event, s, t)'></app-paragraph> <!--(outHtml)="getPosition($event,i);textData($event)"-->
					<button [ngClass]="{'hasLibs':page1.libs?.length>0}" class="btn btn-outline-light rf-btn" (click)="libToSlot=false;getFPosition(page1.id, $event,s, t);  filteredData=null;selectedRow=-1;selectedCell=null;showLibs(page1);op40.toggle($event);">Libraries</button>
					<button [ngClass]="{'hasLibs':page1.slots?.length>0}" class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; getFPosition(page1.id, $event,s, t); filteredData=null;selectedRow=-1;selectedCell=null; showSlots()">Repeat Fields</button>					
					<p-overlayPanel #op40 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<div *ngIf="page1.libs"  cdkDropList [cdkDropListData]="page1.libs" (cdkDropListDropped)="dropLib($event,page1.libs )">
					<div *ngFor="let item of page1.libs; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="item" class="libItem">
					<div class="listItem2">
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op401.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Delete" (click)="getFPosition(page1.id,$event,s,t);removeLib(item)"><i class="fas fa-trash" style='font-size:.8em'></i></a>
					</div>
					<p-overlayPanel #op401 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</div>
					</div>					
				</div>
				</ng-template>
			</p-overlayPanel>
				</div>
			</div>
			<div *ngIf="page1.id!=listid" class="puretext" (click)="getFPosition(page1.id, $event,s, t);">
				<div *ngIf='page1.text&&page1.text.length>0' style="width:100%; padding:10px; margin:0" class="replaceContainer" [attr.data-id]="page1.id" data-type="text" [innerHTML]="page1.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
				</div>
			</div>
			<table *ngIf="page1.TYPE=='PITABLE'&&page1.data" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
				<thead>
					<tr>
						<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
								<span style="font-weight:bold"  [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}" [innerHTML]="h.NAME"></span>
							</th>
						</ng-container>
					</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.length>1">
						<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
								<span *ngIf="!k.refId&&(!k.secHtml)" >{{k.data}}</span>
								<span *ngIf="!k.refId&&k.secHtml"  class="replaceContainer" [attr.data-id]="page1.id" data-type="pitable" [attr.data-x]='q' [innerHTML]="k.secHtml?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								<a *ngIf="k.refId" href="javascript:void(0)" (click)="scrollTo(k.refId)" style="color:#000; margin-left: 2px;">{{k.data}}</a>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.colspan">
						<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
							{{k.data}}
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
			<div *ngIf="page1.id==listid"  [ngClass]="{'hideSec':page1.OTABLE}">			
		<div *ngIf="page1?.data&&(!page1?.data?.erisName)&&page1.TYPE!='PITABLE'">
			<button  *ngIf="page1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
			<table *ngIf="(page1.TYPE=='TABLE'&&page1.data&&(!page1.data?.erisName))" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
				<!--<caption *ngIf="page1.data['caption']" [ngStyle]="{'border':page1.data['caption']['border']?'solid 1px black':'none', 'text-align':page1.data['caption']['align']?page1.data['caption']['align']:'center'}">
					<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-v]='t' [innerHTML]="page1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				</caption>-->
				<thead>
					<ng-container *ngFor="let brow of page1.data.beforeHeaders; let bindex=index">
						<tr>
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
					<tr>
						<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
							<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
								<i *ngIf="page1.data['locked']&&page1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold"  class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}"></span>
							</th>
						</ng-container>
					</tr>
					<ng-container *ngFor="let brow of page1.data.afterHeaders; let bindex=index">
						<tr>
							<ng-container *ngFor="let col of brow; let u=index">
								<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
								<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
									<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
									<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								</th>
							</ng-container>
						</tr>
					</ng-container>
				</thead>
				<tbody>
					<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
						<tr *ngIf="r.items?.length>1">
							<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
								<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;position: relative;">
									<i *ngIf="page1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
									<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>										
									<span *ngIf="k.DATA"  class="replaceContainer" data-type="table" [attr.data-id]="page1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
								</td>														
							</ng-container>
						</tr>
						<tr *ngIf="r.items?.length==1">
							<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;position: relative;">
								<span *ngIf="r.items[0].DATA"  class="replaceContainer" data-type="table" [attr.data-id]="page1.id" [attr.data-x]='h' data-y='0' [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
								<i *ngIf="page1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>        
  <!--<p-table [value]="page1.data.rows" [columns]="page1.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, page1.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, page1)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="width:24px; background:white !important;vertical-align:middle"></th>
            <th *ngFor="let col of columns; let u=index" style="background:white !important;vertical-align:middle;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn  pResizableColumn class="cellItem">
                <span class="headerCell" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}"></span>
				<a (click)="selectCol(page1, u, col); getFPosition(page1.id,$event,s,t)" class="float-right" title="Edit" style="cursor:pointer; margin-right:8px"><i style="color:#ccc" class="far fa-edit"></i></a>
			</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, page1, index);selectedCell=null;" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null"></span>
            </td>			
 			<ng-container *ngIf="rowData.items[0].colspan">
				<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(page1, index, columns[0], rowData.items[0])" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
					<span class="innerCell" *ngIf="rowData.items[0].DATA" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='index' data-y="0" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					<a (click)="op504.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op504 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
					<ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0])">Clear</a>
					</div>					
				</ng-template>
				</p-overlayPanel>
				</td>
			</ng-container>	
			<ng-container *ngIf="!rowData.items[0].colspan">
				<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(page1, index, col, rowData.items[u])" [ngClass]="{'rowHide':rowData.hide}">
					<span class="innerCell" *ngIf="rowData.items[u].DATA" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='index'[attr.data-y] ="u" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					<a (click)="op501.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op501 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
					<ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[u])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[u])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[u])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[u])">Clear</a>
					</div>					
				</ng-template>
				</p-overlayPanel>
				</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table> -->
</div>
</div>
<div *ngIf="page1.id!=listid" class="puretext" (click)="getFPosition(page1.id,$event,s,t);resetProp(page1)">
	<table *ngIf="(page1.TYPE=='TABLE'&&page1.data&&(!page1.data?.erisName))" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
		<!--<caption *ngIf="page1.data['caption']" [ngStyle]="{'border':page1.data['caption']['border']?'solid 1px black':'none', 'text-align':page1.data['caption']['align']?page1.data['caption']['align']:'center'}">
			<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-v]='t' [innerHTML]="page1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
		</caption>-->
		<thead>
			<ng-container *ngFor="let brow of page1.data.beforeHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
			<tr>
				<ng-container *ngFor="let h of page1.data?.cols; let o=index; trackBy:trackByFuntion">
					<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
						<i *ngIf="page1.data['locked']&&page1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold"  class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml" [ngStyle]="{'color':page1.OHEADER?'#C4C4C4':'#444'}"></span>
					</th>
				</ng-container>
			</tr>
			<ng-container *ngFor="let brow of page1.data.afterHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="page1.data['locked']&&page1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="page1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
		</thead>
		<tbody>
			<ng-container *ngFor="let r of page1.data.rows; let h=index; trackBy:trackByFuntion">
				<tr *ngIf="r.items?.length>1">
					<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
						<td [ngStyle]="{'text-align':page1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;position: relative;">
							<i *ngIf="page1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
							<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>										
							<span *ngIf="k.DATA"  class="replaceContainer" data-type="table" [attr.data-id]="page1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
						</td>														
					</ng-container>
				</tr>
				<tr *ngIf="r.items?.length==1">
					<td [attr.colspan]='page1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;position: relative;">
						<span *ngIf="r.items[0].DATA"  class="replaceContainer" data-type="table" [attr.data-id]="page1.id" [attr.data-x]='h' data-y='0' [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						<i *ngIf="page1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
					</td>
				</tr>
			</ng-container>
		</tbody>
	</table>
	</div>
	<div *ngIf="page1.TYPE=='SEALS'&&page1.seals&&page1.seals.length>0" style="width:100%; padding:0" >
		<div class="row">
			<ng-container *ngFor="let photo of page1.seals; let u=index; trackBy:trackByFuntion">
				<div *ngIf="photo.TYPE=='seal'" class="gallery1">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
					</div>
					<a href="javascript:void(0)" class="removeFile1" title="Remove Seal" style="margin:0 4px" (click)="addLib=false; getFPosition(page1.id,$event,s, t);removeSeal('seals',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					
				</div>
				
			</ng-container>
			</div>
		</div>
		<div *ngIf="page1.TYPE=='SIGNS'&&page1.signs&&page1.signs.length>0" style="width:100%; padding:0" >
		<div class="row">
			<ng-container *ngFor="let photo of page1.signs; let u=index; trackBy:trackByFuntion">
				<div *ngIf="!photo['ALIGN']||photo['ALIGN']=='D'" class="gallery1">
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'&&photo.TYPE=='signature'" class="col-md-12" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line">
							<div *ngIf="tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getFPosition(page1.id,$event,s,t);removeSeal('signs', photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='N'&&photo.TYPE=='signature'" class="col-md-12">
					<div  class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:100%;vertical-align:bottom">
					</div>
					<p class="desc1">{{photo.NAME}}</p>
					<p class="desc1">{{photo.TITLE}}
					
					<a href="javascript:void(0);" class="removeFile1" title="Remove Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='N'&&photo.TYPE=='signature'" class="col-md-12" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span  [ngClass]="{'under-line':photo.underline}">
							<div class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getFPosition(page1.id,$event,s,t);removeSeal('signs', photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="photo.signatureTemplate" class="col-md-12">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				</div>	
				<div *ngIf="photo['ALIGN']&&photo['ALIGN']!='D'" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
					<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'&&photo.TYPE=='signature'" class="col-md-6" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line">
							<div *ngIf="tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getFPosition(page1.id,$event,s,t);removeSeal('signs', photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='N'&&photo.TYPE=='signature'" class="col-md-6">
					<div  class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:100%;vertical-align:bottom">
					</div>
					<p class="desc1">{{photo.NAME}}</p>
					<p class="desc1">{{photo.TITLE}}
					
					<a href="javascript:void(0);" class="removeFile1" title="Remove Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='N'&&photo.TYPE=='signature'" class="col-md-6" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span  [ngClass]="{'under-line':photo.underline}">
							<div class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getFPosition(page1.id,$event,s,t);removeSeal('signs', photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="photo.signatureTemplate&&(!(tempInfo&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" class="gallery1">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				<div *ngIf="photo.signatureTemplate&&tempInfo&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;">
					<div  style="padding:10px; margin: 0;width:50%" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
					<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
					<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getFPosition(page1.id,$event,s, t);removeSeal('signs',photo, u)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
				</div>
				</div>						
			</ng-container>
			
			</div>
		</div>
	</div>		
	</div>
	<ng-container *ngIf="tempInfo?.PCA_INDICATOR!='frm1104'&&(!(tempInfo?.PHASE1_TYPE&&tempInfo.PHASE1_TYPE=='1103'))">
		<div *ngFor="let doc of contents; let i=index; trackBy:trackByFuntion" [ngClass]="{'hideSec':doc.HIDE}" style="position:relative" [style.pointer-events]="tableShow ? 'none' : 'auto'">
		<button  *ngIf="doc.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
		<!--<label class='seq' [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1)}" (click)="getPosition(doc.id, $event,i)">{{doc.SECTION_SEQUENCE}}</label>-->
		<label [id]="doc.id+'content'"   style="font-weight:bold;width: 80%;" [ngClass]="{'blue':curIndex[0]==i&&!(curIndex[1]>-1)&&!(curIndex[2]>-1), 'hideSec':doc?.OSNAME||doc?.OPNAME}" (click)="getPosition(doc.id, $event,i)">{{doc.SECTION_SEQUENCE}}<span *ngIf="doc.SECTION_TITLE&&doc.SECTION_TITLE.length>0" class="replaceContainer" [attr.data-id]="doc.id" data-type="title"  [innerHTML]="doc.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
			<app-edit-input *ngIf="doc.TYPE!='SEALS'&&doc.TYPE!='SIGNS'" [text]="doc.SECTION_TITLE"  (edited)="getPosition(doc.id, $event, i); changeTitle('content',$event,i)"></app-edit-input>
			<i *ngIf="(!(doc.text&&doc.text.length>0))&&(!(allEditor.indexOf(doc.id)>-1))&&doc.TYPE!='COST'" class="btn-blue far fa-edit" (click)="getPosition(doc.id, $event,i);selectedRow=-1;addEditor(doc)"></i>
			<i *ngIf="doc.TYPE=='PHOTOS'" class="btn-blue fas fa-camera-retro"></i>
		</label>
		<!--<i class="brn btn-outline-dark btn-small fas fa-cog p-2 float-md-right" (click)="op51.toggle($event);"></i>-->
		<span class="opBtn" [attr.data-id]="doc.id+'popbtn'" (click)="op51.toggle($event);showCat=false">Options <i class="fas fa-angle-down"></i></span>
		<p-overlayPanel #op51  [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '280px'}">
            <ng-template pTemplate>
                <div style="width: 240px; margin:0; padding-right:0; color:white;font-size:.8em"> 
					<label style="font-weight:bold">Set Section Rules</label><br>
					<input type="checkbox" *ngIf="doc.TYPE!='PHOTOS'" [checked]="doc?.DISPLAY_SEQUENCE=='N'" (click)="getPosition(doc.id,$event,i); ifSeq($event, doc)">Omit Section Number<i title="The section number will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br>
					<ng-container *ngIf="doc.TYPE!='PHOTOS'"><input type="checkbox" [(ngModel)]='doc.OSNAME'  (click)="ifSecTitle($event, doc)">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="doc.TYPE=='PHOTOS'"><input type="checkbox" [(ngModel)]='doc.OPNAME'>Omit Photo Name <i title="The photo name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<input type="checkbox" [(ngModel)]='doc.TOC'>Hide from TOC<i title="The section/table name will not print in TOC but will print in the report PDF." class="fas fa-info-circle ml-1"></i><br>
					<input type="checkbox" [disabled]='doc.required' [(ngModel)]='doc.HIDE'>Hide Section<i title="The entire section will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br>					
					<input type="checkbox" [(ngModel)]='doc.NEW'>Add Page Break<i title="Section will print on a new page." class="fas fa-info-circle ml-1"></i><br>
					<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn" (click)="getPosition(doc.id, $event,i); moveShow=true;toMove(doc)"><span style="font-size:.8em;">Move To</span></button>
					<div *ngIf="doc.TYPE=='PCASUMMARY'">
						<hr class="line3">
						<label>Set Summary Categories</label>
						<i class="iconBtn far fa-edit ml-2" (click)="getCatItems()"></i>
						<i class="iconBtn fas fa-info-circle ml-2" (click)="op511.toggle($event)"></i>
						<p-overlayPanel #op511  [appendTo]="'body'" [dismissable]="true" [style]="{width: '280px'}">
							<ng-template pTemplate>
							<div class="listItem2" style="margin:0; border:1px ridge black" *ngFor="let item of summaryCategory">
								<label >{{item}}</label>
							</div>
							</ng-template>
						</p-overlayPanel>
					</div>
					<!--<div *ngIf="otherTypes.indexOf(doc.TYPE)==-1&&summaryStatus&&!doc.data">
						<hr class="line3">
						<label>Summary Category</label>
						<select class="costInput" style="width:90%; font-size: 11px;" (change)="selSummaryCat(doc, $event, 'cat')">
							<option value="">Please Select Category</option>
							<option *ngFor="let item of summaryCategory" [value]="item" [selected]="item==doc.summaryPara?.cat">{{item}}</option>
						</select>						
					</div>-->
					<div *ngIf="otherTypes.indexOf(doc.TYPE)==-1&&tempInfo?.PCA_INDICATOR=='4099e'&&!doc.data">
						<hr class="line3">
						<label>Fannie Mae Category: </label>
						<select class="costInput" style="width:90%; font-size: 11px;" (change)="selFmeUl(doc, $event, 'cat',op51, doc.id+'popbtn')">
							<option value="">Please Select Fannie Mae Category</option>
							<option *ngFor="let item of capitalCategory; let i=index" [value]="item.label" [selected]="item.label==doc.ul?.cat">{{item.label}}</option>
						</select>
						<div *ngIf="doc.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label class="fmeLabel">Average EUL (yr): </label>
							<label class="fmeLabel">Effective Age (yr): </label>
							<input  class="fmeInput" type="number" min="0" [(ngModel)]='doc.ul.EUL'  (change)="selFmeUl(doc, $event, 'EUL')">
							<input  class="fmeInput" type="number" min="0" [(ngModel)]='doc.ul.EFF'  (change)="selFmeUl(doc, $event, 'EFF')">
						</div>
						<div  *ngIf="doc.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label  class="fmeLabel">Rating: </label>
							<label class="fmeLabel"></label>-
							<select class="fmeInput  mr-1" (change)="selFmeUl(doc, $event, 'RATING')">
								<option value="">Select Rating</option>
								<option *ngFor="let item of ratingOps; let i=index" [value]="item" [selected]="item==doc['ul'].RATING">{{item}}</option>
							</select>
							<!--<select class="fmeInput" (change)="selFmeUl(doc, $event, 'ACTION')">
								<option value="">Select Action Item</option>
								<option *ngFor="let item of actionItemOps; let i=index" [value]="item" [selected]="item==doc['ul'].ACTION">{{item}}</option>
							</select> -->
							<!--<p-multiSelect [style]="{'width':'100%', 'padding':'1px', 'font-size':'10px'}" [options]="actionItemOps" [filter]="false" [ngStyle]="{'border':doc.ul?.ACTION.length>0? 'none':'2px solid #F78181'}" [(ngModel)]="doc.ul.ACTION" optionLabel="name" (onChange)="selFmeUl(doc, $event, 'ACTION')"></p-multiSelect>-->
						</div>
					</div>
					<ng-container *ngIf="doc.TYPE!='PCATABLE'&&(!doc.tableClass)&&(doc.TYPE!='4099e')">
						<hr class="line3">
						<input type="checkbox" [checked]='doc.landscape' name="pagesize" (change)="setPageSize(doc, $event)"/>Print in Landscape<br>
					</ng-container>
					<ng-container *ngIf="doc.SUB_SECTIONS?.length==0||!doc.SUB_SECTIONS||(doc.text&&doc.text.length>0)">
						<hr class="line3">
						<input type="checkbox" [(ngModel)]='doc.wcompleted'>Writing Complete<br>
						<input type="checkbox" [(ngModel)]='doc.rcompleted'>Review Complete<br>
					</ng-container>
					<hr class="line3">
					<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn mt-1" (click)="saveTemplate(); op51.hide();"><span style="font-size:.8em;">Save</span></button>
			    </div>
            </ng-template>
        </p-overlayPanel>
		<a *ngIf="(otherTypes.indexOf(doc.TYPE)==-1&&doc.SECTION_SEQUENCE&&doc.SECTION_SEQUENCE.length>0)&&summaryStatus" class="psBtn" [ngStyle]="{'color':doc.pisummarydata||doc.pcasummarydata?'#c2d63e':'#999','border-color':doc.pisummarydata||doc.pcasummarydata?'#c2d63e':'#999'}" title="Project Summary" (click)="editPs(doc)">PS</a>
		<br>
		<ng-container *ngIf="doc.TYPE=='1105'">
			<app-frm *ngIf="doc.id=='frm_sec'" [inputData]="doc.frmData" [src]='"temp"' [rterm]='reserveTerm' [pcaData]='pcaOp' [costs]="costTables" [ulProp]='ulProp' (toRF)="frmShow=true;showSlots(); curFrm=$event" [rfinfo]="curFrm" (frmOutput)="doc.frmData=$event" (scrollOutput)="scroll($event)"></app-frm><!--(frmOutput)="doc.frmData=$event"--> 
		</ng-container>
		<!--<ng-container *ngIf="doc.TYPE=='SUMMARY'">
			<app-summary *ngIf="doc.id=='project_summary'" [inputData]="doc.summaryData" [costs]="costTables" [category]='summaryCategory' [pcaData]='pcaOp' [pcaMultiplier]='pcaOp.multiplier' [pcaRate]='pcaOp.inflation' [pcaTerm]='pcaOp.reserve' [summarys]='allSummarys' (toRF)="summaryShow=true; showSlots(); curSummary=$event" [rfinfo]="curSummary" (toAction)='toSummaryAction($event)' (naviToSec)="scrollTo($event)" (summaryOutput)="doc.summaryData=$event;"></app-summary>
		</ng-container>-->
		<ng-container *ngIf="doc.id==curId">
		<div  class="ckContainer" *ngIf='allEditor.indexOf(doc.id)>-1||(doc.text&&doc.text.length>0)'>
			<app-paragraph class="docItem" [editorType]="'temp'" [addedSlot]="doc.addedItem" [content]="doc.text"  (selected)="selectedRow=-1;selectedCell=null;getPosition(doc.id,$event,i);" [getText]="doc['reqIndex']" (onExit)='textData($event,doc.id)'></app-paragraph>
			<button class="btn btn-outline-light rf-btn" [ngClass]="{'hasLibs':doc.libs?.length>0}" (click)="libToSlot=false;getPosition(doc.id, $event,i);  filteredData=null;selectedRow=-1;selectedCell=null;showLibs(doc);op60.toggle($event);">Libraries</button>
			<button class="btn btn-outline-light rf-btn ml-1 mr-2" [ngClass]="{'hasLibs':doc.slots?.length>0}" (click)="slotToLib=false; getPosition(doc.id, $event,i); filteredData=null;selectedRow=-1;selectedCell=null;showSlots()">Repeat Fields</button>					
			<input type="checkbox" (change)="slotToLib=false; getPosition(doc.id, $event,i); filteredData=null;selectedRow=-1;selectedCell=null;setTextType($event)" [checked]="doc.intro"><label class="libOption">Instruction</label>
			<p-overlayPanel #op60 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:1; color:#C2D63F;font-size:.8em"> 
					<div *ngIf="doc.libs"  cdkDropList [cdkDropListData]="doc.libs" (cdkDropListDropped)="dropLib($event,doc.libs )">
					<div *ngFor="let item of doc.libs; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="item" class="libItem">
					<div class="listItem2">
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op601.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Delete" (click)="getPosition(doc.id,$event,i);removeLib(item)"><i class="fas fa-trash" style='font-size:.8em'></i></a>
					</div>
					<p-overlayPanel #op601 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</div>
					</div>					
				</div>
				</ng-template>
			</p-overlayPanel>
		</div>
		</ng-container>	
		<div *ngIf="doc.id!=curId" class="puretext" (click)="getPosition(doc.id, $event,i)">
			<div *ngIf='(allEditor.indexOf(i.toString()+"--")>-1||(doc.text&&doc.text.length>0))&&!doc?.intro' style="width:100%; padding:10px; margin:0" class="replaceContainer" data-type="text" [attr.data-id]="doc.id" [innerHTML]="doc.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
		</div>
		</div>
		<ng-container *ngIf="doc.id!=curId">
		<div class="intro"  (click)="getPosition(doc.id, $event,i)" *ngIf='(allEditor.indexOf(doc.id)>-1||(doc.text&&doc.text.length>0))&&doc?.intro'>
			<button class="intro-btn btn btn-sm">Instruction Only</button>
			<div [innerHTML]='doc.text' style="width:100%; margin:0"></div>
		</div>
		</ng-container>
		<div *ngFor="let doc1 of doc.SUB_SECTIONS; let j=index; trackBy:trackByFuntion"  [ngClass]="{'hideSec':doc1.HIDE, 'hidefrm':doc1['HIDEFRM']}"  style="position:relative">
			<button  *ngIf="doc1.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
			<!--<label class='seq' style="margin-left:10px" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&!(curIndex[2]>-1)}" (click)="getPosition(doc1.id, $event,i,j)">. {{doc1.SECTION_SEQUENCE}} </label>-->
			<label  [id]="doc1.id+'content'" (click)="getPosition(doc1.id, $event,i,j)" style="font-weight:bold;width: 80%;" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&!(curIndex[2]>-1),'hideSec':doc1?.OTNAME||doc1?.OSNAME||doc1?.OPNAME}">. {{doc1.SECTION_SEQUENCE}}<span *ngIf="doc1.SECTION_TITLE&&doc1.SECTION_TITLE.length>0" class="replaceContainer" [attr.data-id]="doc1.id" data-type="title" [innerHTML]="doc1.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext"></span>
				<app-edit-input *ngIf="doc1.TYPE!='SEALS'&&doc1.TYPE!='SIGNS'" [text]="doc1.SECTION_TITLE" (edited)="getPosition(doc1.id,$event, i, j); changeTitle('content',$event,i,j)"></app-edit-input>
				<i *ngIf="doc1.TYPE=='PDFSEC'" class=" btn-blue far fa-file-pdf" (click)="getPosition(doc1.id,$event, i,j);"></i>
				<i *ngIf="doc1.TYPE=='PHOTOS'" class="btn-blue fas fa-camera-retro"></i>
				<i *ngIf="doc1.TYPE=='TABLE'" data-toggle='modal' title="Table Property" data-target="#tableModal" class="btn-blue fas fa-table" (click)="selectedRow=-1;selectedCell=null;getPosition(doc1.id,$event,i, j);toCreateTable(i,j)"></i>
				<i *ngIf="(!(doc1.text&&doc1.text.length>0))&&(!(allEditor.indexOf(doc1.id)>-1))&&otherTypes.indexOf(doc1.TYPE)==-1&&(!doc1.tableClass)"  class="btn-blue far fa-edit" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;addEditor(doc1)"></i>
				<i *ngIf="doc1.TYPE=='TABLE'&&(!doc1.data?.erisName)"  class="btn-blue" title='Modify Table' (click)="getPosition(doc1.id,$event,i, j);modifyTable(doc1); selectedEditor='O'"><img src="/assets/images/icons8-edit-property-32.png" class="imageIcon"></i>

			</label>
			<ng-container *ngIf="summaryStatus&&summaryType=='PCA'&&doc1.TYPE=='COSTTABLE'">
				
				<select class="costInput mr-1" style="width:40%; font-size: 11px;" [disabled]="doc1.id!=curId" [ngStyle]="{'border':doc1['summaryCat']? 'none':'2px solid #F78181'}" (change)="selCostCat('summaryCat', $event, doc1)">
					<option></option>
					<option *ngFor="let item of summaryCategory; let i=index" [value]="item" [selected]="item==doc1['summaryCat']">{{item}}</option>
				</select>
			
		</ng-container>
			<ng-container *ngIf="doc1.TYPE=='COSTTABLE'&&tempInfo.PCA_INDICATOR=='4099e'">
				<!--<i class="btn-blue far fa-plus-square" title="Add Cost Recommendation Item" (click)="getPosition(doc1.id,$event,i,j);selectedRow=-1;selectedCell=null;getCostData(doc1.id)"></i>-->
				<select class="costInput" [ngStyle]="{'border':doc1.long?.length>0? 'none':'2px solid #F78181'}" style="width:40%; font-size: 11px;" (change)="selFmeCost(doc1, $event)">
					<option>Please Select Fannie Mae Category</option>
					<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.id==doc1.long">{{item.label}}</option>
				</select>
			</ng-container>
			<ng-container *ngIf="doc1.TYPE=='COSTTABLE'&&tempInfo.PCA_INDICATOR=='frm1105'">
				<select class="costInput" style="width:40%; font-size: 12px;" [ngStyle]="{'border':doc1.cat? 'none':'2px solid #F78181'}" (change)="selFrmUl(doc1, $event, 'cat')">
					<option value="-1">Please Select Freddie Mac Category</option>
					<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.tag==doc1.cat">{{item.label}}</option>
				</select>
			</ng-container>
			<span [attr.data-id]="doc1.id+'popbtn'" *ngIf="(!doc1['tableClass']||doc1.id=='pca_summary_0')&&doc1.TYPE!='PITABLE'" class="opBtn" (click)="checkParentSeq(doc.DISPLAY_SEQUENCE); checkPcaTableSetting(doc1); op52.toggle($event);">Options <i class="fas fa-angle-down"></i></span>
			<!--<i class="brn btn-outline-dark btn-small fas fa-cog p-2 float-md-right" (click)="op52.toggle($event);"></i>-->
			<p-overlayPanel #op52  [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '280px'}">
            <ng-template pTemplate>
                <div style="width: 240px; margin:0; padding-right:0; color:white;font-size:.8em"> 
					<label style="font-weight:bold">Set Section Rules</label><br>
					<ng-container *ngIf="doc1.TYPE=='PDFSEC'">
						<span class="cplabel">Upload PDF</span><i class="fas fa-cloud-upload-alt iconBtn" (click)="upload('pdf'); curDoc=doc1"></i>
						<a *ngIf="doc1.pdf?.length>0" [href]="doc1.pdf" target=_blank ><label style="width:200px; font-size:11px">{{doc1.pdfName}}</label></a>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span><br>
						<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="doc1.pdf=''; doc1.pdfName='';"><span style="font-size:.8em;">Remove PDF</span></button>						
					</ng-container>
					<div *ngIf="doc1.TYPE!='PDFSEC'">
					<ng-container *ngIf="!doc1['tableClass']&&doc1.TYPE!='TABLE'&&doc1.TYPE!='PHOTOS'"><input type="checkbox"  [checked]="doc1?.DISPLAY_SEQUENCE=='N'" (click)="getPosition(doc1.id,$event,i, j); ifSeq($event, doc1)" [disabled]='noSeq'>Omit Section Number<i title="The section number will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br>
						<p *ngIf='noSeq' style="color:#F78181; margin: 0;font-size: .9em;">Could not find the upper level section number.</p>
					</ng-container>
					<ng-container *ngIf="!doc1['tableClass']&&doc1.TYPE!='TABLE'&&doc1.TYPE!='PHOTOS'"><input type="checkbox" [(ngModel)]='doc1.OSNAME'  (click)="ifSecTitle($event, doc1)">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="doc1.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='doc1.OTNAME'>Omit Table Name <i title="The table name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="doc1.TYPE=='TABLE'&&(!(doc1.data&&doc1.data.erisName))"><input type="checkbox" [disabled]="doc1['data']&&doc1['data']['locked']&&doc1['data']['locked']['header']" [(ngModel)]='doc1.OHEADER'>Omit Table Header<i title="Table header will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="doc1.TYPE=='PHOTOS'"><input type="checkbox" [(ngModel)]='doc1.OPNAME'>Omit Photo Name <i title="The photo name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="doc1.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='doc1.OTABLE'>Hide Table<i title="The table will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="!doc1['tableClass']" ><input type="checkbox" [(ngModel)]='doc1.TOC'>Hide from TOC<i title="The section/table name will not print in TOC but will print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>	
					<ng-container *ngIf="doc1.TYPE!='TABLE'"><input type="checkbox" [disabled]='doc1.required' [(ngModel)]='doc1.HIDE'>Hide Section<i title="The entire section will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>				
					<ng-container *ngIf="!doc1['tableClass']&&doc1.TYPE!='PCATABLE'"><input type="checkbox" [(ngModel)]='doc1.NEW'>Add Page Break<i title="Section will print on a new page." class="fas fa-info-circle ml-1"></i><br></ng-container>
					<ng-container *ngIf="doc1.TYPE=='TABLE'||doc1.TYPE=='COSTTABLE'">		
						<label style="width:50%" >Table border class</label><input type="text" maxlength="20" [(ngModel)]='doc1.borderClass'style="width:40%" (change)="addTableClass($event,doc1)"><br>
					</ng-container>
					
					<button *ngIf="!doc1['tableClass']" type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn" (click)="getPosition(doc1.id, $event,i,j); moveShow=true;toMove(doc1)"><span style="font-size:.8em;">Move To</span></button>
					<!--<div *ngIf="otherTypes.indexOf(doc1.TYPE)==-1&&summaryStatus&&!doc1.data">
						<hr class="line3">
						<label>Summary Category: </label>
						<select class="costInput" style="width:90%; font-size: 11px;" (change)="selSummaryCat(doc1, $event, 'cat')">
							<option value="">Please Select Category</option>
							<option *ngFor="let item of summaryCategory" [value]="item" [selected]="item==doc1.summaryPara?.cat">{{item}}</option>
						</select>						
					</div>-->
					<ng-container *ngIf="doc1.TYPE=='TABLE'&&(!doc1.data?.erisName)">
						<hr class="line3">		
						<p class="opBtn1" (click)="copyTableData(doc1); optionShow=false;">Copy Table</p>
						<p class="opBtn1" (click)="getPosition(doc1.id, $event,i, j); pasteTableData('O', doc1.id);op52.hide();">Paste Table</p>
					</ng-container>	
					<ng-container *ngIf="doc1.TYPE=='PCATABLE'">
						<hr class="line3">
						<input type="radio" [checked]='lpagesize=="legal-landscape"' name="pagesize" (change)="savePDFconfig('legal-landscape')"/>Print in Landscape Legal Size<br>
						<input type="radio" [checked]='lpagesize=="ledger-landscape"' name="pagesize" (change)="savePDFconfig('ledger-landscape')"/>Print in Landscape Ledger Size<br>
					
						<hr class="line3">
						<ng-container *ngIf="doc1['ZOOM']">
							<input type="radio" [checked]='pcaTableSize=="all"' name="tablesize" (change)="savePcaTableConfig($event,'tableSize', doc1)" value="all"/>Print All Years <br>
							<input type="radio" [checked]='pcaTableSize=="split"' name="tablesize" (change)="savePcaTableConfig($event,'tableSize', doc1)" value="split"/>Split Years for PDF<br>
							<div class="yearSplitContent" *ngIf="pcaTableSize=='split'&&pcaTableSetting">
									<input type="checkbox" class="yearchk" [checked]="pcaTableSetting[0]['selected']" (change)="setPcaTablePage($event, 0)"><label class="yearLabel">First Table from: </label>
								<input class="yearInput" id="start0" [(ngModel)]="pcaTableSetting[0]['start']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[0]['start'] !=1|| pcaTableSetting[0]['start'] >= pcaTableSetting[0]['end'] ? 'red' : 'black'}">
								To: <input class="yearInput" id="end0" [(ngModel)]="pcaTableSetting[0]['end']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[0]['start'] > pcaTableSetting[0]['end'] || pcaTableSetting[0]['end'] > pcaOp.reserve ||(pcaTableSetting[1]['selected']&& ((pcaTableSetting[0]['end'] + 1 )!= pcaTableSetting[1]['start']))||(!pcaTableSetting[1]['selected']&&pcaTableSetting[0]['end'] != pcaOp.reserve)? 'red' : 'black'}"><br>
								<input type="checkbox" class="yearchk" [checked]="pcaTableSetting[1]['selected']" (change)="setPcaTablePage($event, 1)"><label class="yearLabel">Second Table from: </label>
								<input class="yearInput" id="start1" [(ngModel)]="pcaTableSetting[1]['start']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[1]['start'] > pcaTableSetting[1]['end'] || ( pcaTableSetting[0]['end'] + 1 )!= pcaTableSetting[1]['start'] ? 'red' : 'black'}">
								To: <input class="yearInput" id="end1" [(ngModel)]="pcaTableSetting[1]['end']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[1]['start'] > pcaTableSetting[1]['end'] || pcaTableSetting[1]['end'] > pcaOp.reserve ||(pcaTableSetting[2]['selected']&&( pcaTableSetting[1]['end'] + 1 )!= pcaTableSetting[2]['start'])||(!pcaTableSetting[2]['selected']&&pcaTableSetting[1]['end'] != pcaOp.reserve) ? 'red' : 'black'}"><br>
								<input type="checkbox" class="yearchk" [checked]="pcaTableSetting[2]['selected']" (change)="setPcaTablePage($event, 2)"><label class="yearLabel">Third Table from: </label>
								<input class="yearInput" id="start2" [(ngModel)]="pcaTableSetting[2]['start']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[2]['start'] > pcaTableSetting[2]['end'] || ( pcaTableSetting[1]['end'] + 1 )!= pcaTableSetting[2]['start'] ? 'red' : 'black'}">
								To: <input class="yearInput" id="end2" [(ngModel)]="pcaTableSetting[2]['end']" type="number" [max]="pcaOp.reserve" min="1" step="1" [ngStyle]="{'color': pcaTableSetting[2]['start'] > pcaTableSetting[2]['end'] || pcaTableSetting[2]['end'] != pcaOp.reserve ? 'red' : 'black'}"><br>
								<label *ngIf="!pcaTableValidate" style="color:orange">Please Check your year input</label>
							</div>
							<button type="button" class="btn btn-outline-light btn-sm mr-4 mb-1 pt-0 pb-0 pl-1 pr-1 yellowBtn" (click)="savePcaTablePage(doc1, op52)"><span style="font-size:.8em;">Save setting</span></button>
						</ng-container>
					</ng-container>
					<div *ngIf="otherTypes.indexOf(doc1.TYPE)==-1&&tempInfo?.PCA_INDICATOR=='4099e'&&!doc1.data">
						<hr class="line3">
						<label>Fannie Mae Category: </label>
						<select class="costInput" style="width:90%; font-size: 11px;" (change)="selFmeUl(doc1, $event, 'cat',op52, doc1.id+'popbtn')">
							<option value="">Please Select Fannie Mae Category</option>
							<option *ngFor="let item of capitalCategory; let i=index" [value]="item.label" [selected]="item.label==doc1.ul?.cat">{{item.label}}</option>
						</select>
						<div *ngIf="doc1.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label class="fmeLabel">Average EUL (yr): </label>
							<label class="fmeLabel">Effective Age (yr): </label>
							<input  class="fmeInput" type="number" min="0" [(ngModel)]='doc1.ul.EUL'  (change)="selFmeUl(doc1, $event, 'EUL')">
							<input  class="fmeInput" type="number" min="0" [(ngModel)]='doc1.ul.EFF'  (change)="selFmeUl(doc1, $event, 'EFF')">
						</div>
						<div  *ngIf="doc1.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
							<label  class="fmeLabel">Rating: </label>
							<label class="fmeLabel"></label>
							<select class="fmeInput" (change)="selFmeUl(doc1, $event, 'RATING')">
								<option value="">Select Rating</option>
								<option *ngFor="let item of ratingOps; let i=index" [value]="item" [selected]="item==doc1['ul'].RATING">{{item}}</option>
							</select>							
						</div>
					</div>					
					<ng-container *ngIf="doc1.TYPE!='PCATABLE'&&(!doc1.tableClass)&&(doc1.TYPE!='4099e')">
						<hr class="line3">
						<input type="checkbox" [checked]='doc1.landscape' name="pagesize" (change)="setPageSize(doc1, $event)"/>Print in Landscape<br>
					</ng-container>
					<ng-container *ngIf="doc1.SUB_SECTIONS?.length==0||!doc1.SUB_SECTIONS||(doc1.text&&doc1.text.length>0)">
						<hr class="line3">
						<input type="checkbox" [(ngModel)]='doc1.wcompleted'>Writing Complete<br>
						<input type="checkbox" [(ngModel)]='doc1.rcompleted'>Review Complete<br>
					</ng-container>
					<hr class="line3">
					<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn" (click)="saveTemplate(); op52.hide();"><span style="font-size:.8em;">Save</span></button>
			    </div>
				</div>
            </ng-template>
        </p-overlayPanel>
		<a *ngIf="(otherTypes.indexOf(doc1.TYPE)==-1&&doc1.SECTION_SEQUENCE&&doc1.SECTION_SEQUENCE.length>0)&&summaryStatus&&!doc1.data" class="psBtn"  [ngStyle]="{'color':doc1.pisummarydata||doc1.pcasummarydata?'#c2d63e':'#999','border-color':doc1.pisummarydata||doc1.pcasummarydata?'#c2d63e':'#999'}" title="Project Summary" (click)="editPs(doc1)">PS</a>
		<!--<i *ngIf="((!doc1?.data?.erisName&&doc1.TYPE=='TABLE')||(doc1.id=='pca_summary_0'))&&(curId==doc1.id)" class="btn-blue fas fa-toolbox tablebtn" (click)="op70.toggle($event); getPosition(doc1.id,$event,i,j); curSec=doc1"></i>
			<p-overlayPanel #op70  [appendTo]="'body'" [showCloseIcon]="true"  [dismissable]="true" [style]="{width: '190px'}">
            <ng-template pTemplate>
                <div style="width: 180px; margin:0; padding-right:0; color:#C2D63F;font-size:.8em"> 
					<label style="font-weight:bold">Tools</label><br>
					<button type="button" [disabled]="curSec.id=='pca_summary_0'" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="hideRows(doc1)">Hide Rows</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="deleteRows(doc1)">Delete Rows</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(doc1)">Clear Selection</button>
					
					<div style="font-size:.8em; color:#C2D63F; ">
							<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
							<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
							<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
							<select style="width:70px; height:20px;">
								<option>Left</option>
								<option selected>Center</option>
								<option>Right</option>
							</select>
							<a href="javascript:void(0)" [ngClass]="{'disabled':curSec.id=='pca_summary_0'}" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
						
					</div>                                       
				
				
				</div>
            </ng-template>
        </p-overlayPanel>-->
			<br>
			
			<ng-container *ngIf="doc1.id==curId">
			<div  class="ckContainer" *ngIf='allEditor.indexOf(doc1.id)>-1||(doc1.text&&doc1.text.length>0)'>
			<app-paragraph class="docItem" [editorType]="'temp'" [addedSlot]="doc1.addedItem"  [content]="doc1.text" [getText]="doc1['reqIndex']" (selected)="selectedRow=-1;selectedCell=null;getPosition(doc1.id,$event,i,j)"  (onExit)='textData($event,doc1.id)'></app-paragraph>
			<button class="btn btn-outline-light rf-btn" [ngClass]="{'hasLibs':doc1.libs?.length>0}" (click)="libToSlot=false;getPosition(doc1.id,$event,i,j);  filteredData=null;selectedRow=-1;selectedCell=null;showLibs(doc1);op61.toggle($event);">Libraries</button>
			<button class="btn btn-outline-light rf-btn ml-1 mr-2" [ngClass]="{'hasLibs':doc1.slots?.length>0}" (click)="slotToLib=false; getPosition(doc1.id,$event,i,j); filteredData=null;selectedRow=-1;selectedCell=null;showSlots()">Repeat Fields</button>					
			<input type="checkbox" (change)="slotToLib=false; getPosition(doc1.id,$event,i,j); filteredData=null;selectedRow=-1;selectedCell=null;setTextType($event)" [checked]="doc1.intro"><label class="libOption">Instruction</label>
			<p-overlayPanel #op61 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-left:0; color:#C2D63F;font-size:.8em"> 
					<div *ngIf="doc1.libs"   cdkDropList [cdkDropListData]="doc1.libs" (cdkDropListDropped)="dropLib($event,doc1.libs )">
					<div *ngFor="let item of doc1.libs; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="item" class="libItem">
					<div class="listItem2">
					<label class="col-md-9 p-0 m-0"  style="color:white">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op611.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Delete" (click)="getPosition(doc1.id,$event,i,j);removeLib(item)"><i class="fas fa-trash" style='font-size:.8em'></i></a>
					</div>
					<p-overlayPanel #op611 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>														
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</div>
					</div>					
				</div>
				</ng-template>
			</p-overlayPanel>
			</div>
			</ng-container>
			<div *ngIf="doc1.id!=curId" class="puretext" (click)="getPosition(doc1.id, $event,i,j)">
			<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-")>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&!doc1?.intro' style="width:100%; padding:10px; margin:0" class="replaceContainer" data-type="text" [attr.data-id]="doc1.id"  [innerHtml]="doc1.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
			</div>
			
			</div>
			<ng-container *ngIf="doc1.id!=curId">
			<div class="intro"   (click)="getPosition(doc1.id, $event,i,j)" *ngIf='(allEditor.indexOf(doc1.id)>-1&&otherTypes.indexOf(doc1.TYPE)==-1||(doc1.text&&doc1.text.length>0))&&doc1?.intro'>
				<button class="intro-btn btn btn-sm">Instruction Only</button>
				<div [innerHTML]='doc1.text' style="width:100%; margin:0"></div>
			</div>
			</ng-container>
			<div *ngIf="(doc1.TYPE=='SEALS'&&doc1.seals&&doc1.seals.length>0)||(doc1.TYPE=='SIGNS'&&doc1.signs&&doc1.signs.length>0)" style="width:100%; padding:0" >
			<div class="row">
			<ng-container *ngFor="let photo of doc1.signs; let s=index; trackBy:trackByFuntion">
				<div *ngIf="!photo['ALIGN']||photo['ALIGN']=='D'" class="gallery1">
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'&&photo.TYPE=='signature'" class="col-md-12" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line">
							<div *ngIf="tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='N'&&photo.TYPE=='signature'" class="col-md-12">
					<div  class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:100%;vertical-align:bottom">
					</div>
					<p class="desc1">{{photo.NAME}}</p>
					<p class="desc1">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
					
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='N'&&photo.TYPE=='signature'" class="col-md-12" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span  [ngClass]="{'under-line':photo.underline}">
							<div class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="photo.signatureTemplate" class="col-md-12">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc1.id,$event,i,j);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				</div>
				<div *ngIf="photo['ALIGN']&&photo['ALIGN']!='D'" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
					<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'&&photo.TYPE=='signature'" class="col-md-6" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line">
							<div *ngIf="tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='N'&&photo.TYPE=='signature'" class="col-md-6">
					<div  class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:100%;vertical-align:bottom">
					</div>
					<p class="desc1">{{photo.NAME}}</p>
					<p class="desc1">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
					
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='N'&&photo.TYPE=='signature'" class="col-md-6" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span  [ngClass]="{'under-line':photo.underline}">
							<div class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="photo.signatureTemplate&&(!(tempInfo&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" class="gallery1">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc1.id,$event,i,j);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" class="ml-3" title="Remove Signature" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				<div *ngIf="photo.signatureTemplate&&tempInfo&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;">
					<div  style="padding:10px; margin: 0;width:50%" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
					<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc1.id,$event,i,j);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
					<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
				</div>
				</div>
				</ng-container>
			<ng-container *ngFor="let photo of doc1.seals; let s=index; trackBy:trackByFuntion">
				
				<div *ngIf="photo.TYPE=='seal'" class="gallery1">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
					</div>
					<a href="javascript:void(0)" class="removeFile1" style="margin:0 4px" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('seals', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					
				</div>
				
			</ng-container>
			</div>
		</div>
		<table *ngIf="doc1.TYPE=='PITABLE'&&doc1.data" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
			<thead>
			<tr>
				<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
					<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;">
						<span style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}"  class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span>
					</th>
				</ng-container>
			</tr>
			</thead>
			<tbody>
			<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
				<tr *ngIf="r.length>1">
					<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
						<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
							<span *ngIf="!k.refId&&(!k.secHtml)"  >{{k.data}}</span>
							<span *ngIf="!k.refId&&k.secHtml"  class="replaceContainer" data-type="pitable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.secHtml?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<a *ngIf="k.refId" href="javascript:void(0)" (click)="scrollTo(k.refId)" style="color:#000; margin-left: 2px;">{{k.data}}</a>
						</td>														
					</ng-container>
				</tr>
				<tr *ngIf="r.colspan">
					<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold; border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top">
						{{k.data}}
					</td>
				</tr>
			</ng-container>
			</tbody>
		</table>
		<ng-container *ngIf="doc1['tableClass']=='PCA'">
			<table style="width:100%; font-size:11px; font-family:Arial, sans-serif;border: none;border-collapse: collapse;margin-top: 10px" [ngClass]="{'pcasummary':headerClass=='PCA', 'phase1summary':headerClass=='PHASE1'}">
				<thead>
					<tr *ngIf="!doc1.OHEADER">
						<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
							<th *ngIf='!h["hide"]' [ngStyle]="{'width':h.width+h.unit, 'border':h.border}" style="font-weight: bold;text-align: center;" [ngClass]="h.bk">
								<app-editable [text]="h.NAME" style="font-weight:bold" (edited)="changeLabel1($event, doc1, o)"></app-editable>
							</th>	
						</ng-container>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
						<tr *ngIf="!r[0]['rowhide']">
							<td *ngIf="doc1.id=='pca_summary_0'" style="color:#555; background:white; padding:4px; font-size:11px; cursor: pointer;" (click)="getPosition(doc1.id,$event,i,j);selectToggle($event, doc1, h);selectedCell=null;" [ngClass]="{'selected':r.selected}">
								<span class="pi pi-bars" (click)="selectedCell=null;getPosition(doc1.id,$event,i,j); selectedRow=h;"></span>
							</td>
							<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
								<ng-container *ngIf="!k.colspan">
									<td *ngIf='(!k.secHtml||doc1.id!="pca_summary_0")&&(!k["hide"]||doc1.id!="pca_summary_1")' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':doc1.id!='pca_summary_0'?k.border:'1px #ddd solid','padding-left':k.sub}" (dblclick)="selectCell(doc1, h, doc1.data.cols[q], k);getPosition(doc1.id,$event,i,j)">
									   <a *ngIf="q==0&&k.refId" href="javascript:void(0)" style="color:black" (click)="scrollTo(k.refId)">{{k.data}}</a>
									   <ng-container *ngIf="!k.refId||q>0">
											<ng-container *ngIf="k.data=='NaN'||k.data==0||k.data=='0'">
											</ng-container>
											<ng-container *ngIf="k.data!='NaN'&&k.data!=0&&k.data!='0'">
												<span class="replaceContainer" data-type="pitable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.data|highlighter:searchText:caseOn:allMatchtext"></span>
											</ng-container>
									   </ng-container>
									</td>
									<td *ngIf='k.secHtml&&doc1.id=="pca_summary_0"' [ngStyle]="{'text-align':doc1.data.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'padding-left':k.sub}" (dblclick)="selectCell(doc1, h, doc1.data.cols[q], k);getPosition(doc1.id,$event,i,j)">
										<span  class="replaceContainer" data-type="pstable" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]="k.secHtml.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
									</td>
								</ng-container>
								<ng-container  *ngIf="k.colspan">
									<td [attr.colspan]='k.colspan' [ngStyle]="{'text-align':k.celAllign, 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border}">
										{{k.data}}
									</td>
								</ng-container>		
							</ng-container>
						</tr>
					</ng-container> 
				</tbody> 
			</table>
		</ng-container> 
		<table *ngIf="doc1.TYPE=='4099e'" style="width:100%; font-size:11px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
			<tr *ngIf="doc1.header">
				<ng-container *ngFor="let h of doc1.data.cols; let o=index; trackBy:trackByFuntion">
					<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign, 'background-color':h.bk}"  class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext">
					</th>	
				</ng-container>
			</tr>
			<ng-container *ngFor="let r of doc1.data?.rows; let h=index; trackBy:trackByFuntion">
				<tr *ngIf="r.length>1">
					<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
						<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign, 'background-color':k.bk , 'font-weight':k.weight, width:doc1.data.cols[q].width+doc1.data.cols[q].unit, 'border':k.border}">{{k.data}}
							<a *ngIf="k.RF"><i style="margin-left: 5px" class="far fa-list-alt"></i></a>
						</td>		
					</ng-container>
				</tr>
				<tr *ngIf="r.length==1">
					<td colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign, 'background-color':r[0].bk, 'font-weight':r[0].weight,  'border':r[0].border}">{{r[0].data}}
					</td>
				</tr>
			</ng-container>  
		</table>
			<table *ngIf="((doc1.TYPE=='TABLE'&&doc1.data?.erisName)||doc1.TYPE=='COSTTABLE'||doc1.TYPE=='PCATABLE')&&doc1.data" style="width:100%; font-size:11px; font-family:Arial, sans-serif;">
  <tr style="background-color:#eeeeee;">
  <th *ngIf="doc1.TYPE=='TABLE'&&(!doc1.data.erisName)" style="width:40px"></th>
    <ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
	<th  *ngIf="(!h.hide||h.hide=='N')&&doc1.TYPE!='PCATABLE'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}"><app-editable [text]="h.NAME" style="font-weight:bold" (edited)="selCell(o); changeLabel($event)" (focused)="getPosition(doc1.id,$event,i, j);addLib=false; " [defaultText]='"Header"'></app-editable>
	</th>
	<th  *ngIf="(!h.hide||h.hide=='N')&&doc1.TYPE=='PCATABLE'"><app-editable [text]="h.NAME" style="font-weight:bold" (edited)="selCell(o); changeLabel($event)" (focused)="getPosition(doc1.id,$event,i, j);addLib=false; " [defaultText]='"Header"'></app-editable>
	</th>
	<!--<th *ngIf="h.type=='dropdown'">
	
	</th>-->
	</ng-container>
  </tr>
  <ng-container *ngIf="doc1.data?.src==0||doc1.data?.src==2||(!doc1.data?.src);">
  <ng-container *ngFor="let r of doc1.data?.rows; let h=index; trackBy:trackByFuntion">
  <tr *ngIf="r.length>1">
	<td *ngIf="doc1.TYPE=='TABLE'" style="font-size:.8em; background-color:#eeeeee; width:40px">
	<a href="javascript:void(0)" class="btn btn-sm btn-link" (click)="op100.show($event);getPosition(doc1.id,$event,i, j);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'white':null}">{{h+1}}</a>
		<p-overlayPanel #op100 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                               
				<div *ngIf="selectedRow>-1" style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0  pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0  pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)"><i class="fas fa-trash iconBtn smIcon"></i></a>
			<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1" min="0" max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
						<select  style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>
				</ng-template>
            </p-overlayPanel>
	</td>
    <ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
		<td *ngIf="!k.hide||k.hide=='N'" [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j}">
			<app-editable *ngIf="(!k.choice||k.choice?.length==0)&&doc1.TYPE=='TABLE'" [text]="k.DATA" (edited)="selCell(h,q); changeLabel($event)" (focused)="getPosition(doc1.id,$event,i, j);addLib=false; " [defaultText]='"Text"'></app-editable>
			<a (click)="op.toggle($event);" *ngIf="(!k.choice||k.choice?.length==0)&&doc1.TYPE=='TABLE'" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j ? 'white' : '#ccc' }" title="Add Options"><i class="far fa-list-alt"></i></a>
			<!--<a (click)="op3.toggle($event);" *ngIf="(!k.choice||k.choice?.length==0)&&doc1.TYPE=='COSTTABLE'" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j ? 'white' : '#ccc' }" title="Add Options"><i class="far fa-list-alt"></i></a>-->
			<a *ngIf="(!k.choice||k.choice?.length==0)&&doc1.TYPE=='COSTTABLE'&&q==0" data-target='#costLibModal' data-toggle="modal" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q);libToSlot=false;getCostLib()" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j ? 'white' : '#ccc' }" title="Add Options"><i class="far fa-list-alt"></i></a>
			<a *ngIf="k.choice&&k.choice?.length>0" href="javascript:void(0)" (click)="getPosition(doc1.id,$event,i, j); selectedRow=-1;selCell(h,q);libToSlot=false; showSlot(k.choice);op.toggle($event);" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j ? 'white' : 'rgb(195,212,47)' }" title="{{ doc1.TYPE=='COSTTABLE' ?  'Cost Recs' :'Repeat Fields'}}"><i style="font-size:16px" class='fas fa-angle-down'></i></a>
			<!--<a *ngIf="k.choice&&k.choice?.length>0&&k.choice[0].LIBRARY_ID>-1" (click)="op.toggle($event); getPosition($event,i, j);showLib(k.choice)" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j ? 'white' : 'rgb(195,212,47)' }" title="Libraries">LIB</a>-->
			<p-overlayPanel  #op [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px', 'font-size':'12px'}">
                                                <ng-template pTemplate>
                                                    <div style="margin: 4px; color:#C2D63F;max-height:160px; overflow:auto"> 
														<h6>Add Options</h6>
														<button  *ngIf="doc1.TYPE=='TABLE'" class="btn btn-outline-light btn-sm" style="font-size:12px; padding:0 2px; margin:2px" data-target='#libraryModal' data-toggle="modal" (click)="checkLib();getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q);libToSlot=false;showSelLibs()">Libraries</button>
														<button  *ngIf="doc1.TYPE=='COSTTABLE'" class="btn btn-outline-light btn-sm" style="font-size:12px; padding:0 2px; margin:2px" data-target='#costLibModal' data-toggle="modal" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q);libToSlot=false;getCostLib(k.choice)">Libraries</button>
														<button *ngIf="doc1.TYPE=='TABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q); slotToLib=false; addSlotPosi(); filteredData=null; showSelSlots()">Repeat Fields</button>					
														<button *ngIf="doc1.TYPE=='TABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q); slotToLib=false; addSlotPosi(); filteredData=null; clearChoice()">Clear</button>	
														<br>
														<ng-container *ngFor="let item of k.choice; let i=index; trackBy:trackByFuntion">
														<span *ngIf="!item.LIBRARY_ID&&!item.COST_LIBRARY_ID">{{item}}<br></span>
														<label *ngIf="((item.COST?.length>=0)||(item.CONTENT&&item.CONTENT?.length>0))&&!(!item.LIBRARY_ID&&!item.COST_LIBRARY_ID)" class="col-md-10 p-0 m-0"> {{item.KEY}}{{item.ITEM_TITLE}}</label>
															<a *ngIf="((item.COST?.length>=0)||(item.CONTENT&&item.CONTENT?.length>0))&&!(!item.LIBRARY_ID&&!item.COST_LIBRARY_ID)" class="float-right col-md-2 p-0 m-0" href="javascript:void(0)" title="Preview" (click)="op9.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
															
															<p-overlayPanel #op9 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}" (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>		
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																	
																		</div>
																	</div>																	
																</ng-template>
															</p-overlayPanel>
													</ng-container>
													</div>
                                                </ng-template>
            </p-overlayPanel>
			<p-overlayPanel  #op3 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px', 'font-size':'12px'}">
                                                <ng-template pTemplate>
                                                    <div style="margin: 4px; color:#C2D63F;max-height:160px; overflow:auto"> 
														<h6>Add Options</h6>
														<button *ngIf="doc1.TYPE=='TABLE'" class="btn btn-outline-light btn-sm" style="font-size:12px; padding:0 2px; margin:2px" data-target='#libraryModal' data-toggle="modal" (click)="checkLib();getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q);libToSlot=false;">Libraries</button>
														<button  *ngIf="doc1.TYPE=='COSTTABLE'" class="btn btn-outline-light btn-sm" style="font-size:12px; padding:0 2px; margin:2px" data-target='#costLibModal' data-toggle="modal" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q);libToSlot=false;getCostLib(k.choice)">Libraries</button>
														<button *ngIf="doc1.TYPE=='TABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" (click)="getPosition(doc1.id,$event,i, j);selectedRow=-1;selCell(h,q); slotToLib=false; addSlotPosi(); filteredData=null; clearChoice()">Clear</button>	
														<br>
														<ng-container *ngFor="let item of k.choice; let i=index; trackBy:trackByFuntion">
														<span *ngIf="!item.LIBRARY_ID&&!item.COST_LIBRARY_ID">{{item}}<br></span>
														<label *ngIf="(item.COST?.length>=0)||(item.CONTENT&&item.CONTENT?.length>0)" class="col-md-10 p-0 m-0"> {{item.KEY}}{{item.ITEM_TITLE}}</label>
														<a *ngIf="(item.COST?.length>=0)||(item.CONTENT&&item.CONTENT?.length>0)" class="float-right col-md-2 p-0 m-0" href="javascript:void(0)" title="Preview" (click)="op9.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
															
															<p-overlayPanel #op9 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}"  (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngIf="item.LABELS">
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>
																		</ng-container>																			
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
															</p-overlayPanel>
													</ng-container>
													</div>
                                                </ng-template>
            </p-overlayPanel>
		</td>		
	</ng-container>
  </tr>
  <tr *ngIf="r.length==1&&doc1.data">
  <td style="font-size:.8em; background-color:#eeeeee; width:40px">
	<a  href="javascript:void(0)" class="btn btn-sm btn-link" (click)="op102.show($event);getPosition(doc1.id,$event,i, j);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j?'white':null}">{{h+1}}</a>
		<p-overlayPanel #op102 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                               
				<div *ngIf="selectedRow>-1"  style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)"><i class="fas fa-trash iconBtn smIcon"></i></a>
					<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" min="0" max="1000000000" value="1" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>
				</ng-template>
            </p-overlayPanel>
	</td>
		<td colSpan='{{doc1.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}" style="font-weight:bold">
			<app-editable [text]="r[0].DATA" (edited)="selCell(h,0); changeLabel($event)" (focused)="getPosition(doc1.id,$event,i, j);addLib=false; " [defaultText]='"Sub-Header"'></app-editable>
		</td>
  </tr>
  </ng-container>
  </ng-container>
</table>
<div *ngIf="doc1.id==curId" [ngClass]="{'hideSec':doc1.OTABLE}">
<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<div *ngIf="doc1.data&&(!doc1.data?.erisName)&&doc1.TYPE=='TABLE'">
	<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
	<table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&(!doc1.data?.erisName)" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
		<!--<caption *ngIf="doc1.data['caption']" [ngStyle]="{'border':doc1.data['caption']['border']?'solid 1px black':'none', 'text-align':doc1.data['caption']['align']?doc1.data['caption']['align']:'center'}">
			<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-v]='j' [innerHTML]="doc1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
		</caption>-->
		<thead>
			<ng-container *ngFor="let brow of doc1.data.beforeHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span *ngIf="!h.htmltext" style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span>
							<span *ngIf="h.htmltext" style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}"  class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						
						</th>
					</ng-container>
				</tr>
				<ng-container *ngFor="let brow of doc1.data.afterHeaders; let bindex=index">
					<tr>
						<ng-container *ngFor="let col of brow; let u=index">
							<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
								<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
							<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
								<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
				</ng-container>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top">
								<i *ngIf="doc1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
								<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
								<span *ngIf="k.DATA"  class="replaceContainer" data-type="table" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top">
							<span *ngIf="r.items[0].DATA"  class="replaceContainer" data-type="table" [attr.data-id]="doc1.id" [attr.data-x]='h' data-y='0' [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<i *ngIf="doc1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
						</td>
					</tr>
				</ng-container>
				</tbody>
	</table>        
  <!--<p-table [value]="doc1.data?.rows" selectionMode="multiple" [(selection)]="selectedrows" [metaKeySelection]="true" [columns]="doc1.data?.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, doc1.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, doc1)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="background:white;width:2rem;"></th>
            <th *ngFor="let col of columns; let s=index" style="background:white;vertical-align:middle; padding:1px" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn  pResizableColumn class="cellItem">
                <span *ngIf="!col.htmltext" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" class="headerCell" [innerHTML]="col.NAME"></span>
				<span *ngIf="col.htmltext" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" class="headerCell" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="selectCol(doc1, s, col);getPosition(doc1.id,$event,i,j)" class="float-right" style="cursor:pointer; margin-right:8px" title="Edit"><i class="far fa-edit" style="color:#ccc"></i></a>
		    </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index" [pSelectableRow]="rowData" [pSelectableRowIndex]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, doc1, index);selectedCell=null;getPosition(doc1.id,$event,i,j)" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null;getPosition(doc1.id,$event,i,j)"></span>
            </td>			
    		<ng-container *ngIf="rowData.items[0].colspan">
			<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(doc1, index, columns[0], rowData.items[0]);getPosition(doc1.id,$event,i,j)" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
				<span class="innerCell" *ngIf="rowData.items[0].DATA" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="op505.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op505 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
					<ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0])">Clear</a>
					</div>					
				</ng-template>
				</p-overlayPanel>
			</td>
			</ng-container>	
			<ng-container *ngIf="!rowData.items[0].colspan">
			<td *ngFor="let col of columns; let u=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[u].bkcolor? rowData.items[u].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(doc1, index, col, rowData.items[u]);getPosition(doc1.id,$event,i,j)" [ngClass]="{'rowHide':rowData.hide}">
				<span class="innerCell" *ngIf="rowData.items[u].DATA" [innerHTML]="rowData.items[u].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="op502.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[u].libs&&rowData.items[u].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op502 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
					<ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[u])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[u])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[u])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[u])">Clear</a>
					</div>					
				</ng-template>
				</p-overlayPanel>
			</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table>--> 
</div>
</div>	
<div *ngIf="doc1.id!=curId" [ngClass]="{'hideSec':doc1.OTABLE}" class='puretext' (click)="getPosition(doc1.id,$event,i,j);resetProp(doc1)">
	<button  *ngIf="doc1.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
	<table *ngIf="doc1.TYPE=='TABLE'&&doc1.data&&(!doc1.data?.erisName)" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
		<!--<caption *ngIf="doc1.data['caption']" [ngStyle]="{'border':doc1.data['caption']['border']?'solid 1px black':'none', 'text-align':doc1.data['caption']['align']?doc1.data['caption']['align']:'center'}">
			<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-v]='j' [innerHTML]="doc1.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
		</caption>-->
		<thead>
			<ng-container *ngFor="let brow of doc1.data.beforeHeaders; let bindex=index">
				<tr>
					<ng-container *ngFor="let col of brow; let u=index">
						<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
						<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
			</ng-container>
				<tr>
					<ng-container *ngFor="let h of doc1.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
							<i *ngIf="doc1.data['locked']&&doc1.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span *ngIf="!h.htmltext" style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span>
							<span *ngIf="h.htmltext" style="font-weight:bold" [ngStyle]="{'color':doc1.OHEADER?'#C4C4C4':'#444'}"  class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						
						</th>
					</ng-container>
				</tr>
				<ng-container *ngFor="let brow of doc1.data.afterHeaders; let bindex=index">
					<tr>
						<ng-container *ngFor="let col of brow; let u=index">
							<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
								<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
							<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
								<i *ngIf="doc1.data['locked']&&doc1.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc1.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
				</ng-container>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc1.data.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc1.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top">
								<i *ngIf="doc1.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
								<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
								<span *ngIf="k.DATA"  class="replaceContainer" data-type="table" [attr.data-id]="doc1.id" [attr.data-x]='h' [attr.data-y]='q' [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc1.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top">
							<span *ngIf="r.items[0].DATA"  class="replaceContainer" data-type="table" [attr.data-id]="doc1.id" [attr.data-x]='h' data-y='0' [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<i *ngIf="doc1.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
						</td>
					</tr>
				</ng-container>
				</tbody>
	</table>
</div>	
<div *ngFor="let doc2 of doc1.SUB_SECTIONS; let k=index; trackBy:trackByFuntion"  [ngClass]="{'hideSec':doc2.HIDE}" style="position:relative">
				<button  *ngIf="doc2.HIDE" class="hidden-btn btn btn-sm">Hidden Section</button>
				<!--<label class='seq' style="margin-left:20px" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}" (click)="getPosition(doc2.id, $event,i,j,k)">. . {{doc2.SECTION_SEQUENCE}}</label>-->
				<label  [id]="doc2.id+'content'"  style="font-weight:bold; width: 80%;" (click)="getPosition(doc2.id, $event,i,j,k)" style="font-weight:bold;width: 80%;" [ngClass]="{'blue':curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k, 'hideSec':doc2?.OTNAME||doc2?.OSNAME||doc2?.OPNAME}">. . {{doc2.SECTION_SEQUENCE}}<span *ngIf="doc2.SECTION_TITLE&&doc2.SECTION_TITLE.length>0" class="replaceContainer" [attr.data-id]="doc2.id" data-type="title" [innerHTML]="doc2.SECTION_TITLE|highlighter:searchText:caseOn:allMatchtext" ></span>
					<app-edit-input *ngIf="doc2.TYPE!='SEALS'&&doc2.TYPE!='SIGNS'" [text]="doc2.SECTION_TITLE" (edited)="getPosition(doc2.id,$event, i, j,k); changeTitle('content',$event,i,j,k)"></app-edit-input>
					<i *ngIf="doc2.TYPE=='PDFSEC'" class="btn-blue far fa-file-pdf" (click)="getPosition(doc2.id, $event, i, j, k);"></i>
					<i *ngIf="doc2.TYPE=='PHOTOS'" class="btn-blue fas fa-camera-retro"></i>
					<i *ngIf="doc2.TYPE=='TABLE'" title="Table Property" data-toggle='modal' data-target="#tableModal" class="btn-blue fas fa-table" (click)="selectedRow=-1;selectedCell=null;getPosition(doc2.id,$event,i, j, k); toCreateTable(i,j,k)"></i>
					<i *ngIf="(!(doc2.text&&doc2.text.length>0))&&(!(allEditor.indexOf(doc2.id)>-1))&&otherTypes.indexOf(doc2.TYPE)==-1"  class="btn-blue far fa-edit" (click)="getPosition(doc2.id,$event,i, j, k);selectedRow=-1;addEditor(doc2)"></i>
					<i *ngIf="doc2.TYPE=='TABLE'&&(!doc2.data?.erisName)"  class="btn-blue" title='Modify Table' (click)="getPosition(doc2.id,$event,i, j, k);modifyTable(doc2); selectedEditor='O'"><img src="/assets/images/icons8-edit-property-32.png" class="imageIcon"></i>
				</label>
				<ng-container *ngIf="summaryStatus&&summaryType=='PCA'&&doc2.TYPE=='COSTTABLE'">
						<select class="costInput mr-1" style="width:40%; font-size: 11px;" [disabled]="doc2.id!=curId" [ngStyle]="{'border':doc2['summaryCat']? 'none':'2px solid #F78181'}" (change)="selCostCat('summaryCat', $event, doc2)">
							<option></option>
							<option *ngFor="let item of summaryCategory; let i=index" [value]="item" [selected]="item==doc2['summaryCat']">{{item}}</option>
						</select>
					
				</ng-container>	
				<ng-container *ngIf="doc2.TYPE=='COSTTABLE'&&tempInfo.PCA_INDICATOR=='4099e'">
					<!--<i class="btn-blue far fa-plus-square" title="Add Cost Recommendation Item" (click)="getPosition(doc2.id,$event,i,j,k);selectedRow=-1;selectedCell=null;getCostData(doc2.id)"></i>-->
					<select class="costInput" style="width:40%" [ngStyle]="{'border':doc2.long?.length>0? 'none':'2px solid #F78181'}" style="width:40%; font-size: 11px;" (change)="selFmeCost(doc2, $event)">
						<option>Please Select Fannie Mae Category</option>
						<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.id==doc2.long">{{item.label}}</option>
					</select>
				</ng-container>
				<ng-container *ngIf="doc2.TYPE=='COSTTABLE'&&tempInfo.PCA_INDICATOR=='frm1105'">
					<select class="costInput" style="width:40%; font-size: 12px" [ngStyle]="{'border':doc2.cat? 'none':'2px solid #F78181'}" (change)="selFrmUl(doc2, $event, 'cat')">
						<option value="-1">Please Select Freddie Mac Category</option>
						<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.tag==doc2.cat">{{item.label}}</option>
					</select>
				</ng-container>
				<span class="opBtn" [attr.data-id]="doc2.id+'popbtn'" (click)="checkParentSeq(doc.DISPLAY_SEQUENCE, doc1.DISPLAY_SEQUENCE);  op53.toggle($event);">Options <i class="fas fa-angle-down"></i></span>
				
		<!--<i class="brn btn-outline-dark btn-small fas fa-cog p-2 float-md-right" (click)="op53.toggle($event);"></i>-->
				<p-overlayPanel #op53  [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true" [style]="{width: '280px'}">
					<ng-template pTemplate>
						<div style="width: 240px; margin:0; padding-right:0; color:white;font-size:.8em"> 
							<label style="font-weight:bold">Set Section Rules</label><i title="Section will print on a new page." class="fas fa-info-circle"></i><br>
							<ng-container *ngIf="doc2.TYPE=='PDFSEC'">
								<span class="cplabel">Upload PDF</span><i class="fas fa-cloud-upload-alt iconBtn" (click)="upload('pdf'); curDoc=doc2"></i>
								<a *ngIf="doc2.pdf?.length>0" [href]="doc2.pdf" target=_blank ><label style="width:200px; font-size:11px">{{doc2.pdfName}}</label></a>
								<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47); display:inline-block"></span><br>
								<button type="button" class="btn btn-outline-light btn-sm mr-4  mb-1 pt-0 pb-0 pl-1 pr-1" (click)="doc2.pdf=''; doc2.pdfName='';"><span style="font-size:.8em;">Remove PDF</span></button>						
							</ng-container>
							<div *ngIf="doc2.TYPE!='PDFSEC'">
							<ng-container *ngIf="doc2.TYPE!='TABLE'&&doc2.TYPE!='PHOTOS'"><input type="checkbox"  [checked]="doc2?.DISPLAY_SEQUENCE=='N'" (click)="getPosition(doc2.id,$event,i, j, k); ifSeq($event, doc2)" [disabled]='noSeq'>Omit Section Number<i title="The section number will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br>
								<p *ngIf='noSeq' style="color:#F78181; margin: 0;font-size: .9em;">Could not find the upper level section number.</p>
							</ng-container>
							<ng-container *ngIf="doc2.TYPE!='TABLE'&&doc2.TYPE!='PHOTOS'"><input type="checkbox" [(ngModel)]='doc2.OSNAME'  (click)="ifSecTitle($event, doc2)">Omit Section Name<i title="The section name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
							<ng-container *ngIf="doc2.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='doc2.OTNAME'>Omit Table Name <i title="The table name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
							<ng-container *ngIf="doc2.TYPE=='TABLE'&&(!(doc2.data&&doc2.data.erisName))"><input type="checkbox" [disabled]="doc2['data']&&doc2['data']['locked']&&doc2['data']['locked']['header']" [(ngModel)]='doc2.OHEADER'>Omit Table Header<i title="Table header will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
							<ng-container *ngIf="doc2.TYPE=='PHOTOS'"><input type="checkbox" [(ngModel)]='doc2.OPNAME'>Omit Photo Name <i title="The photo name will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
							<ng-container *ngIf="doc2.TYPE=='TABLE'"><input type="checkbox" [(ngModel)]='doc2.OTABLE'>Hide Table<i title="The table will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>
							<input type="checkbox" [(ngModel)]='doc2.TOC'>Hide from TOC<i title="The section/table name will not print in TOC but will print in the report PDF." class="fas fa-info-circle ml-1"></i><br>
							<ng-container *ngIf="doc2.TYPE!='TABLE'"><input type="checkbox"[disabled]='doc2.required'  [(ngModel)]='doc2.HIDE'>Hide Section<i title="The entire section will not print in the report PDF." class="fas fa-info-circle ml-1"></i><br></ng-container>							
							<input type="checkbox" [(ngModel)]='doc2.NEW'>Add Page Break<i title="Section will print on a new page." class="fas fa-info-circle ml-1"></i><br>
							<ng-container *ngIf="doc2.TYPE=='TABLE'||doc2.TYPE=='COSTTABLE'">		
								<label style="width:50%" >Table border class</label><input type="text" maxlength="20" [(ngModel)]='doc2.borderClass'style="width:40%" (change)="addTableClass($event,doc2)"><br>
							</ng-container>
							<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn" (click)="getPosition(doc2.id, $event,i,j,k); moveShow=true;toMove(doc2)"><span style="font-size:.8em;">Move To</span></button>
							<div *ngIf="otherTypes.indexOf(doc2.TYPE)==-1&&tempInfo?.PCA_INDICATOR=='4099e'&&!doc2.data">
								<hr class="line3">
								<label>Fannie Mae Category: </label>
								<select class="costInput" style="width:90%; font-size: 11px;" (change)="selFmeUl(doc2, $event, 'cat', op52, doc2.id+'popbtn')">
									<option value="">Please Select Fannie Mae Category</option>
									<option *ngFor="let item of capitalCategory; let i=index" [value]="item.label" [selected]="item.label==doc2.ul?.cat">{{item.label}}</option>
								</select>
								<div *ngIf="doc2.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
									<label class="fmeLabel">Average EUL (yr): </label>
									<label class="fmeLabel">Effective Age (yr): </label>
									<input  class="fmeInput" type="number" min="0" [(ngModel)]='doc2.ul.EUL' (change)="selFmeUl(doc2, $event, 'EUL')">
									<input  class="fmeInput" type="number" min="0" [(ngModel)]='doc2.ul.EFF' (change)="selFmeUl(doc2, $event, 'EFF')">
								</div>
								<div  *ngIf="doc2.ul" class="row" style="margin-bottom: 0;padding-left: 10px;">
									<label  class="fmeLabel">Rating: </label><br>
									<label class="fmeLabel"></label>
									<select class="fmeInput" (change)="selFmeUl(doc2, $event, 'RATING')">
										<option value="">Select Rating</option>
										<option *ngFor="let item of ratingOps; let i=index" [value]="item" [selected]="item==doc2['ul'].RATING">{{item}}</option>
									</select>
								</div>
							</div>
							<ng-container *ngIf="doc2.TYPE=='TABLE'&&(!doc2.data?.erisName)">
								<hr class="line3">	
								<p class="opBtn1" (click)="copyTableData(doc2); optionShow=false;">Copy Table</p>
								<p class="opBtn1" (click)="getPosition(doc2.id, $event,i, j, k); pasteTableData('O', doc2.id); op53.hide();">Paste Table</p>
							</ng-container>							
							<ng-container *ngIf="doc2.TYPE!='PCATABLE'&&(!doc2.tableClass)&&(doc2.TYPE!='4099e')">
								<hr class="line3">
								<input type="checkbox" [checked]='doc2.landscape' name="pagesize" (change)="setPageSize(doc2, $event)"/>Print in Landscape<br>
							</ng-container>
							<ng-container *ngIf="doc2.SUB_SECTIONS?.length==0||!doc2.SUB_SECTIONS||(doc2.text&&doc2.text.length>0)">
								<hr class="line3">
								<input type="checkbox" [(ngModel)]='doc2.wcompleted'>Writing Complete<br>
								<input type="checkbox" [(ngModel)]='doc2.rcompleted'>Review Complete<br>
							</ng-container>
							<hr class="line3">
							<button type="button" class="btn btn-outline-light btn-sm pt-0 pb-0 pl-1 pr-1 yellowBtn" (click)="saveTemplate();  op53.hide();"><span style="font-size:.8em;">Save</span></button>
						</div>
					</div>
					</ng-template>
				</p-overlayPanel>
				<a *ngIf="(otherTypes.indexOf(doc2.TYPE)==-1&&doc2.SECTION_SEQUENCE&&doc2.SECTION_SEQUENCE.length>0)&&summaryStatus&&!doc2.data" class="psBtn"  [ngStyle]="{'color':doc2.pisummarydata||doc2.pcasummarydata?'#c2d63e':'#999','border-color':doc2.pisummarydata||doc2.pcasummarydata?'#c2d63e':'#999'}" title="Project Summary" (click)="editPs(doc2)">PS</a>
				<!--<i *ngIf="(!doc2?.data?.erisName&&doc2.TYPE=='TABLE')&&(curId==doc2.id)" class="btn-blue fas fa-toolbox tablebtn" (click)="op71.toggle($event);getPosition(doc2.id,$event,i,j,k);curSec=doc2"></i>
				<p-overlayPanel #op71  [appendTo]="'body'" [showCloseIcon]="true"  [dismissable]="true" [style]="{width: '190px'}">
				<ng-template pTemplate>
                <div style="width: 180px; margin:0; padding-right:0; color:#C2D63F;font-size:.8em"> 
					<label style="font-weight:bold">Tools</label><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="hideRows(doc2)">Hide Rows</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="deleteRows(doc2)">Delete Rows</button><br>
					<button type="button" class="btn btn-outline-light btn-sm mr-4 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.8em;" (click)="resetProp(doc2)">Clear Selection</button>
					<div style="font-size:.8em; color:#C2D63F; ">
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
							<input type="number" value="1"  min="0"   max="1000000000" style="width:70px; height:20px;"/>
							<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
							<select style="width:70px; height:20px;">
								<option>Left</option>
								<option selected>Center</option>
								<option>Right</option>
							</select>
							<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addCSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>                                       
				
				
				</div>
            </ng-template>
        </p-overlayPanel>-->
				<br>
				<ng-container *ngIf="doc2.id==curId">
				<div  class="ckContainer" *ngIf='allEditor.indexOf(doc2.id)>-1||(doc2.text&&doc2.text.length>0)'>
					<app-paragraph class="docItem" [editorType]="'temp'" [addedSlot]="doc2.addedItem"  [content]="doc2.text" (selected)="selectedRow=-1;selectedCell=null;getPosition(doc2.id,$event,i,j,k)" [getText]="doc2['reqIndex']" (onExit)='textData($event,doc2.id)'></app-paragraph>
					<button class="btn btn-outline-light rf-btn" [ngClass]="{'hasLibs':doc2.libs?.length>0}" (click)="libToSlot=false;getPosition(doc2.id,$event,i,j,k);  filteredData=null;selectedRow=-1;selectedCell=null;showLibs(doc2);op62.toggle($event);">Libraries</button>
					<button class="btn btn-outline-light rf-btn ml-1 mr-2" [ngClass]="{'hasLibs':doc2.slots?.length>0}" (click)="slotToLib=false; getPosition(doc2.id,$event,i,j,k); filteredData=null;selectedRow=-1;selectedCell=null;showSlots()">Repeat Fields</button>					
					<input type="checkbox" (change)="slotToLib=false; getPosition(doc2.id,$event,i,j,k); filteredData=null;selectedRow=-1;selectedCell=null;setTextType($event)" [checked]="doc2.intro"><label class="libOption">Instruction</label>
					<p-overlayPanel #op62 [appendTo]="'body'" [dismissable]="false"  [showCloseIcon]="true" [style]="{width: '260px'}">
				<ng-template pTemplate>
                <div style="width: 240px; max-height: 300px; overflow:auto; margin:0; padding-right:0; color:#C2D63F;font-size:.8em"> 
					<div *ngIf="doc2.libs"  cdkDropList [cdkDropListData]="doc2.libs" (cdkDropListDropped)="dropLib($event,doc2.libs )">
					<div *ngFor="let item of doc2.libs; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="item" class="libItem">
					<div class="listItem2">
					<label class="col-md-9 p-0 m-0">{{item.ITEM_TITLE}} <span *ngIf="item.STATUS!='Active'" class="inaciveMsg">({{item.STATUS}})</span></label>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Preview" (click)="op621.toggle($event);"><i class="pi pi-eye" style='font-size:.8em'></i></a>
					<a class="float-right p-0 mr-3" href="javascript:void(0)" title="Delete" (click)="getPosition(doc2.id,$event,i,j,k);removeLib(item)"><i class="fas fa-trash" style='font-size:.8em'></i></a>
					</div>
					<p-overlayPanel #op621 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}"  (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>	
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
						</p-overlayPanel>
					</div></div>									
				</div>
				</ng-template>
			</p-overlayPanel>
				</div>
				</ng-container>
				<div *ngIf="doc2.id!=curId" class="puretext" (click)="getPosition(doc2.id,$event,i, j, k)">
				<div *ngIf='(allEditor.indexOf(i.toString()+"-"+j.toString()+"-"+k.toString())>-1||(doc2.text&&doc2.text.length>0))&&!doc2?.intro'  style="padding:10px; margin:0" class="replaceContainer" data-type="text" [attr.data-id]="doc2.id"  [innerHtml]="doc2.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml">
				</div>
				</div>
				<ng-container *ngIf="doc2.id!=curId">
				<div class="intro"   (click)="getPosition(doc2.id,$event,i, j, k)" *ngIf='(allEditor.indexOf(doc2.id)>-1||(doc2.text&&doc2.text.length>0))&&doc2?.intro'>
					<button class="intro-btn btn btn-sm">Instruction Only</button>
					<div [innerHTML]='doc2.text' style="width:100%; margin:0"></div>
				</div>
				</ng-container>
				<div *ngIf="(doc2.TYPE=='SEALS'&&doc2.seals&&doc2.seals.length>0)||(doc2.TYPE=='SIGNS'&&doc2.signs&&doc2.signs.length>0)" style="width:100%; padding:0" >
			<div class="row">
			<ng-container *ngFor="let photo of doc2.signs; let s=index; trackBy:trackByFuntion">
				<div *ngIf="!photo['ALIGN']||photo['ALIGN']=='D'" class="gallery1">
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'&&photo.TYPE=='signature'" class="col-md-12" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line">
							<div *ngIf="tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='N'&&photo.TYPE=='signature'" class="col-md-12">
					<div  class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:100%;vertical-align:bottom">
					</div>
					
					<p class="desc1">{{photo.NAME}}</p>
					<p class="desc1">{{photo.TITLE}}
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc2.id,$event,i, j,k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
		
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='N'&&photo.TYPE=='signature'" class="col-md-12" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span [ngClass]="{'under-line':photo.underline}">
							<div class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="photo.signatureTemplate" class="col-md-12">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				</div>
				<div *ngIf="photo['ALIGN']&&photo['ALIGN']!='D'" class="gallery4" [ngClass]="{'alignCenter':photo['ALIGN']=='C','alignLeft':photo['ALIGN']=='L'}">
					<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'&&photo.TYPE=='signature'" class="col-md-6" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span style="align-self: flex-end"><label>{{photo['AUTHOR']}}</label><app-edit-input [text]="photo['AUTHOR']" [maxlength]='100' (edited)="editAuthor($event, photo)"></app-edit-input></span>
						<span class="under-line">
							<div *ngIf="tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc1.id,$event,i,j);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='N'&&photo.TYPE=='signature'" class="col-md-6">
					<div  class="gallery2">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:100%;vertical-align:bottom">
					</div>
					
					<p class="desc1">{{photo.NAME}}</p>
					<p class="desc1">{{photo.TITLE}}
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc2.id,$event,i, j,k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
		
				</div>
				<div *ngIf="!photo.signatureTemplate&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='Y'&&tempInfo['SPECIAL_SIGNATURE_FORMAT']!='N'&&photo.TYPE=='signature'" class="col-md-6" style="font-size: 10pt;">
					<div style="display:flex;vertical-align:bottom">
						<span [ngClass]="{'under-line':photo.underline}">
							<div class="gallery2">
								<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;width:auto;vertical-align:bottom">
							</div>
						</span>
					</div>
					<p class="desc3" style="font-weight: bold;margin-top: 10px;">{{photo.NAME}}</p>
					<p class="desc3" style="font-weight: bold;">{{photo.TITLE}}					
					<a href="javascript:void(0);" class="removeFile1" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);removeSeal('signs', photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a></p>
				</div>
				<div *ngIf="photo.signatureTemplate&&(!(tempInfo&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'))" class="gallery1">
					<div  class="gallery5" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<div [style.transform]="'translateX(' + getSignaturePosition(photo).offsetX + 'px)'">
						<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
						<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
						<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					</div>
				</div>
				<div *ngIf="photo.signatureTemplate&&tempInfo&&tempInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'" style="width:100%; padding:0; margin: 0;">
					<div  style="padding:10px; margin: 0;width:50%" [innerHTML]="photo.htmlSec?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<label *ngIf="photo['role']" class="roleLabel ml-3">(Role: {{photo['roleName']}}) </label>
					<a href="javascript:void(0);" class="ml-3" title="Edit Signature" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);editSign(photo)"><i class="fas fa-pen" style="font-size: 10px;"></i></a>
					<a href="javascript:void(0);" class="ml-2" title="Remove Signature" (click)="addLib=false; getPosition(doc2.id, $event, i, j, k);removeSeal('signs',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
				</div>
				</div>
				</ng-container>
				<ng-container *ngFor="let photo of doc2.seals; let s=index; trackBy:trackByFuntion">
			
				<div *ngIf="photo.TYPE=='seal'" class="gallery1">
					<div  class="gallery3">
						<img [src]="photo.FILE_URL" [alt]="photo.FILE_URL" style="max-height:100%;max-width:90%;vertical-align:bottom">
					</div>
					<a href="javascript:void(0)" class="removeFile1" style="margin:0 4px" (click)="addLib=false; getPosition(doc2.id,$event,i, j,k);removeSeal('seals',photo, s)"><i class="far fa-trash-alt" style="font-size: 10px;"></i></a>
					
				</div>
				
			</ng-container>
			</div>
		</div>
		<table *ngIf="doc2.TYPE=='1105-table'" style="width:100%; font-size:11px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
			<tr>
				<ng-container *ngFor="let h of doc2.data.cols; let o=index; trackBy:trackByFuntion">
					<th  [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold;border: 1px solid black"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext">
					</th>	
				</ng-container>
			</tr>
			<ng-container *ngFor="let r of doc2.data?.rows; let l=index; trackBy:trackByFuntion">
				<tr>
					<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
						<td class="cellItem"[ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'width':doc2.data.cols[q].width+doc2.data.cols[q].unit, 'border':k.border}">
							<span [ngStyle]="{'margin-left':k.sub?'20px':'none'}">{{k.data}}</span>
							<span *ngIf="k.sign">{{k.sign}}</span>
						</td>
					</ng-container>
				</tr>
			</ng-container>  
		</table>
		<table *ngIf="doc2.TYPE=='4099e'" style="width:100%; font-size:11px; font-family:Arial, sans-serif;border: 1px solid black;border-collapse: collapse;">
			<tr *ngIf="doc2.data.titlerow">
				<th  [ngClass]="doc2.data.titlerow[0].bk" [colSpan]="doc2.data.cols.length" [ngStyle]="{'width':doc2.data.titlerow[0].width+doc2.data.titlerow[0].unit,'text-align':doc2.data.titlerow[0].colAlign}" style="font-weight: bold;border: 1px solid black">{{doc2.data.titlerow[0].NAME}}
				</th>	
			</tr>
			<tr *ngIf="doc2.header">
				<ng-container *ngFor="let h of doc2.data.cols; let o=index; trackBy:trackByFuntion">
					<th  [ngClass]="h.bk" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="font-weight: bold;border: 1px solid black"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext">
					</th>	
				</ng-container>
			</tr>
			<ng-container *ngFor="let r of doc2.data?.rows; let l=index; trackBy:trackByFuntion">
				<tr>
					<ng-container *ngFor="let k of r; let q=index; trackBy:trackByFuntion">
						<td *ngIf="!k.colspan" [ngClass]="k.bk" class="cellItem"[ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'width':doc2.data.cols[q].width+doc2.data.cols[q].unit, 'border':k.border}">
							<a *ngIf="k.index" href="javascript:void(0)" [ngStyle]="{'font-weight':k.bold}" (click)="scrollTo(k.id, k.index)">{{k.data}}</a>
							<span *ngIf="k.sign">{{k.sign}}</span>
							<span class="innerCell" *ngIf="k.DATA&&(!k.ops)" [innerHTML]="k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<span class="innerCell" *ngIf="!k.DATA&&(!k.ops)&&!k.index">{{k.data}}</span>
							
							<a *ngIf="(k.RF||k.Manual)&&(!k.ops)" style="float:right;"  (click)="selectCell(doc2, l, doc2.data.cols[q], k)"><i style="color:#ccc; margin-right: 4px;" class="far fa-list-alt"></i></a>
							<select *ngIf="k.ops" style="float:right;" [(ngModel)]="k.data" >
								<option></option>
								<option *ngFor="let op of k.ops" [value]="op" [selected]="k.data==op">{{op}}</option>
							</select>
						</td>
						<td *ngIf="k.colspan"  [ngClass]="k.bk" colSpan='{{k.colspan}}' [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign, 'font-weight':k.weight, 'border':k.border}">
							<span *ngIf="k.sign">{{k.sign}}</span>{{k.data}}
									<a *ngIf="(k.RF||k.Manual)&&(!k.ops)" style="float:right;"  (click)="selectCell(doc2, l, doc2.data.cols[q], k)"><i style="color:#ccc; margin-right: 4px;" class="far fa-list-alt"></i></a>
									
						</td>			
					</ng-container>
				</tr>

			</ng-container>  
		</table>		
				<table *ngIf="((doc2.TYPE=='TABLE'&&doc2.data?.erisName)||doc2.TYPE=='COSTTABLE'||doc2.TYPE=='PCATABLE')&&doc2.data" style="width:100%; font-size:11px; font-family:Arial, sans-serif;">
  <tr style="background-color:#eeeeee;">
  <th  *ngIf="doc2.TYPE=='TABLE'&&(!doc2.data.SLOT_ID||!(doc2.data.SLOT_ID>-1))" style="width:40px"></th>
    <ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
	<th  *ngIf="!h.hide||h.hide=='N'" [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}"><app-editable [text]="h.NAME" style="font-weight:bold" (edited)="selCell(o); changeLabel($event)" (focused)="getPosition(doc2.id,$event,i, j,k);addLib=false; " [defaultText]='"Header"'></app-editable>
	</th>

	</ng-container>
  </tr>
  <ng-container *ngIf="doc2.data?.src==0||(!doc2.data?.src)">
  <ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
  <tr  *ngIf="r.length>1">
	<td  *ngIf="doc2.TYPE=='TABLE'" style="font-size:.8em; background-color:#eeeeee; width:40px">
		<a href="javascript:void(0)" class="btn btn-sm btn-link"  (click)="op101.show($event); getPosition(doc2.id,$event,i, j, k);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'white':null}">{{h+1}}</a>
		<p-overlayPanel #op101 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                                    
				<div *ngIf="selectedRow>-1"  style="font-size:.8em; color:#C2D63F; ">
					<label  style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2 pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2  pb-0 pt-0 pl-2 pr-2 float-right" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm mr-2  pb-0 pt-0 pl-1 pr-1 float-right" (click)="deleteRow(selectedRow)"><i class="fas fa-trash iconBtn smIcon"></i></a>
				<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above<br>
						<input type="number" value="1" min="0" max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
						<select style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>                                       </ng-template>
            </p-overlayPanel>
	</td>
    <ng-container *ngFor="let m of r; let q=index; trackBy:trackByFuntion">
		<td *ngIf="!m.hide||m.hide=='N'" [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" [ngClass]="{'active':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k}">
			<app-editable *ngIf="(!m.choice||m.choice?.length==0)&&doc2.TYPE=='TABLE'" [text]="m.DATA" (edited)="selCell(h,q); changeLabel($event)"  (focused)="getPosition(doc2.id,$event,i, j,k);addLib=false; " [defaultText]='"Text"'></app-editable>
	<i (click)="op13.toggle($event);"  *ngIf="(!m.choice||m.choice?.length==0)&&doc2.TYPE=='TABLE'" class="far fa-list-alt float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k ? 'white' : '#ccc' }" title="Add Options"></i>
			<a *ngIf="(!m.choice||m.choice?.length==0)&&doc2.TYPE=='COSTTABLE'&&q==0" data-target='#costLibModal' data-toggle="modal" (click)="getPosition(doc2.id,$event,i, j, k);selectedRow=-1;selCell(h,q);libToSlot=false;getCostLib()" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j ? 'white' : '#ccc' }" title="Add Options"><i class="far fa-list-alt"></i></a>
			<a *ngIf="m.choice&&m.choice.length>0" (click)="op13.toggle($event);getPosition(doc2.id,$event,i, j,k);selectedRow=-1;selCell(h,q);libToSlot=false;showSlot(m.choice)" class="float-right"  [ngStyle]="{'color':selectedCell?.col==q&&selectedCell?.row==h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k ? 'white' : 'rgb(195,212,47)' }" title="{{ doc2.TYPE=='COSTTABLE' ?  'Cost Recs' :'Repeat Fields'}}"><i style="font-size:16px" class='fas fa-angle-down'></i></a>
			<p-overlayPanel #op13 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px', 'font-size':'12px'}">
                                                <ng-template pTemplate>
                                                    <div style="margin: 4px; color:#C2D63F;max-height:160px; overflow:auto"> 
														<h6>Add Options</h6>
														<button *ngIf="doc2.TYPE=='TABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" data-target='#libraryModal' data-toggle="modal" (click)="checkLib();getPosition(doc2.id,$event,i, j,k); selectedRow=-1;selCell(h,q); libToSlot=false;showSelLibs()">Libraries</button>
														<button *ngIf="doc2.TYPE=='COSTTABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" data-target='#costLibModal' data-toggle="modal" (click)="getPosition(doc2.id,$event,i, j,k); selectedRow=-1;selCell(h,q); libToSlot=false;getCostLib(m.choice)">Libraries</button>
														<button *ngIf="doc2.TYPE=='TABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" (click)="getPosition(doc2.id,$event,i, j,k); selectedRow=-1;selCell(h,q); slotToLib=false; addSlotPosi(); filteredData=null;showSelSlots();">Repeat Fields</button>					
														<button *ngIf="doc2.TYPE=='TABLE'" class="btn btn-outline-light btn-sm"  style="font-size:12px; padding:0 2px; margin:2px" (click)="getPosition(doc2.id,$event,i, j,k);selectedRow=-1;selCell(h,q); slotToLib=false; addSlotPosi(); filteredData=null; clearChoice()">Clear</button>	
														<br>
														<ng-container *ngFor="let item of m.choice; let i=index; trackBy:trackByFuntion">
														<label  class="col-md-10 p-0 m-0" *ngIf="!item.LIBRARY_ID&&!item.COST_LIBRARY_ID">{{item}}</label>
														<label  *ngIf="((item.COST?.length>=0)||(item.CONTENT&&item.CONTENT?.length>0))&&!(!item.LIBRARY_ID&&!item.COST_LIBRARY_ID)" class="col-md-10 p-0 m-0"> {{item.KEY}}{{item.ITEM_TITLE}}</label>
														<a  *ngIf="((item.COST?.length>=0)||(item.CONTENT&&item.CONTENT?.length>0))&&!(!item.LIBRARY_ID&&!item.COST_LIBRARY_ID)" class="float-right col-md-2 p-0 m-0" href="javascript:void(0)" title="Preview" (click)="op9.toggle($event);"><i class="pi pi-eye"  style='font-size:.8em'></i></a>
														<br>	
															<p-overlayPanel #op9 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '300px', 'font-size':'12px'}"  (onShow)="getSftContent(item)">
																<ng-template pTemplate>
																	<div  style="color:#C2D63F; max-height:400px; overflow:auto"> 
																		<h6>{{item.ITEM_TITLE}}</h6>
																		<ng-container *ngIf="item.LABELS">	
																		<ng-container *ngFor="let label of item.LABELS.split(';'); trackBy:trackByFuntion">
																			<label class="tag">{{label}}</label>
																		</ng-container>
																		</ng-container>																			
																		<div *ngIf="item.LIBRARY_ID>-1">
																			<strong>Instruction :</strong> {{item.INSTRUCTIONS}}
																		</div>
																		<div *ngIf="!item.COST_LIBRARY_ID">
																			<strong>Content :</strong>
																			<span *ngIf="!item.CONTENT_HTML||item.CONTENT_HTML.length==0" style="color:white">{{item.CONTENT}}</span>
																			<div *ngIf="item.CONTENT_HTML&&item.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="item.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
																		</div>
																		<div *ngIf="item.COST_LIBRARY_ID>-1">
																			<strong>Cost :</strong> <span style="color:white">{{item.COST}}</span><br>
																			<strong>EUL: </strong>	<span style="color:white">{{item.EUL}}</span><br>
																			<strong>Unit: </strong>	<span style="color:white">{{item.UNIT}}</span>
																		</div>
																	</div>																	
																</ng-template>
															</p-overlayPanel>
													</ng-container>
													</div>
                                                </ng-template>
            </p-overlayPanel>
		</td>		
	</ng-container>
  </tr>
  <tr *ngIf="r.length==1&&doc2.data">
<td style="font-size:.8em; background-color:#eeeeee; width:40px">
	<a class="btn btn-sm btn-link"  (click)="op103.show($event); getPosition(doc2.id,$event,i, j,k);selectedRow=h;selectedCell=null" [ngStyle]="{'background-color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'rgb(195,212,47)':null,'color':selectedRow===h&&curIndex[0]==i&&curIndex[1]==j&&curIndex[2]==k?'white':null}">{{h+1}}</a>
		<p-overlayPanel #op103 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '240px'}">
            <ng-template pTemplate>                                                    
				<div *ngIf="selectedRow>-1"  style="font-size:.8em; color:#C2D63F; ">
					<label style="font-weight:bold">Row: {{selectedRow+1}}</label>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm p-0" (click)="moveUp(selectedRow)"><i class="fas fa-long-arrow-alt-up iconBtn smIcon" title="Move Up"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm ml-2 p-0" (click)="moveDown(selectedRow)"><i class="fas fa-long-arrow-alt-down iconBtn smIcon"></i></a>
					<a href="javascript:void(0)"class="btn btn-outline-light btn-sm ml-2 p-0" (click)="deleteRow(selectedRow)"><i class="fas fa-trash iconBtn smIcon"></i></a>
			<br>
					<div>
						<input type="checkbox" [checked]="addBefore" (change)="addBefore=!addBefore">Insert Row Above <br>
						<input type="number" value="1" min="0" max="1000000000" style="width:70px; height:20px;"/>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addRows($event)"><span style="font-size:.8em; pointer-events:none">Add Row</span></a><br>
						<select  style="width:70px; height:20px;">
							<option>Left</option>
							<option selected>Center</option>
							<option>Right</option>
						</select>
						<a href="javascript:void(0)" class="btn btn-sm btn-outline-light  pb-0 pt-0 ml-1 mb-1" (click)="addSub($event)"><span style="font-size:.8em; pointer-events:none">Add Sub-Header</span></a>
					</div>
				</div>                                       </ng-template>
            </p-overlayPanel>
	</td>
		<td colSpan='{{doc2.data.cols.length}}' [ngStyle]="{'text-align':r[0].celAllign}"  style="font-weight:bold">
			<app-editable [text]="r[0].DATA" (edited)="selCell(h,0); changeLabel($event)" (focused)="getPosition(doc2.id,$event,i, j,k);addLib=false; " [defaultText]='"Sub-Header"'></app-editable>
		</td>
  </tr>
  </ng-container>
  </ng-container>
</table>
<div *ngIf="doc2.id==curId" [ngClass]="{'hideSec':doc2.OTABLE}">
<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<div *ngIf="doc2.data&&(!doc2.data?.erisName)&&doc2.TYPE=='TABLE'">
	<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&(!doc2.data?.erisName)" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
	<!--<caption *ngIf="doc2.data['caption']" [ngStyle]="{'border':doc2.data['caption']['border']?'solid 1px black':'none', 'text-align':doc2.data['caption']['align']?doc2.data['caption']['align']:'center'}">
		<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-v]='k' [innerHTML]="doc2.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
	</caption>-->
	<thead>
		<ng-container *ngFor="let brow of doc2.data.beforeHeaders; let bindex=index">
			<tr>
				<ng-container *ngFor="let col of brow; let u=index">
					<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
						<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
					<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
						<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
				</ng-container>
			</tr>
		</ng-container>	
		<tr>
					<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
							<i *ngIf="doc2.data['locked']&&doc2.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span *ngIf="!h.htmltext" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" style="font-weight:bold"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span>
							<span *ngIf="h.htmltext" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" style="font-weight:bold"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
				<ng-container *ngFor="let brow of doc2.data.afterHeaders; let bindex=index">
					<tr>
						<ng-container *ngFor="let col of brow; let u=index">
							<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
								<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
							<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative" [ngStyle]="{'text-align':col.colAlign}">
								<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
				</ng-container>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top">
								<i *ngIf="doc2.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
								<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
								<span *ngIf="k.DATA" class="replaceContainer" data-type="table" [attr.data-id]="doc2.id" [attr.data-x]='h' [attr.data-y]='q'  [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc2.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;position: relative;">
							<span *ngIf="r.items[0].DATA"  class="replaceContainer" data-type="table" [attr.data-id]="doc2.id" [attr.data-x]='h' data-y='0' [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<i *ngIf="doc2.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>        
  <!--<p-table [value]="doc2.data.rows" [columns]="doc2.data.cols" [reorderableColumns]="true"  [resizableColumns]="true" styleClass="p-datatable-gridlines"  (onColReorder)="colReorder($event, doc2.id)" (onRowReorder)="rowReorder($event)" (onColResize)="colResize($event, doc2)">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="cellItem" style="background:white;width:2rem;"></th>
            <th *ngFor="let col of columns; let t=index" style="background:white;vertical-align:middle; padding:1px" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}" pReorderableColumn  pResizableColumn class="cellItem">
                <span *ngIf="!col.htmltext" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}"class="headerCell" [innerHTML]="col.NAME"></span>
				<span *ngIf="col.htmltext" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" class="headerCell" [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="selectCol(doc2, t, col);getPosition(doc2.id,$event,i,j,k)" class="float-right" style="cursor:pointer; margin-right:8px" title="Edit"><i class="far fa-edit" style="color:#ccc"></i></a>
	        </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td style="color:#555; background:white; padding:4px; font-size:11px" (click)="selectToggle($event, doc2, index);selectedCell=null;getPosition(doc2.id,$event,i,j,k)" [ngClass]="{'selected':rowData.selected}">
                <span class="pi pi-bars" pReorderableRowHandle (click)="selectedRow=index;selectedCell=null;getPosition(doc2.id,$event,i,j,k)"></span>
            </td>			
        	<ng-container *ngIf="rowData.items&&rowData.items.length>0&&rowData.items[0].colspan">
			<td class="cellItem" [attr.colspan]="rowData.items[0].colspan" (dblclick)="selectCell(doc2, index, columns[0], rowData.items[0]);getPosition(doc2.id,$event,i,j,k)" [ngClass]="{'rowHide':rowData.hide}" [ngStyle]="{'text-align':rowData.items[0].celAllign, 'background':rowData.items[0].bkcolor? rowData.items[0].bkcolor:'white'}">
				<span class="innerCell" *ngIf="rowData.items[0].DATA" [innerHTML]="rowData.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="op506.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[0].libs&&rowData.items[0].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op506 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
					<ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[0])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[0])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[0])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[0])">Clear</a>
					</div>					
				</ng-template>
				</p-overlayPanel>
			</td>
			</ng-container>	
			<ng-container *ngIf="rowData.items&&rowData.items.length>0&&(!rowData.items[0].colspan)">
			<td *ngFor="let col of columns; let z=index" [ngStyle]="{'text-align':col.celAllign, 'background':rowData.items[z].bkcolor? rowData.items[z].bkcolor:'white'}"  class="cellItem" (dblclick)="selectCell(doc2, index, col, rowData.items[z]);getPosition(doc2.id,$event,i,j,k)" [ngClass]="{'rowHide':rowData.hide}">
				<span class="innerCell" *ngIf="rowData.items[z].DATA" [innerHTML]="rowData.items[z].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
				<a (click)="op503.toggle($event)" class="float-right"  [ngStyle]="{'color':rowData.items[z].libs&&rowData.items[z].libs.length>0 ? '#C2D63F' : '#ccc' }" title="Edit"><i class="fas fa-cog"></i></a>
					<p-overlayPanel #op503 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{width: '160px'}">
					<ng-template pTemplate>
					<div style="max-height:160px; overflow-y:auto">
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="copyCell(rowData.items[z])">Copy</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="pasteCell(rowData.items[z])">Paste</a><br>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="addCheckmark(rowData.items[z])">Checkmark</a>
						<a class="btn btn-outline-light  pb-0 pt-0 ml-1 mb-1" style="font-size:.7em;"(click)="clearCheckmark(rowData.items[z])">Clear</a>
					</div>					
				</ng-template>
				</p-overlayPanel>
			</td>
			</ng-container>			
        </tr>
    </ng-template>
</p-table>--> 
</div>
</div>
<div *ngIf="doc2.id!=curId" [ngClass]="{'hideSec':doc2.OTABLE}" class='puretext' (click)="getPosition(doc2.id,$event,i, j,k);resetProp(doc2)">
<button  *ngIf="doc2.OTABLE" class="hidden-btn btn btn-sm">Hidden Table</button>
<table *ngIf="doc2.TYPE=='TABLE'&&doc2.data&&(!doc2.data?.erisName)" style="border: 1px solid #ccc;  border-collapse: collapse;font-size:11px; font-family:Arial, sans-serif;width:100%">
	<!--<caption *ngIf="doc2.data['caption']" [ngStyle]="{'border':doc2.data['caption']['border']?'solid 1px black':'none', 'text-align':doc2.data['caption']['align']?doc2.data['caption']['align']:'center'}">
		<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-v]='k' [innerHTML]="doc2.data['caption'].htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
	</caption>-->
	<thead>
		<ng-container *ngFor="let brow of doc2.data.beforeHeaders; let bindex=index">
			<tr>
				<ng-container *ngFor="let col of brow; let u=index">
					<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
						<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
					<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'text-align':col.colAlign}">
						<i *ngIf="doc2.data['locked']&&doc2.data['locked']['beforeHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
						<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-z]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
					</th>
				</ng-container>
			</tr>
		</ng-container>	
		<tr>
					<ng-container *ngFor="let h of doc2.data?.cols; let o=index; trackBy:trackByFuntion">
						<th [ngStyle]="{'width':h.width+h.unit,'text-align':h.colAlign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;">
							<i *ngIf="doc2.data['locked']&&doc2.data['locked']['header']" class="fas fa-lock lockicon" title="Header Locked"></i>										
							<span *ngIf="!h.htmltext" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" style="font-weight:bold"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.NAME|highlighter:searchText:caseOn:allMatchtext"></span>
							<span *ngIf="h.htmltext" [ngStyle]="{'color':doc2.OHEADER?'#C4C4C4':'#444'}" style="font-weight:bold"  class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]="o" [innerHTML]="h.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
						</th>
					</ng-container>
				</tr>
				<ng-container *ngFor="let brow of doc2.data.afterHeaders; let bindex=index">
					<tr>
						<ng-container *ngFor="let col of brow; let u=index">
							<th *ngIf="!col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;" [ngStyle]="{'width': col.width+col.unit,'text-align':col.colAlign}">
								<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
							<th *ngIf="col.colspan&&u==0" [attr.colspan]="col.colspan" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative" [ngStyle]="{'text-align':col.colAlign}">
								<i *ngIf="doc2.data['locked']&&doc2.data['locked']['afterHeaders'].indexOf(bindex)>-1" class="fas fa-lock lockicon" title="Header Locked"></i>										
								<span style="font-weight:bold" class="replaceContainer" [attr.data-id]="doc2.id" data-type="table" [attr.data-x]='bindex' [attr.data-w]='u' [innerHTML]="col.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							</th>
						</ng-container>
					</tr>
				</ng-container>
				</thead>
				<tbody>
				<ng-container *ngFor="let r of doc2.data?.rows; let h=index; trackBy:trackByFuntion">
					<tr *ngIf="r.items?.length>1">
						<ng-container *ngFor="let k of r.items; let q=index; trackBy:trackByFuntion">
							<td [ngStyle]="{'text-align':doc2.data?.cols[q].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;position: relative;vertical-align:top">
								<i *ngIf="doc2.data.cols[q]['lock']||r['lock']" class="fas fa-lock lockicon" title="Locked"></i>										
								<i *ngIf="k['lock']" class="fas fa-lock lockicon" title="Content Locked" style="pointer-events: none;"></i>	
								<span *ngIf="k.DATA" class="replaceContainer" data-type="table" [attr.data-id]="doc2.id" [attr.data-x]='h' [attr.data-y]='q'  [innerHTML]='k.DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:"full"|safeHtml'></span>
							</td>														
						</ng-container>
					</tr>
					<tr *ngIf="r.items?.length==1">
						<td [attr.colspan]='doc2.data.cols.length' [ngStyle]="{'text-align':r.items[0].celAllign}" style="border: 1px solid #ccc;  border-collapse: collapse;vertical-align:top;position: relative;">
							<span *ngIf="r.items[0].DATA"  class="replaceContainer" data-type="table" [attr.data-id]="doc2.id" [attr.data-x]='h' data-y='0' [innerHTML]="r.items[0].DATA?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></span>
							<i *ngIf="doc2.data.cols[0]['lock']||r['lock']||r.items[0]['lock']" class="fas fa-lock lockicon" title="Locked"></i>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
</div>
</div>
		</div>		
	</div>
</ng-container>
<ng-container *ngIf="tempInfo?.PCA_INDICATOR=='frm1104'">
	<h6 [id]='contents[0].id' [ngStyle]="{'background-color':listid==contents[0].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section I: General Information, Documentation and Certification</h6>
	<div style="font-size:10px"><!--Mortgage and Property Information-->
	<h6 [id]='contents[0].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[0].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo', 0, 0 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
				
				</div>
			</div>
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Report date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate', 0, 0 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
					<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
			  		<p *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
					<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>
				</div>
			</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
	<div style="height:4px; border:none"></div>
	<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName', 0, 0 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
	</div>

<div style="width:49.5%; display:inline-block;">
	  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px"></div>
		<label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText', 0, 0 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
</div>
<div style="width:49.5%; display:inline-block;">
<div style="width:49.5%;display:inline-block">
  <div style="height:4px; border:none"></div>
  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId', 0, 0 )"><i class="far fa-list-alt"></i></a>
 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
</div>
</div>
<div style="width:49.5%;display:inline-block">
  <!--<div style="height:4px; border:none"></div>
  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PrelimInspectionDate')"><i class="far fa-list-alt"></i></a>
  <div *ngIf="contents[0].SUB_SECTIONS[0].data.PrelimInspectionDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PrelimInspectionDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.PrelimInspectionDate?.html" type="text" style="border:none;width:100%" />
  </div>-->
</div>
</div>
<div style="width:49.5%; display:inline-block;">
	<div style="width:22%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">City</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'CityName', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.CityName?.html" disabled ="text" style="border:none;width:94%"/>
		</div>
	</div>
	<!--<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px"></div>
		<label style="margin-left:4px">City</label>
		<div>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
		</div>
	</div>-->
	<div style="width:35%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">State</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" disabled ="text" style="border:none;width:94%"/>
		</div>
	</div>
	<div style="width:42.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Zip</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PostalCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" disabled ="text" style="border:none;width:94%"/>
		</div>
	</div>
</div>    
</div><!--Consultant Information-->
<h6 [id]='contents[0].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px; margin-top: 20px;">{{contents[0].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label for="frmloanNo" style="margin-left:4px">Firm name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmName', 0, 1 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmName?.html" disabled ="text" style="border:none;width:94%"/>
				
				</div>
			</div>
			
	
	<div style="width:49.5%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Inspector's name and title</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'InspectorName', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
	<div style="height:4px; border:none"></div>
	<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmAddressLineText', 0, 1 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmAddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
	</div>

<div style="width:49.5%; display:inline-block;">
	  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px"></div>
		<label style="margin-left:4px">Report writer's name and title</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'WriterName', 0, 1 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[1].data?.WriterName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.WriterName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.WriterName?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
</div>
<div style="width:49.5%; display:inline-block;">
	<div style="width:22%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">City</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmCityName', 0, 1 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmCityName?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<!--<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px"></div>
			<label style="margin-left:4px">City</label>
			<div>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName', 0, 0 )"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode', 0, 0 )"><i class="far fa-list-alt"></i></a>
			</div>
		</div>-->
		<div style="width:35%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">State</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmStateUspsCode', 0, 1 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:42.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Zip</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPostalCode', 0, 1 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPostalCode?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
	
</div>
<div style="width:49.5%;display:inline-block">
  <div style="height:4px; border:none"></div>
  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
 <label  style="margin-left:4px" for="frmloanNo">Environmental reviewer's name and title</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'ReviewerName', 0, 1 )"><i class="far fa-list-alt"></i></a>
 <div *ngIf="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.ReviewerName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
 <input *ngIf="!contents[0].SUB_SECTIONS[1].data?.ReviewerName?.html" disabled ="text" style="border:none;width:100%"/>
</div>
</div>
<div style="width:49.5%; display:inline-block;">
	<div style="width:69.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label for="FirmPhoneNumber" style="margin-left:4px">Telephone number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPhoneNumber', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber?.html" disabled ="text" style="border:none;width:94%"/>
		
		</div>
	</div>
	<div style="width:29.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Extension</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPhoneExt', 0, 1 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt?.html" disabled ="text" style="border:none;width:94%"/>
		</div>
	</div>
</div><div style="width:49.5%; display:inline-block;">
<div style="width:69.5%;display:inline-block">
	<div style="height:4px; border:none"></div>
	<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<label for="VisitDate" style="margin-left:4px">Date of visit</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate', 0, 1 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[1].data?.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.VisitDate?.html" disabled ="text" style="border:none;width:94%"/>-->
		<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[1].data.VisitDate"><br>
		<p *ngIf="contents[0].SUB_SECTIONS[1].data?.VisitDate"  style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[1].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
		<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.VisitDate" disabled ="text" style="border:none;width:94%"/>
	</div>
</div>
<div style="width:29.5%;display:inline-block">
	<div style="height:4px; border:none"></div>
	<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<label style="margin-left:4px">Date of engagement</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'EngageDate', 0, 1 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[1].data?.EngageDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[1].data?.EngageDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[1].data?.EngageDate?.html" disabled ="text" style="border:none;width:94%"/>-->
		<input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[1].data.EngageDate">
			  <label *ngIf="contents[0].SUB_SECTIONS[1].data?.EngageDate">{{contents[0].SUB_SECTIONS[1].data.EngageDate|date:"MMMM dd, yyyy"}}</label>
			  <input *ngIf="!contents[0].SUB_SECTIONS[1].data?.EngageDate" disabled ="text" style="border:none;width:80%"/>
	</div>
</div>
</div>

	
</div><!--Site Statistics-->
<h6 [id]='contents[0].SUB_SECTIONS[2].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px; margin-top: 20px;">{{contents[0].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label for="BuildYear" style="margin-left:4px">Year(s) of construction</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'BuildYear', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.BuildYear?.html" disabled ="text" style="border:none;width:94%"/>
				
				</div>
			</div>
			<div style="width:49.5%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px">Year last renovated (with amount)</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'RenovYear', 0, 2 )"><i class="far fa-list-alt"></i></a>
					<!--<div *ngIf="contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.RenovYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" disabled ="text" style="border:none;width:94%"/>-->
					<div>
						<span *ngIf="contents[0].SUB_SECTIONS[2].data?.RenovYear?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.RenovYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'RenovYear',0,2)"><i class="far fa-list-alt"></i></a>
						<div>$<input [(ngModel)]="contents[0].SUB_SECTIONS[2].data.RenovCost"  (change)="validateInput($event, contents[0].SUB_SECTIONS[2].data, 'RenovCost')"></div>
					</div>
				</div>
			</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label for="BuildingType" style="margin-left:4px">Construction type</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'BuildingType', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.BuildingType?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.BuildingType?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.BuildingType?.html" disabled ="text" style="border:none;width:94%"/>
			
			</div>
		</div>
		<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Acreage</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Acre', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div class="row"  style="width:100%; margin: 0;">
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Acre?.html"  style="width:94%; margin:0;"  [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Acre?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Acre?.html" disabled ="text" style="border:none;width:94%; margin:0;"/>
				</div>
			</div>
		</div>
</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="height:4px; border:none"></div>
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Topography</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Topo', 0, 2 )"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Topo?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Topo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Topo?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
	</div>
	<div style="width:49.5%; display:inline-block;">
		<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label for="FloodZone" style="margin-left:4px">Flood zone</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FloodZone', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.FloodZone?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.FloodZone?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.FloodZone?.html" disabled ="text" style="border:none;width:94%"/>
			
			</div>
		</div>
		<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Peak ground acceleration</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PeakGround', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div class="row"  style="width:100%; margin: 0">
					<div *ngIf="contents[0].SUB_SECTIONS[2].data?.PeakGround?.html" style="width:94%; margin: 0"   [innerHTML]="contents[0].SUB_SECTIONS[2].data?.PeakGround?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
					<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.PeakGround?.html" disabled ="text" style="border:none;width:94%;margin: 0"/><span style="float:right">g</span>
				</div>
			</div>
		</div>
</div>
	<div style="width:99.5%; display:inline-block;">
	<div style="height:4px; border:none"></div>
	<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<label style="margin-left:4px">Amenities</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Amenities', 0, 2 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Amenities?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Amenities?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Amenities?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
	</div>
<div style="margin-top: 20px; width: 100%;">
<!--<div style="width:49.5%; display:inline-block;">
	  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px"></div>
		<label style="margin-left:4px">units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText', 0, 0 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
	</div>
</div>-->
<p style="width:72%; display:inline-block;">Number of:</p><p style="width:28%; display:inline-block;">Number of parking spaces:</p>
<div style="width:72%; display:inline-block;">
	<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Units', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Units?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Units?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Apartment buildings</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'ApartmentUnits', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.ApartmentUnits?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Other buildings</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'OtherUnits', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.OtherUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.OtherUnits?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
	
</div>
<div style="width:28%; display:inline-block;">
	<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Surface</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Surface', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Surface?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Surface?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Surface?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Garage</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Garage', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Garage?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Garage?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Garage?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Carports</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Carports', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Carports?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Carports?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Carports?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
	
</div>
<div style="width:72%; display:inline-block;">
	<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Ground floor units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'GroundUnits', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.GroundUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.GroundUnits?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Elevators</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Elevators', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Elevators?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Elevators?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Elevators?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
		<div style="width:33%;display:inline-block">
			<div style="height:4px; border:none"></div>
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Floors</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Floors', 0, 2 )"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Floors?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Floors?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Floors?.html" disabled ="text" style="border:none;width:94%"/>
			</div>
		</div>
	
</div>
<div style="width:28%; display:inline-block;">
	<div style="height:4px; border:none"></div>
	<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<label style="margin-left:4px">Other:</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Other', 0, 2 )"><i class="far fa-list-alt"></i></a>
		<div *ngIf="contents[0].SUB_SECTIONS[2].data?.Other?.html" [innerHTML]="contents[0].SUB_SECTIONS[2].data?.Other?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		<input *ngIf="!contents[0].SUB_SECTIONS[2].data?.Other?.html" disabled ="text" style="border:none;width:94%"/>
	</div>
</div>
<div style="width: 100%; margin-bottom: 4px;">
	<p>Discuss other features:</p>
	<textarea style="width: 100%;" [(ngModel)]="contents[0].SUB_SECTIONS[2].data.discuss"></textarea>
</div>
</div>
	
</div>
<div style="margin-top: 6px;font-size: 11px;"><!--List of Parties Present-->
	<h6 [id]="contents[0].SUB_SECTIONS[3].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[3].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;">{{contents[0].SUB_SECTIONS[3].SECTION_TITLE}}</h6>
	<p style="margin-bottom: 10px;">Provide a listing of parties involved in the site visit (including the consultants).</p>
		<ng-container *ngFor="let row of contents[0].SUB_SECTIONS[3].data; let i=index">
			<table class="partiesTable" style="border:2px solid black">
				<tbody>
					<tr style="height: 14px;">
						<td rowspan="2" style="background-color: black;color: #FFFFFF;vertical-align: middle;width:4%; text-align: center;">
							{{i+1}}
						</td>
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Company
						</td>
						<td style="width:38%;"><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Company.text">
						</td>
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Name
						</td>
						<td style="width:38%"> <input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Name.text">
						</td>
					</tr>
					<tr style="height: 14px;">
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Title
						</td>
						<td style="width:38%"><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Title.text">
						</td>
						<td style="background-color: #C0C0C0;width:10%; text-align: right">Affiliation
						</td>
						<td style="width:38%"><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Affiliation.text">
						</td>
					</tr>
					<tr style="border-top: double 2px black;height: 14px;">
						<td colspan="5" style="background-color: #C0C0C0;">Comments
						</td>
					</tr>
					<tr>
						<td colspan="5" ><input type="search" style="width: 100%;outline: none;border: none;" [(ngModel)]="row.Comment.text">
						</td>
					</tr>
				</tbody>
			</table>
		</ng-container>
		<div style="position:relative; height:20px">
			<button class="frmBtn" style="float: right;" (click)="addListParties(contents[0].SUB_SECTIONS[3].data)">Add</button>
			<button class="frmBtn" style="float: right;" (click)="deleteListParties(contents[0].SUB_SECTIONS[3].data)">Delete Last Entry</button>
		</div>
		
</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Documentation-->
	<h6 [id]="contents[0].SUB_SECTIONS[4].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[4].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;">{{contents[0].SUB_SECTIONS[4].SECTION_TITLE}}</h6>
	<p style="margin-bottom: 10px;">Indicate if the below are attached or not attached. If they are not attached, then additional information should be provided in the comments</p>
	<div style="width:100%">
		<div class='klistItem' style="width:86%;">
			<p style="border-bottom:solid 1px black;margin-bottom: 4px;">Document</p>
			<p >Limiting conditions</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			  <p style="border-bottom:solid 1px black;margin-bottom: 4px;">Status</p>
			  <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[0]">
				<option value="Y" >Attached</option>
				<option value="N" >Not attached</option>
				<option value="NA" >NA</option>                     
			</select>
		</div>
		<div class='klistItem' style="width:86%;">
			<p>Site plan</p>
		 </div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[1]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Renovation scope of work and budgets</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[2]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Information provided by borrower (specified in appendix)</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[3]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Building and health code violations</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[4]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Environmental transaction screen</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[5]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Test and study results (e.g., structural, civil, asbestos, etc. - specified in appendix)</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[6]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Other records and data reviewed (specified in appendix)</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[7]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Resume of inspector</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[8]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Resume of report writer/reviewer (if different from the inspector)</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[9]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			<p>Resume of environmental reviewer (if different from the inspector and/or report reviewer)</p>
		 </div>
		 <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			 <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[10]">
				 <option value="Y" >Attached</option>
				 <option value="N" >Not attached</option>
				 <option value="NA" >NA</option>                     
			 </select>
		 </div>
		 <div class='klistItem' style="width:86%;">
			 <p>Identification of any deviations from the Guide requirements and the most recent versions of the ASTM standards E2018 and E1528 as well as applicable environmental regulations established by the Environmental Protection Agency</p>
		  </div>
		  <div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			  <select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[4].data.documents[11]">
				  <option value="Y" >Attached</option>
				  <option value="N" >Not attached</option>
				  <option value="NA" >NA</option>                     
			  </select>
		  </div>
		  <div style="width: 100%; margin-bottom: 4px;">
			<p>Additional Comments:</p>
			<textarea style="width: 100%;"  [(ngModel)]="contents[0].SUB_SECTIONS[4].data.additionalInfo"></textarea>
		</div>			  
	</div>	
</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Data Collection and Records Inquiry-->
	<h6 [id]="contents[0].SUB_SECTIONS[5].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[5].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;">{{contents[0].SUB_SECTIONS[5].SECTION_TITLE}}</h6>
	<div style="width:100%">
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Was information pertaining to the maintenance, repair and replacement of major building components or systems reviewed?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[0].status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>
		<div   *ngIf="contents[0].SUB_SECTIONS[5].data[0].status=='NO'" style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
			<p>Explain why not:</p>
			<input style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[0].Explanation">
		</div>
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Were all significant maintenance reports, repair receipts and replacement items completed within the past 12 months, as well as elevator, boiler and safety inspection records and certificates reviewed?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[1].status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>
		<div   *ngIf="contents[0].SUB_SECTIONS[5].data[1].status=='NO'"style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
			<p>Explain why not:</p>
			<input style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[1].Explanation">
		</div>
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Was all available information related to planned capital improvements, inclusive of renovation/rehabilitation scope or work, and/or such work in progress reviewed?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[2].status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>
		<div   *ngIf="contents[0].SUB_SECTIONS[5].data[2].status=='NO'"style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
			<p>Explain why not:</p>
			<input style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[2].Explanation">
		</div>
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Was evidence of completed capital expenditures or construction costs reviewed?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[3].status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>
		<div  *ngIf="contents[0].SUB_SECTIONS[5].data[3].status=='NO'" style="width: 100%; margin-left: 4%;margin-bottom: 4px;">
			<p>Explain why not:</p>
			<input style="width: 95%;" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[3].Explanation">
		</div>
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Were there any records of violations of any federal, State or local laws, ordinances or codes that remain open for the Property, including any violations related to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters, fire safety or energy-related requirements?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[5].data[4].status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>
		<div *ngIf="contents[0].SUB_SECTIONS[5].data[4].status=='YES'" style="width: 100%; padding-left: 4%;margin-top: 4px;">
			<p class='klistItem' style="width:75%">Provide details regarding the violations in Section III. Only violations that are considered to be life/safety issues or significant deficiencies, and that should be corrected as part of the Priority Repairs scope, need to be included</p>
			<button class='navBtn' (click)="scroll('frm1104-2'); listid='frm1104-2'">Enter Violations</button>
		</div>
					  
	</div>	
</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Reliance-->
	<h6 [id]="contents[0].SUB_SECTIONS[6].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[6].id?'rgb(195, 212, 47)':'white'}"  style="padding:4px; background-color: black;">{{contents[0].SUB_SECTIONS[6].SECTION_TITLE}}</h6>
	<div style="width:100%;">
		<p>This report is for the use and benefit of, and may be relied upon by</p>
		<ol style="list-style-type: lower-alpha">
			<li style="list-style:symbol('(a)');font-weight: normal;">the Seller/Servicer, Freddie Mac and any successors and assigns (“Lender”);</li>
			<li style="list-style:symbol('(a)');font-weight: normal;">independent auditors, accountants, attorneys and other professionals acting on behalf of Lender;</li>
			<li style="list-style:symbol('(a)');font-weight: normal;">governmental agencies having regulatory authority over Lender;</li>
			<li style="list-style:symbol('(a)');font-weight: normal;">designated persons pursuant to an order or legal process of any court or governmental agency;</li>
			<li style="list-style:symbol('(a)');font-weight: normal;">prospective purchasers of the Mortgage; and</li>
			<li style="list-style:symbol('(a)');font-weight: normal;"> with respect to any debt (or portion thereof) and/or securities secured, directly or indirectly, by the Property which is the subject of this report, the following parties and their respective successors and assigns:</li>
			<ul style="list-style-type:disc;">
				<li style="font-weight: normal;">any placement agent or broker/dealer and any of their respective affiliates, agents and advisors;</li>
				<li style="font-weight: normal;">any initial purchaser or subsequent holder of such debt and/or securities;</li>
				<li style="font-weight: normal;">any Servicer or other agent acting on behalf of the holders of such debt and/or securities;</li>
				<li style="font-weight: normal;">any indenture trustee;</li>
				<li style="font-weight: normal;">any rating agency; and</li>
				<li style="font-weight: normal;">any institutional provider from time to time of any liquidity facility or credit support for such financings.</li>
			</ul>
		</ol>
		<p>In addition, this report, or a reference to this report, may be included or quoted in any offering circular, information circular, offering memorandum, registration statement, private placement memorandum, prospectus or sales brochure (in either electronic or hard copy format) in connection with a securitization or transaction involving such debt (or portion thereof) and/or securities.</p>
	</div>

</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Certification-->
	<h6 [id]="contents[0].SUB_SECTIONS[7].id" [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[7].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;">{{contents[0].SUB_SECTIONS[7].SECTION_TITLE}}</h6>
	<div style="width:100%">
		<p>The undersigned hereby certifies that:</p>
		<ul>
			<li>The attached physical risk report was prepared in accordance with all applicable requirements in the Freddie Mac Multifamily</li>
			<li>The inspection and report was prepared in a manner consistent with generally accepted industry practices and standards</li>
			<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and</li>
			<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac</li>
		</ul>
		<p>In addition, this report, or a reference to this report, may be included or quoted in any offering circular, information circular, offering memorandum, registration statement, private placement memorandum, prospectus or sales brochure (in either electronic or hard copy format) in connection with a securitization or transaction involving such debt (or portion thereof) and/or securities.</p>
	</div>

</div>
<div style="width:100%; display:inline; position:relative">
	<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px;"></div>
			<label style="margin-left:4px">Signature of property inspector</label><br>
			<input type="text" style="border:none;width:90%"/>				
		</div>
	</div>
	
	<div style="width:49%; display:inline-block;;margin-left:10px">
	<div style="display:inline-block;;margin:0;width:100%;">
		<div style="height:4px; border:none; "></div>
		<label style="margin-left:4px">Date</label><br>
		<input type="text" disabled style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
	</div>
	</div>
	<div style="width:49%; display:inline-block;">
	<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px;"></div>
		<label style="margin-left:4px">Name (typed or printed)</label><br>
		<input type="text" style="border:none;width:100%"/>
		
	</div>
	</div>
	<div style="width:49%; display:inline-block;margin-left:10px">
	<div style="display:inline-block;margin:0;width:100%;">
		<div style="height:4px; border:none; "></div>
		<label style="margin-left:4px">Title</label><br>
		<input type="text"style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
	</div>
	</div>
</div>
<div style="width: 100%;margin-top: 20px;">
	<div class='klistItem' style="width:86%;">
		<p style="width:75%;">Did a separate individual write or review the report?</p>
	</div>
	<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
		<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required">
			<option value="Y" >Yes</option>
			<option value="N" >No</option>					                  
		</select>
	</div>
</div>
<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherRptReviewer'].required=='Y'" style="width:100%; display:inline; position:relative">
	<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px;"></div>
			<label style="margin-left:4px">Signature of writer/reviewer</label><br>
			<input type="text" style="border:none;width:90%"/>				
		</div>
	</div>
	
	<div style="width:49%; display:inline-block;;margin-left:10px">
	<div style="display:inline-block;;margin:0;width:100%;">
		<div style="height:4px; border:none; "></div>
		<label style="margin-left:4px">Date</label><br>
		<input type="text" disabled style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
	</div>
	</div>
	<div style="width:49%; display:inline-block;">
	<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px;"></div>
		<label style="margin-left:4px">Name (typed or printed)</label><br>
		<input type="text" style="border:none;width:100%"/>
		
	</div>
	</div>
	<div style="width:49%; display:inline-block;margin-left:10px">
	<div style="display:inline-block;margin:0;width:100%;">
		<div style="height:4px; border:none; "></div>
		<label style="margin-left:4px">Title</label><br>
		<input type="text"style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
	</div>
	</div>
</div>
<div style="width: 100%;margin-top: 20px;">
	<div class='klistItem' style="width:86%;">
		<p style="width:75%;">Was a separate individual required to review the environmental section?</p>
	</div>
	<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
		<select style="width:100%" [(ngModel)]="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required">
			<option value="Y" >Yes</option>
			<option value="N" >No</option>					                  
		</select>
	</div>
</div>
<div *ngIf="contents[0].SUB_SECTIONS[7].data['otherEvReviewer'].required=='Y'" style="width:100%; display:inline; position:relative">
	<div style="width:49%; display:inline-block;">
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<div style="height:4px;"></div>
			<label style="margin-left:4px">Signature of reviewer</label><br>
			<input type="text" style="border:none;width:90%"/>				
		</div>
	</div>
	
	<div style="width:49%; display:inline-block;;margin-left:10px">
	<div style="display:inline-block;;margin:0;width:100%;">
		<div style="height:4px; border:none; "></div>
		<label style="margin-left:4px">Date</label><br>
		<input type="text" disabled style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
	</div>
	</div>
	<div style="width:49%; display:inline-block;">
	<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px;"></div>
		<label style="margin-left:4px">Name (typed or printed)</label><br>
		<input type="text" style="border:none;width:100%"/>
		
	</div>
	</div>
	<div style="width:49%; display:inline-block;margin-left:10px">
	<div style="display:inline-block;margin:0;width:100%;">
		<div style="height:4px; border:none; "></div>
		<label style="margin-left:4px">Title</label><br>
		<input type="text"style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
	</div>
	</div>
</div>
</div>
<div style="margin-top: 6px;font-size: 12px;">
	<h6 [id]="contents[1].id" [ngStyle]="{'background-color':listid==contents[1].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">Section II: Unit Details</h6>
	<div style="width:100%"><!--Unit Mix and Inspection-->
		<h6 [id]="contents[1].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[1].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		
<p>Complete <b>Table 1</b> for residential units <i><ins>only</ins></i>. Commercial units, both spaces that are purpose-built and dwelling units converted to commercial use will be accounted for in <b>Table 2.</b> If "Other" dwelling units have been indicated, <b>Table 3</b> will need to be completed as indicated.</p>
	<div style="width:100%; padding:0 0 0 20px; display:inline-block;">
	<p style="font-weight:bold; margin-top:4px; margin-bottom:2px; border-top:2px double black; border-bottom:1px solid black; background-color: #ccc;">Table 1 - below, indicate the unit type and occupancy at the time of the visit and the number of units inspected of each type</p>
	  <div style="width:32%; display:inline-block; border-top:1px solid black;vertical-align: top;">
		  <p style="border-top:1px solid black; border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">Unit Type
		  </p>
		  <table style="width:100%; border-collapse: collapse;">
			  <thead>
				  <tr style="text-align: center;">
					  <th style="border:none; width:30%">BR</th>
					  <th style="border:none; width:30%">BA</th>
					 <!--<th style="border:none; width:24%">SF</th>-->
					  <th style="border:none; width:40%">Style</th>
				  </tr>
			  </thead>
			  <tbody>
				<tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix" >
				  <td style="border:none; border-bottom:1px solid black; height:16px; padding:0">
					  
					  <input type='number' [(ngModel)]="row.BedroomCount" style="width:90%; border:none;text-align: center;" (change)="validateInput($event, row, 'BedroomCount')"/>
				  </td>
				  <td style="border:none; border-bottom:1px solid black; height:16px; padding:0;border-left: 4px solid;">
					  <input type='number' [(ngModel)]="row.BathroomCount" style="width:90%; border:none;padding:0;text-align: center;" (change)="validateInput($event, row, 'BathroomCount', 'decimal')"/>
				  </td>
				  <!--<td style="border:none; border-bottom:1px solid black; height:16px; padding:0;border-left: 4px solid;">
					  <input type='number' [(ngModel)]="row.AvgSquareFeetNumber" style="width:90%; border:none;text-align: center;" (change)="validateInput($event)"/>
				  </td>-->
				  <td style="border-bottom:1px solid black;padding: 1px 0; display:inline;border-left: 4px solid;border-bottom:1px solid black;">
					  <select style="border:none; width:100%;" [(ngModel)]="row.StyleType">
						  <option>Flat</option>
						  <option>Townhouse</option>
						  <option>Loft</option>
						  <option>House</option>						  				
					  </select>					  
				  </td>
				</tr>
			  </tbody>
		  </table>
		  <div style="margin:4px 0; position: relative;">
		  <button class="frmBtn" style="width:30%; margin: 0 4px; float: right;" (click)="insertUnit()">Add Type</button>
		  <button class="frmBtn" style="width:30%; margin: 0 4px; float: right;" (click)="deleteUnit()">Delete</button>
		  <!--<label style="width:25%; margin: 0; font-weight:bold; float:right">Totals: </label>-->
		  </div>
	  </div>
	  <div style="width:32%; display:inline-block; border-top:1px solid black; margin-left:10px">
		  <p style="border-top:1px solid black; border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">Number of units
		  </p>
		  <table style="width:100%; border-collapse: collapse;">
			  <thead>
				  <tr>
					  <th style="border:none; width:25%">Occupied</th>
					  <th style="border:none; width:25%">Vacant</th>
					  <th style="border:none; width:25%">Down</th>
					  <th style="border:none; width:25%">Other</th>
				  </tr>
			  </thead>
			  <tbody>
				<tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; let i=index; trackBy:trackByFuntion">
				  <td style="border:1px solid black; height:16px" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedUnitCount>=0?'white':'red'}">
					<input type='number' [(ngModel)]="row.PptyUnitTypeOccupiedUnitCount" style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'PptyUnitTypeOccupiedUnitCount')"/>
				</td>
				  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.VacantUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.VacantUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.VacantUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'VacantUnitCount')"/>
				</td>
				  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeDownUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.PptyUnitTypeDownUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeDownUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'PptyUnitTypeDownUnitCount')"/>
				</td>
				  <td  style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeOtherUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.PptyUnitTypeOtherUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOtherUnitCount>=0?'white':'red'}" (change)="addUnit1($event, i, 'PptyUnitTypeOtherUnitCount')" />
				</td>
				</tr>
			  </tbody>
		  </table>
		  <!--<div style="display: inline-block; margin:4px 0; width:100%; text-align:centre; border-top:2px solid black; border-bottom:2px solid black">
				<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOccupiedUnitCount}}</label>
				<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalVacantUnitCount}}</label>
				<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.PptyTotalDownUnitCount}}</label>
				<label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount}}</label>    
		  </div>-->
	  </div>
	  <div style="width:32%; display:inline-block; border-top:1px solid black; margin-left:10px; vertical-align:top">
		  <p style="border-top:1px solid black;border-bottom:1px solid black;  text-align:center; font-weight:bold; background-color: #ccc;">Number of units inspected
		  </p>
		<table style="width:100%; border-collapse: collapse;">
			  <thead>
				  <tr>
					  <th style="border:none; width:25%">Occupied</th>
					  <th style="border:none; width:25%">Vacant</th>
					  <th style="border:none; width:25%">Down</th>
					  <th style="border:none; width:25%">Other</th>
				  </tr>
			  </thead>
			  <tbody>
				<tr *ngFor="let row of contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; let i=index; trackBy:trackByFuntion">
				  <td style="border:1px solid black" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedInspectedUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.PptyUnitTypeOccupiedInspectedUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOccupiedInspectedUnitCount>=0?'white':'red'}"  (change)="addUnit2($event, i,'PptyUnitTypeOccupiedInspectedUnitCount')"/>
				</td>
				  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeVacantInspectedUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.PptyUnitTypeVacantInspectedUnitCount" type='number' style="width:99%; border:none;"  [ngStyle]="{'background-color':row.PptyUnitTypeVacantInspectedUnitCount>=0?'white':'red'}" (change)="addUnit2($event, i,'PptyUnitTypeVacantInspectedUnitCount')"/>
				</td>
				  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeDownInspectedUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.PptyUnitTypeDownInspectedUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeDownInspectedUnitCount>=0?'white':'red'}" (change)="addUnit2($event, i,'PptyUnitTypeDownInspectedUnitCount')"/>
				</td>
				  <td style="border:1px solid black"  [ngStyle]="{'background-color':row.PptyUnitTypeOtherInspectedUnitCount>=0?'white':'red'}">
					<input [(ngModel)]="row.PptyUnitTypeOtherInspectedUnitCount" type='number' style="width:99%; border:none;" [ngStyle]="{'background-color':row.PptyUnitTypeOtherInspectedUnitCount>=0?'white':'red'}" (change)="addUnit2($event, i,'PptyUnitTypeOtherInspectedUnitCount')"/>
				</td>
				</tr>
			  </tbody>
		  </table>
		  <!--<div style="display: inline-block; margin:4px 0; width:100%; text-align:centre; border-top:2px solid black; border-bottom:2px solid black">
		  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOccupiedInspectedUnitCount}}</label>
		  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlVacantInspectedUnitCount}}</label>
		  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlDownInspectedUnitCount}}</label>
		  <label style="width:25%">{{contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOtherInspectedUnitCount}}</label>
		  </div>-->
	  </div>
	</div>
	<div style="width:65%; padding:0 0 0 20px; display:inline-block;">
		<div class='row' style="width: 100%; font-weight:bold; margin:4px 0; border-top:2px double black; border-bottom:1px solid black; background-color: #ccc;">
			<p style="width:50%">Table 2</p>
			<div style="display: inline-block; width:50%">
				<label style="width:25%">0</label>
				<label style="width:25%">0</label>
				<label style="width:25%">0</label>
				<label style="width:25%">0</label>    
		  </div>
		</div>	
		<p style="margin-top:0; border-top:1px solid black;border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">Detail of Commercial Units</p>
	  <div style="width:45%; display:inline-block">
		  <p style="text-align:right; font-size:12px; margin:4px 10px; ">Number of purpose-built spaces</p>
		  <p style="text-align:right;  font-size:12px; margin:4px 10px">Number of converted residential units</p>
	  </div>
	  <div style="width:49.3%; display:inline-block; margin-left:10px">
		  <table style="width:100%; border-collapse: collapse;">
			  <thead>
				  <tr style="vertical-align: bottom;">
					  <th style="border:none; width:25%;text-align: center">Occupied</th>
					  <th style="border:none; width:25%;text-align: center">Vacant</th>
					  <th style="border:none; width:25%;text-align: center">Down</th>
					  <th style="border:none; width:25%;text-align: center">Total</th>
				  </tr>
			  </thead>
			  <tbody>
				  <tr>
					  <td style="border:1px solid black; height:16px">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].OccupiedUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(0, $event,'OccupiedUnitCount')"/> 
					</td>
					  <td style="border:1px solid black; height:16px">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].VacantUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(0, $event, 'VacantUnitCount')"/>
					</td>
					  <td style="border:1px solid black; height:16px">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].DownUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(0, $event, 'DownUnitCount')"/>
					</td>
					  <td style="border:1px solid black; height:16px; background-color: #ccc;">
						<label style="width:99%; border:none;text-align: center">{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[0].UnitCount}}</label> 
					</td>
				  <tr>
				  <tr>
					  <td style="border:1px solid black; height:16px">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].OccupiedUnitCount" type='number' style="width:99%; border:none;text-align: center;" (change)="addUnit3(1, $event,'OccupiedUnitCount')"/>
					</td>
					  <td style="border:1px solid black; height:16px">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].VacantUnitCount" type='number' style="width:99%; border:none;text-align: center;" (change)="addUnit3(1, $event,'VacantUnitCount')"/>
					</td>
					  <td style="border:1px solid black; height:16px">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].DownUnitCount" type='number' style="width:99%; border:none;text-align: center" (change)="addUnit3(1, $event, 'DownUnitCount')"/>
					</td>
					  <td style="border:1px solid black; height:16px; background-color: #ccc;">
						<label style="width:99%; border:none;text-align: center">{{contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[1].UnitCount}}</label>
					</td>
				  <tr>
			  </tbody>
		  </table>
	  </div>
	  
	  <div style="width:98%; padding:0 0 0 20px; display:inline-block;border:2px double black">
		  <div style="width:85%; display:inline-block">
			  <p style="text-align:right; font-size:12px; margin:4px 10px">Occupied units, including commercial space and other</p>
			  <p style="text-align:right; font-size:12px; margin:4px 10px">Vacant/down units, including commercial space</p>
			  <p style="text-align:right; font-size:12px; margin:4px 10px">Total number of ALL units, including commercial space</p>
		  </div>
		  <div style="width:12%; display:inline-block; margin-left:10px">
			  <p style="text-align:center; font-size:12px; border-bottom:1px solid black; margin:4px 10px">{{contents[1].SUB_SECTIONS[0].data.summary.RsdntlTotalUnitCount}}</p>
			  <p style="text-align:center; font-size:12px; border-bottom:1px solid black; margin:4px 10px">{{contents[1].SUB_SECTIONS[0].data.summary.CommercialTotalUnitCount}}</p>
			  <p style="text-align:center; font-size:12px; border-bottom:1px solid black; margin:4px 10px">{{contents[1].SUB_SECTIONS[0].data.summary.TotalUnitCount}}</p>
		  </div>
	  </div>
	  </div>
	  <div style="width:33%; padding:0 0 0 20px; display:inline-block; vertical-align:top">
	<p style="font-weight:bold; margin-top:4px; margin-bottom:4px; border-top:2px double black; border-bottom:1px solid black; background-color: #ccc;">Table 3</p>
	<p style="margin-top:0; border-top:1px solid black;border-bottom:1px solid black; text-align:center; font-weight:bold; background-color: #ccc;">*Detail of "Other" noted above</p>
		<div style="width:90%; display:inline-block; margin-left:10px">
		 <table style="width:100%; border-collapse: collapse;border:none">
			  <thead>
				  <tr>
					<th style="border:none; width:65%"></th>
					<th style="border:none; width:35%">Total units</th>
				  </tr>
			  </thead>
			  <tbody>
				  <tr>
					<td style="border:none; text-align: right;padding-right: 8px;">Management office</td>
					  <td style="border:1px solid black; padding:0;">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMgmtOfficeUnitCount" type='number' style="width:99%; border:none; text-align: center"  (change)="addUnit4($event, 'PptyTotalOtherMgmtOfficeUnitCount')"/>
					</td>
				  </tr>
				  <tr>
					<td style="border:none; text-align: right;padding-right: 4px">Model</td>
					  <td style="border:1px solid black; padding:0;">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherModelUnitCount" type='number' style="width:99%; border:none; text-align: center"  (change)="addUnit4($event, 'PptyTotalOtherModelUnitCount')"/>
					</td>
				  </tr>
				  <tr>
					<td style="border:none; text-align: right;padding-right: 4px;">Maintenance shop</td>                          
					<td style="border:1px solid black; padding:0;">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMaintenanceShopUnitCount" type='number' style="width:99%; border:none; text-align: center"  (change)="addUnit4($event, 'PptyTotalOtherMaintenanceShopUnitCount')"/>
					</td>
				  </tr>
				  <tr>
					<td style="border:none; text-align: right;padding-right: 4px;">Storage</td>  
					<td style="border:1px solid black; padding:0;">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherStorageUnitCount" type='number' style="width:99%; border:none; text-align: center"  (change)="addUnit4($event, 'PptyTotalOtherStorageUnitCount')"/>
					</td>
				  </tr>
				  <tr>
					<td style="border:none; text-align: right;padding-right: 4px;">Hospitality suite</td>
					  <td style="border:1px solid black; padding:0;">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherHospitalitySuiteUnitCount" type='number' style="width:99%; border:none; text-align: center"  (change)="addUnit4($event, 'PptyTotalOtherHospitalitySuiteUnitCount')"/>
					</td>
				  </tr>
				  <tr>
					<td style="border:none; text-align: right;padding-right: 4px;">Other administrative</td>
					  <td style="border:1px solid black; padding:0;">
						<input [(ngModel)]="contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail.PptyTotalOtherMiscellaneousUnitCount" type='number' style="width:99%; border:none; text-align: center"  (change)="addUnit4($event, 'PptyTotalOtherMiscellaneousUnitCount')"/>
					</td>
				  </tr>
			  </tbody>
		  </table>
		  <label *ngIf="contents[1].SUB_SECTIONS[0].data['unequal']" style="color: red; font-weight: bold;text-align: center;">Table 3 is incomplete.</label>
	  </div>
	  </div>
	</div>
	<div style="font-size:10px"><!--Unit Inspection Information-->
		<h6 [id]="contents[1].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;">{{contents[1].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div style="width:100%">
			<div class="row" style="width: 100%;margin-left: 8px;">
				<div class='klistItem' style="width:86%;">
					<p style="width:75%;">Were any uncertified or unpermitted units, and/or modifications to units identified or suspected, either via the inspection or from the building records research?</p>
				</div>
				<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<select style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.Violations">
						<option value="YES" >Yes</option>
						<option value="NO" >No</option>					                  
					</select>
				</div>					
			  </div>
		</div>
		<div *ngIf="contents[1].SUB_SECTIONS[1].data.Violations=='YES'">
			  <div class="row" style="width: 60%;margin-left: 8px;">
				<div class='klistItem' style="width:86%;">
					<p style="width:75%;">Number of units certified with municipality:</p>
				</div>
				<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<input min="0" max="1000000000" type="number" style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.Certified">
				</div>
				<div class='klistItem' style="width:86%;">
					<p style="width:75%;">Current number of units at the property (uncertified and certified):</p>
				</div>
				<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<input min="0" max="1000000000" type="number" style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.AllUnit">
				</div>					
			  </div>
			  <ng-container *ngFor="let item of contents[1].SUB_SECTIONS[1].data.ViolationRecord;">
				<table style="border:2px solid black; width:100%; border-collapse: collapse;">
					<tbody>
						<tr>
							<td class="frm-graycell" style="width:20%">Location or Unit #</td>
							<td class="frm-normalcell" style="width:53%; border-top:double 2px black">
								<input type="text" [(ngModel)]="item.Location" style="width:100%; border:none">
							</td>
							<td class="frm-graycell" style="width:20%">Violation on record?</td>
							<td class="frm-normalcell" style="width:7%">
								<select style="width:100%" [(ngModel)]="item.OnRecords">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</td>
						</tr>
						<tr>
							<td class="frm-graycell" colspan="4">Description of violation and/or observed concerns</td>
						</tr>
						<tr>
							<td  class="frm-normalcell" colspan="4">
								<textarea [(ngModel)]="item.Description" rows="2" style="width:100%; border:none"></textarea>
							</td>
						</tr>
					</tbody>
				</table>
			  </ng-container>
			  <div style="position:relative; height:20px">
				<button class="frmBtn" style="float:right" (click)="insertVoliationRow()">Insert</button>
				<button class="frmBtn" *ngIf="contents[1].SUB_SECTIONS[1].data.ViolationRecord.length>0" style="float:right"(click)="deleteVoliationRow()">Delete</button>		  
			   </div>
		</div>
	</div>
		<div><!--Unit Inspection Information-->
		<h6 [id]="contents[1].SUB_SECTIONS[2].id" [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}" style="padding:4px; background-color: black;">{{contents[1].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
		<div style="width:100%">
		<p>Indicate the type of unit, using the following abbreviations: 0BR, 1BR, 2BR, etc. Give the unit number and status, using the following status codes: O =
			occupied, V = vacant, D = down and R = other (maintenance shop, management office, etc.). For example, an occupied one-bedroom unit numbered 101
			should be listed as 1BR/101/O.</p>
		<div style="width:100%; display:inline; position:relative">
		<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
			<tbody>
			<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
			<tr style="vertical-align: bottom;">
				<td class='frmCell'>{{4*i+1}}
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
					
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].UnitType" class="frmInput" (blur)="addinput($event, i,0, 'UnitType')"/>
					<i (click)="op1.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op1 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomList">
								<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i,0, 'UnitType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
					
					<input type='text' (blur)="addUnitId($event, i, 0, 'SlrDesignatedUnitId')" [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i].OccupancyStatusType" class="frmInput" (blur)="addinput1($event, i,0, 'OccupancyStatusType')"/>
					<i  (click)="op2.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op2 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomStatus">
								<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i,0, 'OccupancyStatusType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
			
				<td class='frmCell'>{{4*i+2}}
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%" class="half-a-border-on-right">
					
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].UnitType" class="frmInput"  (blur)="addinput($event, i,1, 'UnitType')"/>
					<i (click)="op3.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op3 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomList">
								<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i, 1, 'UnitType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
					<input type='text' (blur)="addUnitId($event, i, 1, 'SlrDesignatedUnitId')"  [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+1].OccupancyStatusType" class="frmInput"  (blur)="addinput1($event, i,1, 'OccupancyStatusType')"/>
					<i  (click)="op4.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op4 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomStatus">
								<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i, 1, 'OccupancyStatusType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
			  
				<td class='frmCell'>{{4*i+3}}
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
					
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].UnitType" class="frmInput"  (blur)="addinput($event, i,2, 'UnitType')"/>
					<i (click)="op5.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op5 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomList">
								<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i, 2,  'UnitType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:12%">
					<input type='text' (blur)="addUnitId($event, i, 2, 'SlrDesignatedUnitId')"  [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; width:5%">
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+2].OccupancyStatusType" class="frmInput"  (blur)="addinput1($event, i,2, 'OccupancyStatusType')"/>
					<i  (click)="op6.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op6 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomStatus">
								<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i, 2, 'OccupancyStatusType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
			 
				<td class='frmCell'>{{4*i+4}}
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:5%">
					
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].UnitType" class="frmInput"  (blur)="addinput($event, i,3, 'UnitType')"/>
					<i (click)="op7.toggle($event)"  class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op7 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomList">
								<a href='javascript:void(0)' class='frmItem' (click)="addBedroomType(item, i, 3,  'UnitType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:12%">
					<input type='text' (blur)="addUnitId($event, i, 3, 'SlrDesignatedUnitId')"   [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].SlrDesignatedUnitId" class="frmInput1 half-border-right"/>
				</td>
				<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:5%">
					<input type='text' [(ngModel)]="contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3]&&contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[4*i+3].OccupancyStatusType" class="frmInput"  (blur)="addinput1($event, i,3, 'OccupancyStatusType')"/>
					<i  (click)="op8.toggle($event)" class="far fa-caret-square-down fa-sm" style="float: right;position: absolute;"></i>
					<p-overlayPanel #op8 [appendTo]="'body'">
						<ng-template pTemplate> 
							<ng-container *ngFor="let item of bedroomStatus">
								<a href='javascript:void(0)' class='frmItem' (click)="addStaus(item, i, 3, 'OccupancyStatusType')">{{item}}</a><br>
							</ng-container>
						</ng-template>
					</p-overlayPanel>
				</td>
			</tr>
		</ng-container>			
			</tbody>
		</table>
	  </div>
	  <div style="position:relative; height:20px">
		<button class="frmBtn" style="float:right" (click)="insertUnitRow()">Insert</button>
		<button class="frmBtn" *ngIf="unitrow>0" style="float:right"(click)="deleteUnitRow()">Delete</button>		  
	   </div>
	<div class="row" style="width: 100%;margin-left: 4px;margin-top: 10px;">
		<div class='klistItem' style="width:86%;">
			<p style="width:75%;">Were there any problems with gaining access to the required number of units?</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="contents[1].SUB_SECTIONS[2].data.AccessProblems.status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>
		<div  *ngIf="contents[1].SUB_SECTIONS[2].data.AccessProblems.status=='YES'" style="width: 100%; margin-bottom: 4px;">
			<p>Provide details:</p>
			<textarea [(ngModel)]="contents[1].SUB_SECTIONS[2].data.AccessProblems.description" style="width: 100%;"></textarea>
		</div>
	  </div>
</div>
</div>
</div>
<div style="margin-top: 6px;font-size: 12px;">
<h6 [id]="contents[2].id" [ngStyle]="{'background-color':listid==contents[2].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section III: Property Condition Assessment</h6>
<ng-container *ngFor="let sec of contents[2].SUB_SECTIONS|slice:0:-4; trackBy: trackByFuntion; let j=index">
<div style="width:100%">
	<h6 [id]="sec.id" [ngStyle]="{'color':listid==sec.id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{sec.SECTION_TITLE}}</h6>
	<p>{{sec.data.intro}}</p>
	<div *ngIf="j==0" style="width:100%; display:inline; position:relative">
		<div style="width:24.5%; display:inline-block;vertical-align: top;">
		<label style="padding:0">
			<select style="vertical-align:middle; line-height:16px" [(ngModel)]="sec.data.checkItem[0]" (click)="selectItem($event, sec.data)">
				<option value=""></option>
				<option value="X">X</option>
			</select>
			<span>Galvanized water pipe</span>
		</label><br>
		<label>
			<select style="vertical-align:middle; line-height:16px"  [(ngModel)]="sec.data.checkItem[1]" (click)="selectItem($event, sec.data)">
				<option value=""></option>
				<option value="X">X</option>
			</select>
			<span>Polybutylene water pipe</span>
		</label><br>
		</div>
		<div style="width:24.5%; display:inline-block;vertical-align: top;" >
			<label style="padding:0">
				<select  [(ngModel)]="sec.data.checkItem[2]" (click)="selectItem($event, sec.data)">
					<option value=""></option>
					<option value="X">X</option>
				</select>
				<span>Aluminum branch wiring</span>
			</label><br>
			<label>
				<select  [(ngModel)]="sec.data.checkItem[3]"  (click)="selectItem($event, sec.data)">
					<option value=""></option>
					<option value="X">X</option>
				</select>
				<span>Edison base/T-type fuses</span>
			</label><br>
			</div>
			<div style="width:24.5%; display:inline-block;vertical-align: top;">
				<label style="padding:0">
					<select  [(ngModel)]="sec.data.checkItem[4]" (click)="selectItem($event, sec.data)">
						<option value=""></option>
						<option value="X">X</option>
					</select>
					<span>Recalls</span>
				</label><br>
				<label>
					<select  [(ngModel)]="sec.data.checkItem[5]" (click)="selectItem($event, sec.data)">
						<option value=""></option>
						<option value="X">X</option>
					</select>
					<span>Stab-lok breakers</span>
				</label><br>
				</div>
				<div style="width:24.5%; display:inline-block;vertical-align: top;">
					<label style="padding:0">
						<select  [(ngModel)]="sec.data.checkItem[6]" (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>Fiberboard exterior siding</span>
					</label><br>
					<label>
						<select  [(ngModel)]="sec.data.checkItem[7]"  (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>T1-11 siding</span>
					</label><br>
					</div>
					<div style="width:73.5%; display:inline-block;vertical-align: top;">
						<label style="padding:0">
							<select  [(ngModel)]="sec.data.checkItem[8]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>EIFS (exterior foam insulation system)</span>
						</label><br>
					</div>
					<div style="width:24.5%; display:inline-block;vertical-align: top;">
						<label style="padding:0">
							<select  [(ngModel)]="sec.data.None" (click)="selectNone($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>None</span>
						</label><br>
					</div>
					<div style="width:99%; display:inline-block;vertical-align: top;">
						<label style="padding:0">
							<select [(ngModel)]="sec.data.checkItem[9]">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Other</span>
							
						</label>
						<input [(ngModel)]="sec.data.other" style="width:60%; border-bottom: #000 2px solid;">
					</div>
				</div>
				<div *ngIf="j==1" style="width:100%; display:inline; position:relative">
					<div style="width:33.1%; display:inline-block;vertical-align: top;">
					<label style="padding:0">
						<select style="vertical-align:middle; line-height:16px" [(ngModel)]="sec.data.checkItem[0]" (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>Smoke detectors</span>
					</label><br>
					<label>
						<select style="vertical-align:middle; line-height:16px"  [(ngModel)]="sec.data.checkItem[1]" (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>Sprinklers</span>
					</label><br>
					<label style="padding:0">
						<select  [(ngModel)]="sec.data.checkItem[2]" (click)="selectItem($event, sec.data)">
							<option value=""></option>
							<option value="X">X</option>
						</select>
						<span>Intercom</span>
					</label><br>
					
					</div>
					<div style="width:33.1%; display:inline-block;vertical-align: top;" >
						<label style="padding:0">
							<select  [(ngModel)]="sec.data.checkItem[3]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Carbon monoxide detectors</span>
						</label><br>
						<label>
							<select  [(ngModel)]="sec.data.checkItem[4]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Emergency lights & exit signs</span>
						</label><br>
						<label>
							<select  [(ngModel)]="sec.data.checkItem[5]" (click)="selectItem($event, sec.data)">
								<option value=""></option>
								<option value="X">X</option>
							</select>
							<span>Security cameras</span>
						</label>
						</div>
						<div style="width:33.1%; display:inline-block;vertical-align: top;">
							<label style="padding:0">
								<select  [(ngModel)]="sec.data.checkItem[6]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Fire extinguishers</span>
							</label><br>
							<label>
								<select  [(ngModel)]="sec.data.checkItem[7]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Fire alarms</span>
							</label><br>
							<label>
								<select  [(ngModel)]="sec.data.checkItem[8]" (click)="selectItem($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>Secured entrance doors</span>
							</label>
							</div>
							<div  style="width:66.2%; display:inline-block;vertical-align: top;">
								<label>
									<select  [(ngModel)]="sec.data.checkItem[9]" (click)="selectItem($event, sec.data)">
										<option value=""></option>
										<option value="X">X</option>
									</select>
									<span>Other</span>
								</label>
								<input [(ngModel)]="sec.data.other" style="width:80%; border-bottom: #000 2px solid;">
							</div>
							<div   style="width:33.1%; display:inline-block;vertical-align: top;">
								
							<label>
								<select  [(ngModel)]="sec.data.None"  (click)="selectNone($event, sec.data)">
									<option value=""></option>
									<option value="X">X</option>
								</select>
								<span>None</span>
							</label>
							</div>
							</div>
					<div *ngIf="sec3type1.indexOf(j)>-1">
						<div  *ngIf="!sec.data.issues&&!sec.data.ifcover&&(!sec.data.checkItem||sec.data.checkItem.join('').length>0)" style="width: 100%; margin-bottom: 4px;">
							<p>Description:</p>
							<textarea [(ngModel)]="sec.data.otherDetail.description" style="width: 100%;"></textarea>
						</div>
					<div *ngIf="sec.data.issues"   class="row" style="width: 100%;margin-left: 4px;margin-top: 10px;">
						<ng-container *ngFor="let issue of sec.data.issues">
							<div class='klistItem' style="width:86%;">
								<p style="width:100%;">{{issue.label}}</p>
							</div>
							<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="issue.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<ng-container *ngIf="issue.status=='YES'">
								<p >Description:</p>
								<input style="width:99%; margin-bottom: 4px;" [(ngModel)]="issue.description">
							</ng-container>
						</ng-container>
					</div>
					<div *ngIf="sec.data.ifcover"   class="row" style="width: 100%;margin-left: 4px;margin-top: 10px;">
							<div class='klistItem' style="width:86%;">
								<p style="width:100%;">{{sec.data.ifcover.label}}</p>
							</div>
							<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="sec.data.ifcover.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<ng-container *ngIf="sec.data.ifcover.status=='YES'">
								<p >Description:</p>
								<input style="width:99%; margin-bottom: 4px;" [(ngModel)]="sec.data.ifcover.description">
							</ng-container>
						
					</div>		
					<div  *ngIf="((!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&j!=4)||(j==4&&sec.data.ifcover.status=='YES')"  class="row" style="width: 100%;margin-left: 4px;">
						<div *ngIf="!sec.data.issues" class='klistItem' style="width:86%;">
							<p style="width:100%;">What is the general condition of this component?</p>
						</div>
						<div  *ngIf="!sec.data.issues" class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="sec.data.otherDetail.condition">
								<option value="Excellent" >Excellent</option>
								<option value="Above Average" >Above Average</option>	
								<option value="Average" >Average</option>
								<option value="Below Average" >Below Average</option>
								<option value="Inferior" >Inferior</option>				                  
							</select>
						</div>
						<div class='klistItem' style="width:86%;">
							<p style="width:75%;">Were any deficiencies identified that could be categorized as a Critical, PR-90, Priority or Operational Repair?</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="sec.data.otherDetail.hasDeficiencies">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
					</div>
					<div *ngIf="(((!sec.data.checkItem||sec.data.checkItem.join('').length>0)&&j!=4)||(j==4&&sec.data.ifcover.status=='YES'))&&sec.data.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
						<ng-container *ngFor="let item of sec.data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class='klistItem' style="width:83.45%;">
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
								<div class='klistItem' style="width:20%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem' style="width:74%;margin-left: 1%;">
									<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;" (change)="getAllDeficiencies()"></textarea>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem' style="width:20%;">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem' style="width:20%;margin-left: 1%;">
										$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies()">
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
				<div *ngIf="sec3type2.indexOf(j)>-1">
					<ng-container *ngFor="let sec1 of sec.data.sub">
						<h6 [id]="sec1.id" style="border-bottom:2px solid black;border-left:2px solid black;width:25% ">{{sec1.subcat}}</h6>
						<p>{{sec1.otherDetail.intro}}</p>
						<div class="row" *ngIf="sec1.otherDetail.providers" style="width:100%; margin-left:0">
							<ng-container *ngFor="let provider of sec1.otherDetail.providers; trackBy:trackByFuntion let k=index">
								<div style="width:49.5%; display:inline-block;">
									<div style="height:4px; border:none"></div>
									<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
										<label style="margin-left:4px">{{provider.label}}</label>
										<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, provider, 2, j, k )"><i class="far fa-list-alt"></i></a>
										<div *ngIf="provider.html" [innerHTML]="provider.secHtml.changingThisBreaksApplicationSecurity|safeHtml"></div>
										<input *ngIf="!provider.html" type="text" style="border:none;width:100%"/>
									</div>
								</div>
							</ng-container>
						</div>
						<div *ngIf="sec1.otherDetail.ifConditions">
							<div class="row" style="width:100%">
								<div class='klistItem1' style="width:20%;">
									<p style="border-bottom:solid 1px black">Present/Not Present</p>
								</div>
								<div class='klistItem ml-1' style="width:79%;">
									<p style="border-bottom:solid 1px black">Risk factor</p>
								</div>
								<ng-container *ngFor="let condition of sec1.otherDetail.ifConditions; trackBy:trackByFuntion let h=index">
									<div class='klistItem1' style="width:20%;">
										<select style="width:70%" [(ngModel)]="condition.status" [ngStyle]="{'border':condition.status? '2px solid #666':'2px solid #F78181'}" >
											<option value="N" >Not Present</option>
											<option value="Y" >Present</option>
										</select>
									</div>
									<div class='klistItem ml-1' style="width:79%;">
										<p style="margin-top:0;">{{condition.condition}}</p>
										<div class="row" *ngIf="condition.status=='Y'" style="width:100%; margin-left: 0;">
											<ng-container *ngIf="condition.questions">
												<div class='klistItem' style="width:83.5%;">
													<p>{{condition.questions[0].label}}</p>
												</div>
												<div class='klistItem' style="width:14%;text-align: center;position: relative;">
													<select style="width:100%; float: right;" [(ngModel)]="condition.questions[0].status">
														<option value="YES">Yes</option>
														<option value="NO">No</option>					                  
													</select>
												</div>
												<ng-container *ngIf="condition.questions[0].status=='YES'">
													<div class='klistItem' style="width:83.5%;">
														<p>{{condition.questions[1].label}}</p>
													</div>
													<div class='klistItem' style="width:14%;margin-left: 5px;text-align: center;">
														<select style="width:100%" [(ngModel)]="condition.questions[1].status">
															<option value="YES" >Yes</option>
															<option value="NO" >No</option>					                  
														</select>
													</div>
													<div class="row"  *ngIf="condition.questions[1].moreinfo&&condition.questions[1].status=='YES'"  style="margin-left:10px; width:100%">
														<div class='klistItem' style="width:83.45%;">
															<p>{{condition.questions[1].info}}</p>
														</div>
														<div class='klistItem' style="width:15%;margin-left: 1%;text-align: center;">
															<input [(ngModel)]="condition.questions[1].value" style="width:50%"><span style="margin-left: 4px;">{{condition.questions[1].unit}}</span>
														</div>
													</div>
												</ng-container>	
											</ng-container>
													<div *ngIf="(!condition.questions||condition.questions[0].status=='NO'||condition.questions[1].status=='YES')&&condition.description" class="row" style="width: 100%;margin-left: 4px;">
														<div class='klistItem' style="width:100%;">
															<p style="width:75%;">{{condition.description.label}}</p>
															<textarea style="width:100%" [(ngModel)]="condition.description.text"></textarea>
														</div>
														<div class='klistItem' style="width:86%;">
															<p style="width:75%;">Were any deficiencies identified that could be categorized as a Critical, PR-90, Priority or Operational Repair?</p>
														</div>
														<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
															<select style="width:100%" [(ngModel)]="condition.hasDeficiencies">
																<option value="YES" >Yes</option>
																<option value="NO" >No</option>					                  
															</select>
														</div>
													</div>
													<div *ngIf="condition.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
														<ng-container *ngFor="let item of condition.deficiencies;let i=index; trackBy:trackByFuntion">
															<div class='klistItem' style="width:83.45%;">
																<p>{{item.cat}}</p>
															</div>
															<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
																<select style="width:100%" [(ngModel)]="item.status">
																	<option value="YES" >Yes</option>
																	<option value="NO" >No</option>					                  
																</select>
															</div>
															<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
																<div class='klistItem' style="width:20%;">
																	<p>Provide a brief description:</p>
																</div>
																<div class='klistItem' style="width:74%;margin-left: 1%;">
																	<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies()"></textarea>
																</div>
																<ng-container *ngIf="item.type!='ors'">
																	<div class='klistItem' style="width:20%;">
																		<p>Cost to cure:<i class="fa fa-info-circle" title="Provide any costs for the above noted repairs here. If there are multiple costs, sum those costs and put a single number in this field."></i></p>
																	</div>
																	<div class='klistItem' style="width:20%;margin-left: 1%;">
																		$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 90%;"  (change)="getAllDeficiencies()">
																	</div>
																</ng-container>
															</div>
														</ng-container>
													</div>
													<p *ngIf="condition.intro">Please go to the <i>Problematic Materials and Conditions</i> section at the top of this page for further discussion.</p>
													
												
																					
										</div>
										
									</div>
											 
								</ng-container>
								</div>
						</div>
						<div *ngIf="sec1.otherDetail.ifPresent" class="row" style="width: 100%;margin-left: 4px;">
							<div class='klistItem' style="width:86%;">
								<p style="width:75%;">{{sec1.otherDetail.ifPresent.question}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="sec1.otherDetail.ifPresent.status">
									<option value="YES">Yes</option>
									<option value="NO">No</option>												                  
								</select>
							</div>
						</div>
						<div *ngIf="(!sec1.otherDetail.ifPresent||sec1.otherDetail.ifPresent?.status=='YES')&&(!sec1.otherDetail.providers&&(!sec1.otherDetail.ifConditions))" style="width: 100%; margin-bottom: 4px;">
							<p>Description:</p>
							<textarea [(ngModel)]="sec1.otherDetail.description" style="width: 100%;"></textarea>
						</div>
					
				<div *ngIf="(!sec1.otherDetail.ifPresent||sec1.otherDetail.ifPresent?.status=='YES')&&(!sec1.otherDetail.ifConditions)" class="row" style="width: 100%;margin-left: 4px;">
					<div class='klistItem' style="width:86%;">
						<p style="width:75%;">What is the general condition of these component?</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<select style="width:100%" [(ngModel)]="sec1.otherDetail.condition">
							<option value="Excellent" >Excellent</option>
							<option value="Above Average" >Above Average</option>	
							<option value="Average" >Average</option>
							<option value="Below Average" >Below Average</option>
							<option value="Inferior" >Inferior</option>				                  
						</select>
					</div>
					<div class="row" *ngIf="sec1.otherDetail.detailQuestion" style="width: 100%;;margin-left: 0">
						<ng-container *ngFor="let detailQ of sec1.otherDetail.detailQuestion">
							<div class='klistItem' style="width:86%;">
								<p style="width:75%;">{{detailQ.question}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="detailQ.status">
									<option value="YES">Yes</option>
									<option value="NO">No</option>					                  
								</select>									
							</div>
							<div class="row" *ngIf="detailQ.status=='NO'&&detailQ.sub" style="width: 100%;;margin-left: 10px">
								<div class='klistItem' style="width:86%;">
									<p style="width:75%;">{{detailQ.sub.label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%;margin-right: 10px;float: right;" [(ngModel)]="detailQ.sub.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>										
								</div>
								<div class="row" *ngIf="detailQ.sub.status=='NO'&&detailQ.sub.sub" style="width: 100%;;margin-left: 10px">
									<div class='klistItem' style="width:86%;">
										<p style="width:75%;">{{detailQ.sub.sub.label}}</p>
									</div>
									<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
										<select style="width:100%;margin-right: 20px;float: right;" [(ngModel)]="detailQ.sub.sub.status">
											<option value="YES" >Yes</option>
											<option value="NO" >No</option>					                  
										</select>											
									</div>
									<div class="row" *ngIf="detailQ.sub.sub.status=='NO'&&detailQ.sub.sub.costs" style="width: 100%;margin-left: 10px;">
										<ng-container *ngFor="let costitem of detailQ.sub.sub.costs; let l=index">
										<div class='klistItem' style="width:82%;">
											<p style="width:75%;">{{costitem.description}}</p>
										</div>
										<label class='klistItem' style="width:2%;"*ngIf="l">$</label>
										<div class='klistItem' style="width:2%;" *ngIf="l==0"></div>
										<div class='klistItem' style="width:12%;text-align: center;">
											<input style="width:90%; float:right;margin-right: 10px;" [(ngModel)]="costitem.cost" (change)="validateInput($event, costitem, 'cost')">
										</div>
										</ng-container>
									</div>
								</div>
							</div>
							<div class="row" *ngIf="detailQ.status=='NO'&&detailQ.costs" style="width:100%; margin-left: 10px;">
								<ng-container *ngFor="let costitem of detailQ.costs;let h=index">
									<div class='klistItem' style="width:84%">
										<p style="width:75%;">{{costitem.description}}</p>
									</div>
									<div class='klistItem' style="width:2%;" *ngIf="h==0"></div>
									<label class='klistItem' style="width:2%;"*ngIf="h">$</label>
									<div class='klistItem' style="width:12%;text-align: center">
										<input style="width:90%; float:right;margin-right: 10px;" [(ngModel)]="costitem.cost" (change)="validateInput($event, costitem, 'cost')">											
									</div>
								</ng-container>
							</div>
						</ng-container>

					</div>
					<div class='klistItem' style="width:86%;">
						<p style="width:75%;">Did management report any concerns or were any deficiencies identified?</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<select style="width:100%" [(ngModel)]="sec1.otherDetail.hasDeficiencies">
							<option value="YES" >Yes</option>
							<option value="NO" >No</option>					                  
						</select>
					</div>
				</div>
				<div *ngIf="sec1.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
					<ng-container *ngFor="let item of sec1.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
						<div class='klistItem' style="width:83.45%;">
							<p>{{item.cat}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="item.status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
							<div class='klistItem' style="width:20%;">
								<p>Provide a brief description:</p>
							</div>
							<div class='klistItem' style="width:74%;margin-left: 1%;">
								<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies()"></textarea>
							</div>
							<ng-container *ngIf="item.type!='ors'">
								<div class='klistItem' style="width:20%;">
									<p>Cost to cure:</p>
								</div>
								<div class='klistItem' style="width:20%;margin-left: 1%;">
									$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies()">
								</div>
							</ng-container>
						</div>
					</ng-container>
				</div>
			</ng-container>
			</div>
</div>
</ng-container>
<ng-container *ngFor="let sec of contents[2].SUB_SECTIONS|slice:-4:-2; trackBy: trackByFuntion; let j=index">
	<div style="width:100%">
		<h6 [id]="sec.id" [ngStyle]="{'color':listid==sec.id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{sec.SECTION_TITLE}}</h6>
	<div *ngIf="sec.data.laws"   class="row" style="width: 100%;margin-left: 4px;">
		<div class='klistItem' style="width:86%;">
			<p style="width:100%;">{{sec.data.laws.label}}</p>
		</div>
		<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="sec.data.laws.status" (change)="clearOther(sec.data)">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>			
	</div>
	<div *ngIf="sec.data.detail&&sec.data.laws.status=='YES'" class="row" style="width: 100%;margin-left: 4px;">
		<div class='klistItem' style="width:86%;">
			<p style="width:100%;">{{sec.data.detail.label}}</p>
		</div>
		<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="sec.data.detail.status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>			
	</div>
	<div *ngIf="sec.data.needRepair&&sec.data.laws.status=='NO'" class="row" style="width: 100%;margin-left: 0;display: inline-block;">
		<div class='klistItem' style="width:86.5%;">
			<p style="width:80%;">{{sec.data.needRepair.label}}</p>
		</div>
		<div  class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<select style="width:100%" [(ngModel)]="sec.data.needRepair.status">
				<option value="YES" >Yes</option>
				<option value="NO" >No</option>					                  
			</select>
		</div>	
			
	</div>
	<div  *ngIf="sec.data.laws.status=='NO'&&sec.data.needRepair&&sec.data.needRepair.status=='YES'"> 
		<label style="margin-left: 40px;">Provide a brief description:</label>
		<textarea [(ngModel)]="sec.data.needRepair.description" style="width:73%; float: right;margin-right: 10px;"></textarea>
	</div>
		
	<div *ngIf="((j==0&&sec.data.detail.status=='NO')||(j==1&&sec.data.detail.status=='YES'))&&sec.data.laws.status=='YES'" style="margin-left: 4px;">
		<p>Description:</p>
		<textarea style="width:99%; margin-bottom: 4px;" [(ngModel)]="sec.data.description"></textarea>
		<p *ngIf="j==0">Identify the type of repair required below to correct the deficiency:</p>
		<div class="row" style="width: 100%;margin-left: 20px;">
			<ng-container *ngFor="let item of sec.data.deficiencies;let i=index; trackBy:trackByFuntion">
				<div class='klistItem' style="width:83.45%;">
					<p>{{item.cat}}</p>
				</div>
				<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
					<select style="width:100%" [(ngModel)]="item.status">
						<option value="YES" >Yes</option>
						<option value="NO" >No</option>					                  
					</select>
				</div>
				<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
					<div class='klistItem' style="width:20%;">
						<p>Provide a brief description:</p>
					</div>
					<div class='klistItem' style="width:74%;margin-left: 1%;">
						<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies()"></textarea>
					</div>
					<ng-container *ngIf="item.type!='ors'">
						<div class='klistItem' style="width:20%;">
							<p>Cost to cure:</p>
						</div>
						<div class='klistItem' style="width:20%;margin-left: 1%;">
							$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies()">
						</div>
					</ng-container>
				</div>					
			</ng-container>
		</div>
	</div>	
</div>
</ng-container>

<div style="width:100%">
	<h6 [id]="contents[2].SUB_SECTIONS[8].id" [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[8].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[2].SUB_SECTIONS[8].SECTION_TITLE}}</h6>
	<div class="row" style="width: 100%;margin-left: 0;">
		<div class='klistItem' style="width:86.45%;">
			<p>Total number of outstanding municipal violations as of the date of the site visit:</p>
		</div>
		<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
			<input type="number" min="0" max="1000000" style="width: 100%;" [(ngModel)]="contents[2].SUB_SECTIONS[8].data.violationCount">
		</div>					
		
	</div>
	<p>Provide a general description of the types of violations, excluding those that are considered life/safety issues or significant deficiencies:</p>
	<textarea style="width:100%" [(ngModel)]="contents[2].SUB_SECTIONS[8].data.description"></textarea>
	<p>List the violations and costs to cure below for those findings that are considered to be life/safety issues or significant deficiencies.</p>
	<p><b>Note: costs and descriptions should not be duplicated elsewhere in this report.</b></p>
	<table>
		<thead>
			<tr>
				<th class="frm-graycell" style="width:70%">Description of violation</th>
				<th class="frm-graycell" style="width:18%">Underlying physical<br> issue resolved?</th>
				<th class="frm-graycell" style="width:12%">Cost to Cure</th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let row of contents[2].SUB_SECTIONS[8].data.list">
				<tr>
					<td>
						<textarea style="width:100%" row='1' [(ngModel)]="row.description"></textarea>
					</td>
					<td>
						<select style="width:100%" [(ngModel)]="row.status">
							<option value="Yes" >Yes</option>
							<option value="No" >No</option>					                  
						</select>
					</td>
					<td>
						<input type="number" min="0" max="1000000" style="width: 100%;" [(ngModel)]="row.cost" (change)="validateInput($event, row, 'cost')">
					</td>
				</tr>
			</ng-container>
		</tbody>
	</table>
	
	<div style="margin: 10px 0;position:relative; height:20px">
		<button class="frmBtn" style="float:right" (click)="insertViolationRow(contents[2].SUB_SECTIONS[8].data)">Add</button>
		<button class="frmBtn" *ngIf="contents[2].SUB_SECTIONS[8].data.list.length>0" style="float:right"(click)="deleteViolationRow(contents[2].SUB_SECTIONS[8].data)">Delete Last Entry</button>		  
	</div>		
</div>
<div style="width:100%">
	<h6 [id]="contents[2].SUB_SECTIONS[9].id" [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[9].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[2].SUB_SECTIONS[9].SECTION_TITLE}}</h6>
	<p>Provide a history of repairs and capital improvements for the last 12 months along with improvements planned for the next 24 months.</p>
	<table style="width: 100%;">
		<tbody>	
			<ng-container *ngFor="let row of contents[2].SUB_SECTIONS[9].data.list">
			
				<tr>
					<td  class="frm-graycell" rowspan="2"  style="width: 19%;">Description</td>
					<td rowspan="2"  style="width: 60%;">
						<textarea style="width:100%" row='1' [(ngModel)]="row.description"></textarea>
					</td>
					<td  class="frm-graycell" colspan="2"  style="width: 6%;text-align: right">Status</td>
					<td  style="width:15%;">
						<select style="width:100%" [(ngModel)]="row.status">
							<option value="">&lt;select &gt;</option>
							<option value="In progress">In progress</option>
							<option value="Completed">Completed</option>
							<option value="Planned">Planned</option>					                  
						</select>
					</td>
				</tr>
				<tr>
					<td  class="frm-graycell" colspan="2"  style="width: 6%;text-align: right;">Cost</td>
					<td  style="width: 15%;">
						$<input type="number" min="0" max="1000000" style="width: 90%;" [(ngModel)]="row.cost"  (change)="validateInput($event, row, 'cost')">
					</td>
				</tr>
			</ng-container>
		</tbody>
	</table>
	<div style="margin: 10px 0;position:relative; height:20px">
		<button class="frmBtn" style="float:right" (click)="insertViolationRow(contents[2].SUB_SECTIONS[9].data)">Add</button>
		<button class="frmBtn" *ngIf="contents[2].SUB_SECTIONS[9].data.list.length>0" style="float:right"(click)="deleteViolationRow(contents[2].SUB_SECTIONS[9].data)">Delete Last Entry</button>		  
	</div>	
</div>	
</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Section IV: Environmental Site Assessment-->
<h6 [id]="contents[3].id" [ngStyle]="{'background-color':listid==contents[3].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">{{contents[3].SECTION_TITLE}}</h6>
<div style="width:100%"><!--Environmental Summary-->
	<h6 [id]="contents[3].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[3].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		
			<div style="width:100%;display:inline-block">
				<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.summary">
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<label style="margin-left:4px; width: 34%;" >{{item.label}}</label>
					<label style="width: 13%;"><input type="checkbox" [checked]="item.acceptable=='Y'"  (change)="summaryCheck($event, item, 'acceptable')">Acceptable</label>
					<label *ngIf="!item.requireMMP" style="width: 15%;"><input type="checkbox" [checked]="item.requireOM=='Y'" (change)="summaryCheck($event, item, 'requireOM')">O&M required</label>
					<label *ngIf="item.requireMMP" style="width: 15%;"><input type="checkbox" [checked]="item.requireMMP=='Y'"  (change)="summaryCheck($event, item, 'requireMMP')">MMP required</label>
					<label *ngIf="item.requireMMP" style="width: 23%;"></label>
					<label *ngIf="!item.requireMMP" style="width: 23%;"><input type="checkbox" [checked]="item.requireFurther=='Y'"  (change)="summaryCheck($event, item, 'requireFurther')">Further testing required</label>
					<label style="width: 14%;"><input type="checkbox" [checked]="item.notacceptable=='Y'"  (change)="summaryCheck($event, item, 'notacceptable')">Not Acceptable</label>					
				</div>
				</ng-container>
			</div>
			<div style="width:100%;display:inline-block">
				<div style="height:4px; border:none"></div>
				<div class="row" style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<div class='klistItem' style="width:87%;">
						<p>{{contents[3].SUB_SECTIONS[0].data.law.label}}</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[0].data.law.status">
							<option value="YES" >Yes</option>
							<option value="NO" >No</option>					                  
						</select>
					</div>
				</div>
			</div>
			<div>
				<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.questions">
					<ng-container *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'">
						<p>{{item.label}}</p>
						<textarea row="2" [(ngModel)]="item.description" style="width:100%"></textarea>
					</ng-container>
					
				</ng-container>
			</div>
			<div>
				<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[0].data.discuss">
					<ng-container *ngIf="item.field=='notacceptable'">
						<div *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'||contents[3].SUB_SECTIONS[0].data.summary[item.required].acceptable=='Y'" [innerHTML]="item.label"></div>
					</ng-container>
					<ng-container *ngIf="item.field=='requireFurther'">
						<div *ngIf="contents[3].SUB_SECTIONS[0].data.summary[item.required][item.field]=='Y'" [innerHTML]="item.label"></div>
					</ng-container>
					
				</ng-container>
			</div>
	</div>
	<h6 [id]="contents[3].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{contents[3].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
			<div style="width:100%;display:inline-block">
				<div class="row" style="width:100%;margin-left: 0;">
					
						<div class='klistItem' style="width:87%;">
							<p>{{contents[3].SUB_SECTIONS[1].data.issues[0].label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.issues[0].status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						<ng-container *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='YES'">
							<div class='klistItem' style="width:87%;">
								<p>{{contents[3].SUB_SECTIONS[1].data.issues[1].label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.issues[1].status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="contents[3].SUB_SECTIONS[1].data.issues[1].status=='YES'" style="margin-left: 20px;width:100%">
								<p>Describe:</p>
								<textarea style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.issues[1].description"></textarea>
							</div>
					</ng-container>
				</div>
						<ng-container *ngIf="contents[3].SUB_SECTIONS[1].data.issues[0].status=='YES'&&contents[3].SUB_SECTIONS[1].data.issues[1].status=='YES'">
						<div *ngIf="contents[3].SUB_SECTIONS[1].data.other" class="row" style="width:100%;margin-left: 20px;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[1].data.other">
							<div class='klistItem' style="width:83.45%;">
								<p style="width:75%;">{{item.label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
						</ng-container>
							</div>
						<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail" class="row" style="width:100%;margin-left: 20px;">
						<div class='klistItem' style="width:83.45%;">
							<p style="width:90%;">{{contents[3].SUB_SECTIONS[1].data.otherDetail.label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						</div>
					
					<div *ngIf="contents[3].SUB_SECTIONS[1].data.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
						<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[1].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class='klistItem' style="width:83.45%;">
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
								<div class='klistItem' style="width:20%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem' style="width:74%;margin-left: 1%;">
									<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies()"></textarea>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem' style="width:20%;">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem' style="width:20%;margin-left: 1%;">
										$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies()">
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</ng-container>
				
					
				</div>
			</div>
			<h6 [id]="contents[3].SUB_SECTIONS[2].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{contents[3].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
			
			<div style="width:100%;display:inline-block">
				<ng-container *ngFor="let items of contents[3].SUB_SECTIONS[2].data">
					<div style="width:100%;display:inline-block">
				<div class="row" style="width:100%;margin-left: 0;">
					
						<div class='klistItem' style="width:87%;">
							<p>{{items.issues[0].label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="items.issues[0].status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						<ng-container *ngIf="items.issues[0].status=='YES'">
							<p>{{items.issues[0].descriptionLabel}}</p>
							<table>
								<thead>
									<th class="frm-graycell" style="width:86%">Location</th>
									<th class="frm-graycell" style="width:14%">Condition</th>
									<th class="frm-graycell" style="width:14%">Potential for disturbance</th>
								</thead>
								<tbody>
									<ng-container *ngFor="let row of items.issues[0].materials">
										<tr>
											<td>
												<textarea rows="2" [(ngModel)]="row.location" style="width: 100%;"></textarea>
											</td>
											<td>
												<select  style="width: 100%;" [(ngModel)]="row.condition">
													<option>Damaged</option>
													<option>Undamaged</option>
												</select>
											</td>
											<td>
												<select  style="width: 100%;" [(ngModel)]="row.disturbance">
													<option>High</option>
													<option>Low</option>
													<option>Restricted from tenant access</option>
													<option>Only during construction activities</option>
												</select>
											</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
							<div style="margin: 10px 0;position:relative; height:20px">
								<button class="frmBtn" style="float:right" (click)="insertMaterials(items.issues[0])">Add</button>
								<button *ngIf="items.issues[0].materials.length>1" class="frmBtn" style="float:right" (click)="deleteMaterials(items.issues[0])">Delete Last Entry</button>		  
							</div>									
								<div  class="row" style="width:100%;margin-left: 20px;">
								<div   class='klistItem' style="width:85%;">
									<p>{{items.issues[1].label}}</p>
								</div>
								<div   class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="items.issues[1].status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
							</div>
							<div  *ngIf="items.issues[1].status=='YES'" class="row" style="width:100%;margin-left: 20px;">
								<div  *ngIf="items.issues[1].moreinfo" style="width:100%; margin-left: 0">
									<p>{{items.issues[1].descriptionLabel}}</p>
									<textarea style="width:98%" [(ngModel)]="items.issues[1].description"></textarea>
								</div>
								<div  class='klistItem' style="width:85%;">
									<p>{{items.issues[2].label}}</p>									
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="items.issues[2].status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>							
								<div  *ngIf="items.issues[2].status=='YES'" style="width:100%; margin-left: 0">
									<p>{{items.issues[2].descriptionLabel}}</p>
									<textarea style="width:98%" [(ngModel)]="items.issues[2].description"></textarea>
								</div>
							</div>
							
					</ng-container>
				</div>
						<ng-container *ngIf="items.issues[0].status=='YES'">
						<!--<div *ngIf="items.other" class="row" style="width:100%;margin-left: 20px;margin-top: 10px;">
							<ng-container *ngFor="let item of items.other">
								<div class='klistItem' style="width:83.45%;">
									<p style="width:75%;">{{item.label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
							</ng-container>
						</div>-->
						<div *ngIf="items.otherDetail" class="row" style="width:100%;margin-left: 20px;">
						<div class='klistItem' style="width:84.45%;">
							<p style="width:90%;">{{items.otherDetail.label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="items.otherDetail.hasDeficiencies">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
						
					
					<div *ngIf="items.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
						<ng-container *ngFor="let item of items.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class='klistItem' style="width:82%;">
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
								<div class='klistItem' style="width:20%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem' style="width:73%;margin-left: 1%;">
									<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;"  (change)="getAllDeficiencies()"></textarea>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem' style="width:20%;">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem' style="width:20%;margin-left: 1%;">
										$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;"  (change)="getAllDeficiencies()">
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
				</ng-container>
			</div>
			</ng-container>	
				
			</div>
			<h6 [id]="contents[3].SUB_SECTIONS[3].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[3].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{contents[3].SUB_SECTIONS[3].SECTION_TITLE}}</h6>
			
			<div style="width:100%;display:inline-block">
				
				<div style="width:100%;display:inline-block">
				<div class="row" style="width:100%;margin-left: 0;">
					
						<div class='klistItem' style="width:87%;">
							<p>{{contents[3].SUB_SECTIONS[3].data.issues[0].label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[3].data.issues[0].status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
					</div>
						<ng-container *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'">
							<p>{{contents[3].SUB_SECTIONS[3].data.issues[0].descriptionLabel}}</p>
							<table>
								<thead>
									<th class="frm-graycell" style="width:86%">Location</th>
									<th class="frm-graycell" style="width:14%">Condition</th>
								</thead>
								<tbody>
									<ng-container *ngFor="let row of contents[3].SUB_SECTIONS[3].data.issues[0].materials">
										<tr>
											<td>
												<textarea rows="2" [(ngModel)]="row.location" style="width: 100%;"></textarea>
											</td>
											<td>
												<select  style="width: 100%;" [(ngModel)]="row.condition">
													<option>Damaged</option>
													<option>Undamaged</option>
												</select>
											</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
							<div style="margin: 10px 0;position:relative; height:20px">
								<button class="frmBtn" style="float:right" (click)="insertMaterials(contents[3].SUB_SECTIONS[3].data.issues[0])">Add</button>
								<button *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].materials.length>1" class="frmBtn" style="float:right"(click)="deleteMaterials(contents[3].SUB_SECTIONS[3].data.issues[0])">Delete Last Entry</button>		  
							</div>									
						</ng-container>
				
						<ng-container *ngIf="contents[3].SUB_SECTIONS[3].data.issues[0].status=='YES'">
							<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail" class="row" style="width:100%;margin-left: 20px;">
							<div class='klistItem' style="width:84.45%;">
								<p style="width:90%;">{{contents[3].SUB_SECTIONS[3].data.otherDetail.label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
						
					
					<div *ngIf="contents[3].SUB_SECTIONS[3].data.otherDetail.hasDeficiencies=='YES'" class="row" style="width: 100%;margin-left: 20px;">
						<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[3].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class='klistItem' style="width:82%;">
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
								<div class='klistItem' style="width:20%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem' style="width:73%;margin-left: 1%;">
									<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;" (change)="getAllDeficiencies()"></textarea>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem' style="width:20%;">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem' style="width:20%;margin-left: 1%;">
										$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;" (change)="getAllDeficiencies()">
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
				</ng-container>
			</div>
			
				
			</div>	
			<h6 [id]="contents[3].SUB_SECTIONS[4].id" [ngStyle]="{'color':listid==contents[3].SUB_SECTIONS[4].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{contents[3].SUB_SECTIONS[4].SECTION_TITLE}}</h6>
			
			<div style="width:100%;display:inline-block">
				
				<div style="width:100%;display:inline-block">
				<div class="row" style="width:100%;margin-left: 0;">
					
						<div class='klistItem' style="width:87%;">
							<p>{{contents[3].SUB_SECTIONS[4].data.issues[0].label}}</p>
						</div>
						<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
							<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[4].data.issues[0].status">
								<option value="YES" >Yes</option>
								<option value="NO" >No</option>					                  
							</select>
						</div>
					</div>
						
						<ol>
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.issues[0].items">
								<li style="font-weight: normal;">{{item}}</li>
							</ng-container>
						</ol>
						<ng-container *ngIf="contents[3].SUB_SECTIONS[4].data.issues[0].status=='NO'">
							<p>{{contents[3].SUB_SECTIONS[4].data.issues[0].descriptionLabel}}</p>
							<textarea  rows="2" [(ngModel)]="contents[3].SUB_SECTIONS[4].data.issues[0].description" style="width: 100%;"></textarea>								
						</ng-container>
						<div *ngIf="(contents[3].SUB_SECTIONS[4].data.issues[0].status==='YES'||contents[3].SUB_SECTIONS[4].data.issues[0].status==='NO')&&contents[3].SUB_SECTIONS[4].data.other" class="row" style="width:100%;margin-left: 0;">
							<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.other">
								<div class='klistItem' style="width:87%;">
									<p style="width:75%;">{{item.label}}</p>
								</div>
								<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
									<select style="width:100%" [(ngModel)]="item.status" (change)="ifdeficiencies($event, contents[3].SUB_SECTIONS[4].data)">
										<option value="YES" >Yes</option>
										<option value="NO" >No</option>					                  
									</select>
								</div>
								<ng-container *ngIf="item.status=='YES'">
									<p>{{item.descriptionLabel}}</p>
									<textarea  rows="2" [(ngModel)]="item.description" style="width: 100%;"></textarea>								
								</ng-container>
							</ng-container>
						</div>
						<ng-container *ngIf="contents[3].SUB_SECTIONS[4].data.other[0].status=='YES'&&contents[3].SUB_SECTIONS[4].data.other[0].status=='YES'">
							<div *ngIf="contents[3].SUB_SECTIONS[4].data.otherDetail" class="row" style="width:100%;margin-left: 20px;">
							<div class='klistItem' style="width:84.25%;">
								<p style="width:90%;">{{contents[3].SUB_SECTIONS[4].data.otherDetail.label}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<!--<select style="width:100%" [(ngModel)]="contents[3].SUB_SECTIONS[4].data.otherDetail.hasDeficiencies">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>-->
							</div>
						
					
					<div class="row" style="width: 100%;margin-left: 20px;">
						<ng-container *ngFor="let item of contents[3].SUB_SECTIONS[4].data.otherDetail.deficiencies;let i=index; trackBy:trackByFuntion">
							<div class='klistItem' style="width:82%;">
								<p>{{item.cat}}</p>
							</div>
							<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
								<select style="width:100%" [(ngModel)]="item.status">
									<option value="YES" >Yes</option>
									<option value="NO" >No</option>					                  
								</select>
							</div>
							<div *ngIf="item.status=='YES'" class="row" style="padding: auto;margin-left: 10px;width: 100%;">
								<div class='klistItem' style="width:20%;">
									<p>Provide a brief description:</p>
								</div>
								<div class='klistItem' style="width:73%;margin-left: 1%;">
									<textarea rows="2" [(ngModel)]="item.description" style="width: 100%;" (change)="getAllDeficiencies()"></textarea>
								</div>
								<ng-container *ngIf="item.type!='ors'">
									<div class='klistItem' style="width:20%;">
										<p>Cost to cure:</p>
									</div>
									<div class='klistItem' style="width:20%;margin-left: 1%;">
										$<input type='number' [(ngModel)]="item.cost" min="0" max="100000000" style="width: 95%;" (change)="getAllDeficiencies()">
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
				</ng-container>
			</div>
			
				
			</div>	
			
	
</div>
</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Section V: List of Repairs and Capital Needs Over the Loan Term-->
<h6 [id]="contents[4].id" [ngStyle]="{'background-color':listid==contents[4].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">{{contents[4].SECTION_TITLE}}</h6>
<div style="width:100%"><!--Summary of Repairs and Violations-->
	<h6 [id]="contents[4].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[4].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}"  style="background-color:black;padding:4px">{{contents[4].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
	<p>{{contents[4].SUB_SECTIONS[0].data.intro}}</p>
	<div style="width:100%; display:inline; position:relative">
		<ng-container *ngFor="let repairdata of contents[4].SUB_SECTIONS[0].data.summarylabel; let i=index; trackBy:trackByFuntion">
			<ng-container *ngIf="contents[4].SUB_SECTIONS[0].data.summarydata[repairdata.field].length>0" >
			<h6 style="border-bottom:2px solid black;border-left:2px solid black;width:30%; margin-bottom: 0; ">{{repairdata.label}}</h6>
			<table style="margin-top: 0;border: none;margin-bottom: 20px;">
				<thead>
					<ng-container *ngFor="let col of repairdata.cols; let j=index; trackBy:trackByFuntion">
						<th style="border:none" [ngStyle]="{'width':repairdata.space[j],'text-align':j==2?'center':'left'}">{{col}}</th>
					</ng-container>					
				</thead>
				<tbody>
					<ng-container *ngFor="let rowdata of contents[4].SUB_SECTIONS[0].data.summarydata[repairdata.field]; let j=index; trackBy:trackByFuntion">
						<tr>
							<ng-container *ngFor="let cell of repairdata.rows">
								<td style="border:1px black solid; border-collapse: collapse;" *ngIf="cell!='cost'">{{rowdata[cell]}}</td>
								<td style="border:1px black solid; border-collapse: collapse;" *ngIf="cell=='cost'" >{{USDollar.format(rowdata[cell])}}</td>
							</ng-container>
						</tr>						
					</ng-container>
					<ng-container *ngIf="repairdata.field!='ors';">
						<tr>
							<td colspan="2" style="text-align: right;">
								TOTAL
							</td>
							<td class="frm-graycell">
								{{USDollar.format(repairdata.total)}}
							</td>
						</tr>					
				</ng-container>
				</tbody>
			</table>
		</ng-container>
		</ng-container>

		
			
	</div>		
</div>
<div style="width:100%"><!--Repair Costs-->
	<h6 [id]="contents[4].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[4].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[4].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">			
			<div style="width:100%;display:inline-block">					
				<div class="row" style="display:inline-block;margin:0;width:100%;">
					<div class='klistItem' style="width:87%;">
						<p>{{contents[4].SUB_SECTIONS[1].data.label}}</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<select style="width:100%" [(ngModel)]="contents[4].SUB_SECTIONS[1].data.status">
							<option value="YES" >Yes</option>
							<option value="NO" >No</option>					                  
						</select>
					</div>
					<ng-container *ngIf="contents[4].SUB_SECTIONS[1].data.status=='YES'">
						<p>{{contents[4].SUB_SECTIONS[1].data.descriptionLabel}}</p>
						<textarea  rows="2" [(ngModel)]="contents[4].SUB_SECTIONS[1].data.description" style="width: 100%;"></textarea>								
					</ng-container>
				</div>
			</div>
		</div>		
</div>
<div style="width:100%"><!--Overall Property Condition Rating/Capital Needs Over the Loan Term-->
	<h6 [id]="contents[4].SUB_SECTIONS[2].id" [ngStyle]="{'color':listid==contents[4].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[4].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
	<p>{{contents[4].SUB_SECTIONS[2].data.intro}}</p>
	<div style="width:100%; display:inline; position:relative">
			<div style="width:100%;display:inline-block; margin-left: 20px;">
				<div style="border-bottom: 1px solid black;margin-top: 10px;">
					<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Excellent'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Excellent')"><label class="rateItem">Excellent</label>
				</div>
				<hr class="line1">
				<p>Thee Property is new or maintained in like new condition with proactive maintenance practices, thus exhibiting no deferred maintenance or life safety/code issues.</p>
				<div>
					<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Above Average'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Above Average')"><label class="rateItem">Above Average</label>
				</div>
				<hr class="line1">
				<p>The Property is fully functional, well maintained, exhibits minimal wear and tear and no deferred maintenance or life safety/code issues. Any identified repairs are due to recent events (e.g., a wind storm or a burst pipe) or are very limited in scope (routine maintenance). Low reserves are required.</p>
				<div>
					<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Average'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Average')"><label class="rateItem">Average</label>
				</div>
				<hr class="line1">
				<p>The Property is fully functional and generally well maintained. It may exhibit customary wear and tear based on age and may have minimal deferred maintenance. Any life safety/code issues can be readily corrected as part of the operating budget and are isolated in nature. Moderate reserves are required.</p>
				<div style="margin: 0;padding:0">
					<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Below Average'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Below Average')"><label class="rateItem">Below Average</label>
				</div>
				<hr class="line1">
				<p>The Property exhibits pervasive wear and tear, some limits in functionality and deferred maintenance issues. Life safety/code issues are significant and/or numerous and involve substantial cost. High reserves are required.</p>
				<div>
					<input type="radio" name="frm1104-4-2" [checked]="contents[4].SUB_SECTIONS[2].data.rate=='Inferior'" (change)="selectRate($event, contents[4].SUB_SECTIONS[2].data, 'Inferior')"><label class="rateItem">Inferior</label>
				</div>
				<hr class="line1">
				<p>The Property exhibits inferior/deteriorating conditions and some limits in functionality. Deferred maintenance is pervasive and will be costly to cure. Multiple life safety/code issues are identified and involve significant cost. Extensive repairs are required.</p>
				<p style="margin-top: 30px;">{{contents[4].SUB_SECTIONS[2].data.descriptionLabel}}</p>
				<textarea  rows="2" [(ngModel)]="contents[4].SUB_SECTIONS[2].data.description" style="width: 100%;"></textarea>					
			</div>
		</div>		
</div>	
</div>
<div style="margin-top: 6px;font-size: 12px;"><!--Section VI: Definitions-->
<h6 [id]="contents[5].id" [ngStyle]="{'background-color':listid==contents[5].id?'rgb(195, 212, 47)':'white'}"  style="text-align: right; padding:4px">{{contents[5].SECTION_TITLE}}</h6>
<div style="width:100%"><!--Section VI: Definitions-->
	<h6 [id]="contents[5].SUB_SECTIONS[0].id" [ngStyle]="{'color':listid==contents[5].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[5].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		<div style="border-bottom: 1px solid black;margin-top: 4px;">
			<p class="rateItem">Excellent</p>
		</div>
		<p>The component is new or maintained in like new condition with proactive maintenance practices, thus exhibiting no deferred maintenance or life safety/code issues.</p>
			<p class="rateItem">Above Average</p>
			<hr class="line1">
		<p>The component is fully functional, well maintained, exhibits minimal wear and tear and no deferred maintenance or life safety/code issues. Any identified repairs are due to recent events (e.g., a wind storm or a burst pipe) or are very limited in scope (routine maintenance). Low reserves are required.</p>	
			<p class="rateItem">Average</p>
			<hr class="line1">
		<p>The component is fully functional and generally well maintained. It may exhibit customary wear and tear based on age and may have minimal deferred maintenance. Any life/safety codes issues can be readily corrected as part of the operating budget and are isolated in nature. Moderate reserves are required.</p>	
			<p class="rateItem">Below Average</p>
			<hr class="line1">
		<p>The component exhibits pervasive wear and tear, some limits in functionality and deferred maintenance issues. Life safety/code issues are significant and/or numerous and involve substantial cost. High reserves are required.</p>	
			<p class="rateItem">Inferior</p>
			<hr class="line1">
		<p>The component exhibits inferior/deteriorating conditions and some limits in functionality. Deferred maintenance is pervasive and will be costly to cure. Multiple life safety/code issues are identified and involve significant cost. Extensive repairs are required.</p>		
	</div>		
</div>
<div style="width:100%"><!--Section VI: Definitions-->
	<h6 [id]="contents[5].SUB_SECTIONS[1].id" [ngStyle]="{'color':listid==contents[5].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px">{{contents[5].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		
			<p class="rateItem">Critical Repairs</p>
			<hr class="line1">
		<p>These are repairs and replacements that significantly impact habitability, value, income or marketability and that must be corrected before Freddie Mac will proceed with the transaction.</p>
			<p class="rateItem">PR-90 Repairs</p>
			<hr class="line1">
		<p>These are corrective actions that must be completed within 90 days, and are limited to:</p>
		<ul>
			<li>Imminent life safety hazards</li>
			<li>Ongoing substantive damage to the property</li>
		
		</ul>
		
			<p class="rateItem">Priority Repairs</p>
			<hr class="line1">
		<p>These are repairs and replacements that are significant and must be addressed as soon as possible. Priority Repairs consist of:</p>
		<ul>
			<li>All non-imminent life safety hazards</li>
			<li>Violations of any federal, State or local law, ordinance or code relating to zoning, subdivision and use, building and housing accessibility (including the Americans with Disabilities and Fair Housing Acts), health matters or fire safety</li>
			<li>Material deficiencies *</li>
			<li>Significant deferred maintenance *</li>
		</ul>
		<label class="note">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</label>
		
		<p class="rateItem">Operational Repairs</p>
		<hr class="line1">
		<p>These are repairs and replacements that consist of Minor Deficiencies, Minor Deferred Maintenance and Handicap Accessibility Enhancements that are expected to be completed by the Borrower as part of a repairs and maintenance budget and that cannot be reasonably resolved by Routine Maintenance. Operational Repairs consist of:</p>
		<ul>
			<li>Minor deficiencies *</li>
			<li>Minor deferred maintenance *</li>
			<li>Handicap Accessibility Enhancements *</li>				
		</ul>
		<label class="note">* Additional guidance can be found in Section 62.3(b) of the Freddie Mac Multifamily Seller/Servicer Guide</label>
	</div>		
</div>

</div>	
</ng-container>
<ng-container *ngIf="tempInfo?.PHASE1_TYPE&&tempInfo.PHASE1_TYPE=='1103'">
	<h6 [id]='contents[0].id' [ngStyle]="{'background-color':listid==contents[0].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section I: Summary</h6>
	<div style="font-size:12px"><!--Mortgage, Consultant and Property Information-->
	<h6 [id]='contents[0].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[0].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
	<div style="width:100%; display:inline; position:relative">
		<div style="width:49.5%; display:inline-block;">
		<div style="width:49.5%;display:inline-block">
		  <div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
		  
		  </div>
		</div>
		<div style="width:49.5%;display:inline-block">
		  <div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <label style="margin-left:4px">Report date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
		  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
		<p *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
		<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>
		</div>
		</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
		  <div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		   <label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName',0,0)"><i class="far fa-list-alt"></i></a>
		   <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		   <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
		  </div>
		</div>
		<div style="width:49.5%; display:inline-block;">
		  <div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName',0,0)"><i class="far fa-list-alt"></i></a>
			<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
		  </div>
		</div>
		
		<div style="width:49.5%; display:inline-block;">
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <div style="height:4px"></div>
		  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
		<div style="width:49.5%;display:inline-block">
		  <div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId',0,0)"><i class="far fa-list-alt"></i></a>
		 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
		</div>
		<div style="width:49.5%;display:inline-block">
		  <div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate?.html" type="text" style="border:none;width:100%" />-->
		  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.VisitDate"><br>
		<p *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate" style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
		<input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate" type="text" style="border:none;width:100%" />
		  </div>
		</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
	   <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <div style="height:4px"></div>
		  <label style="margin-left:4px">City, State, Zip</label>
		  <div>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName',0,0)"><i class="far fa-list-alt"></i></a>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode',0,0)"><i class="far fa-list-alt"></i></a>
		</div>
	</div>
		</div>
		<div style="width:49.5%; display:inline-block;">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px">Environmental consultant (firm name)</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmName',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmName?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			  </div>
		<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label  style="margin-left:4px" for="frmloanNo">Number of units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'Units',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data.Units?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.Units?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.Units?.html" disabled ="text" style="border:none;width:100%"/> 
			</div>
			  </div>
			<div style="width:49.5%;display:inline-block">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px" for="frmloanNo">Number of residential buildings</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'ApartmentUnits',0,0)"><i class="far fa-list-alt"></i></a><br>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.ApartmentUnits?.html" disabled type="text" style="border:none;width:100%"/>
			  </div>
			  </div>
			</div>
			<div style="width:49.5%; display:inline-block;">
				<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<div style="height:4px"></div>
				  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmAddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
				  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmAddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
				</div>
				</div>
			
		<div style="width:49.5%; display:inline-block;">
		<div style="width:49.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <label style="margin-left:4px" for="frmloanNo">Number of ground floor units</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'GroundUnits',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.GroundUnits?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.GroundUnits?.html" disabled ="text" style="border:none;width:100%"/>
		</div>
		  </div>
		<div style="width:49.5%;display:inline-block">
		<div style="height:4px; border:none"></div>
		  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <label style="margin-left:4px" for="frmloanNo">Date of construction</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'BuildYear',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.BuildYear?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.BuildYear?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.BuildYear?.html" disabled ="text" style="border:none;width:100%"/>
		 </div>
		  </div>
		</div>
		<div style="width:49.5%; display:inline-block;">
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		<div style="height:4px"></div>
		  <label style="margin-left:4px">City, State, Zip</label>
		  <div>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmCityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'FirmCityName',0,0)"><i class="far fa-list-alt"></i></a>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmStateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'FirmStateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
			<span *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'FirmPostalCode',0,0)"><i class="far fa-list-alt"></i></a>
		</div>
		</div>
		</div>
		<div style="width:49.5%; display:inline-block;"></div>
		<div style="width:49.5%; display:inline-block;">
			<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">Telephone number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FirmPhoneNumber',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber?.html" disabled ="text" style="border:none;width:100%"/>
				  </div>
			</div>
		<div style="width:49.5%; display:inline-block;">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px">On-site contact (with title)</label>
			  <!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'OnsiteName',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html" disabled ="text" style="border:none;width:100%"/>-->
			  <div>
			  		<span *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'OnsiteName',0,0)"><i class="far fa-list-alt"></i></a>
					<span *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.html" style="display: inline-table;margin-left: 10px;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsiteTitle?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'OnsiteTitle',0,0)"><i class="far fa-list-alt"></i></a>
			  </div>
			</div>
			  </div>	
		
		<div style="width:49.5%; display:inline-block;">
			<div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px">Name of inspector</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'InspectorName',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.InspectorName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.InspectorName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			  </div>	
		<div style="width:49.5%; display:inline-block;">
		<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
		  <div style="height:4px"></div>
		  <label style="margin-left:4px">On-site contact telephone number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'OnsitePhoneNo',0,0)"><i class="far fa-list-alt"></i></a>
		  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
		  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
		</div>
		
		</div>
		<h6 [id]='contents[0].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[0].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[0].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div style="width:100%; ">
			<p>Check the applicable result for each hazard and provide costs where appropriate.</p>
			<table style="border: 1px solid black;border-left:4px solid black;text-align: center;">
				<thead>
					<th style="width:30%; text-align: left;">Environmental Issue</th>
					<th style="width:10%">Acceptable</th>
					<th style="width:25%">Indicate if O&M<br>Program Required</th>
					<th style="width:10%">Mitigation<br>Cost</th>
					<th style="width:10%">Additional<br>Information<br>Required</th>
					<th colspan="2" style="width:20%">Section and<br>Page Number(s)</th>					
				</thead>
				<tbody>
					<ng-container *ngFor="let rowdata of contents[0].SUB_SECTIONS[1].data.summary">
						<tr>
							<td>{{rowdata.label}}</td>
							<td><input type="checkbox" style="text-align: center;" [checked]="rowdata.acceptable=='Y'"  (change)="summaryCheck($event, rowdata, 'acceptable')"></td>
							<td style="position: relative;"><input *ngIf="rowdata.requireOM==''||rowdata.requireOM" type="checkbox" style="text-align: center;" [checked]="rowdata.requireOM=='Y'"  (change)="summaryCheck($event, rowdata, 'requireOM')">
								<input *ngIf="rowdata.requireMMP==''||rowdata.requireMMP" type="checkbox" style="text-align: center;" [checked]="rowdata.requireMMP=='Y'"  (change)="summaryCheck($event, rowdata, 'requireMMP')">
								<ng-container *ngIf="rowdata.requireMMP==''||rowdata.requireMMP">
									<label style="position: absolute; right:20px">MMP</label>
								</ng-container>
							</td>
							<td>$<input type="number"  min="0" max="1000000000" style="text-align: center;width:90%" [(ngModel)]="rowdata.cost" (change)="setvalue($event, rowdata)"></td>
							<td><input type="checkbox" style="text-align: center;" [checked]="rowdata.requireFurther=='Y'" (change)="summaryCheck($event, rowdata, 'requireFurther')"></td>
							<td><input type="text" size="20" style="text-align: center;width:80px"[(ngModel)]="rowdata.sectionNo"></td>
							<td><input type="text" size="20" style="text-align: center;width:80px" [(ngModel)]="rowdata.pageNo"></td>							
						</tr>
					</ng-container>
					
					
				</tbody>
			</table>
			<div style="border-left:solid 4px black; border-bottom:1px solid black;margin-top: 20PX;">
				<label>{{contents[0].SUB_SECTIONS[1].data.law.label}}</label>
				<input class="ml-3" type="checkbox" [checked]="contents[0].SUB_SECTIONS[1].data.law.status=='Y'" (change)="contents[0].SUB_SECTIONS[1].data.law.status='Y'"><label class="ml-1">Yes</label>
				<input class="ml-3" type="checkbox" [checked]="contents[0].SUB_SECTIONS[1].data.law.status=='N'" (change)="contents[0].SUB_SECTIONS[1].data.law.status='N'"><label class="ml-1">No</label>
			</div>
		</div>
		<h6 [id]='contents[1].id' [ngStyle]="{'background-color':listid==contents[1].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section II: Private Wells, Radon and Attachments</h6>
		<div style="font-size:12px"><!--Private Wells, Radon and Attachments-->
		<h6 style="background-color:black;padding:4px; margin-top: 20px;height: 20px;"></h6>
		<div style="width:100%; display:inline; position:relative">
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
			  
			  </div>
			</div>
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px">Report date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
			  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
			  <p *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>			  
			</div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			   <label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName',0,0)"><i class="far fa-list-alt"></i></a>
			   <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			   <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName',0,0)"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			</div>
			
			<div style="width:49.5%; display:inline-block;">
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId',0,0)"><i class="far fa-list-alt"></i></a>
			 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			</div>
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate?.html" type="text" style="border:none;width:100%" />-->
			  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.VisitDate"><br>
				<p *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate"style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate" type="text" style="border:none;width:100%" />
			  </div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
		   <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">City, State, Zip</label>
			  <div>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode',0,0)"><i class="far fa-list-alt"></i></a>
			</div>
		</div>
			</div>
		</div>
		<h6  [id]='contents[1].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[1].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div>
		<div style="width: 100%">
					<div class='klistItem' style="width:86%;">
						<p>{{contents[1].SUB_SECTIONS[0].data?.label}}</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<label><input type="radio" name="frm1103-1-0" [checked]="contents[1].SUB_SECTIONS[0].data.status=='Yes'" (change)="contents[1].SUB_SECTIONS[0].data.status='Yes'">Yes</label>
						<label class="ml-3"><input type="radio" name="frm1103-1-0" [checked]="contents[1].SUB_SECTIONS[0].data.status=='No'" (change)="contents[1].SUB_SECTIONS[0].data.status='No'">No</label>
					</div>
					<div *ngIf="contents[1].SUB_SECTIONS[0].data.status=='Yes'" style="margin-left: 20px;">
					<div class='klistItem' style="width:86%;">
						<p>{{contents[1].SUB_SECTIONS[0].data.label2}}</p>
					</div>
					<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
						<input style="width: 100%;" disabled type="text">
					</div>					
					
						<p>{{contents[1].SUB_SECTIONS[0].data.label3}}</p>
						<textarea  rows="2" [(ngModel)]="contents[1].SUB_SECTIONS[0].data.info" style="width: 100%;"></textarea>								
					</div>
		</div>
		<h6  [id]='contents[1].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[1].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div style="width: 100%">
			<div class='klistItem' style="width:86%;">
				<p>{{contents[1].SUB_SECTIONS[1].data?.label}}</p>
			</div>
			<div class='klistItem' style="width:12%;margin-left: 1%;text-align: center;">
				<label><input type="radio" name="frm1103-1-1" value="Yes" [checked]="contents[1].SUB_SECTIONS[1].data.status=='Yes'" (change)="contents[1].SUB_SECTIONS[1].data.status='Yes'">Yes</label>
				<label class="ml-3"><input type="radio" name="frm1103-1-1" value="No" [checked]="contents[1].SUB_SECTIONS[1].data.status=='No'" (change)="contents[1].SUB_SECTIONS[1].data.status='No'">No</label>
			</div>
			<div *ngIf="contents[1].SUB_SECTIONS[1].data.status=='No'" style="border-left: #000 4px solid; border-bottom: #000 1px solid;">
				<label>Explain below:</label>
				<textarea  rows="2" [(ngModel)]="contents[1].SUB_SECTIONS[1].data.info" style="width: 100%;"></textarea>								
			</div>
		</div>
		<h6  [id]='contents[1].SUB_SECTIONS[2].id' [ngStyle]="{'color':listid==contents[1].SUB_SECTIONS[2].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[1].SUB_SECTIONS[2].SECTION_TITLE}}</h6>
		<div style="width: 100%">
			<ng-container *ngFor="let item of contents[1].SUB_SECTIONS[2].data.Attachments; let i=index; trackBy:trackByFuntion">
			<div style="display:flex">
				<label style="display: flex;width:40%; font-weight: bold;">{{item.label}}</label>
				<ng-container *ngIf="i<6">
					<label style="display: flex;width:20%;"><input type="checkbox" [checked]="item.status=='attached'" (change)="item.status='attached'">Attached</label>
					<label style="display: flex;width:20%;" ><input type="checkbox" [checked]="item.status=='nattached'" (change)="item.status='nattached'">Not attached</label>
					<label  style="display: flex;width:20%;" *ngIf="i==1||i==2"><input type="checkbox" [checked]="item.status=='nreq'" (change)="item.status='nreq'">Not required</label>
					<label  style="display: flex;width:20%;" *ngIf="i==4||i==5"><input type="checkbox" [checked]="item.status=='navailable'" (change)="item.status='navailable'">Not available</label>
				</ng-container>
			</div>
			<div *ngIf="item.status=='nattached'||i==6" style="border-left: #000 4px solid; border-bottom: #000 1px solid;">
				<label *ngIf="i!=6">Explain below:</label>
				<textarea  rows="2" [(ngModel)]="item.info" style="width: 100%;"></textarea>								
			</div>
		</ng-container>
		</div>
		</div>
	</div>
	<h6 [id]='contents[2].id' [ngStyle]="{'background-color':listid==contents[2].id?'rgb(195, 212, 47)':'white'}" style="text-align: right; padding:4px">Section III: Unit Inspection and Certification</h6>
		<div style="font-size:12px"><!--Private Wells, Radon and Attachments-->
		<h6 style="background-color:black;padding:4px; margin-top: 20px;height: 20px;"></h6>
		<div style="width:100%; display:inline; position:relative">
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label for="frmloanNo" style="margin-left:4px">Freddie Mac loan number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FrmLoanNo',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FrmLoanNo?.html" disabled ="text" style="border:none;width:94%"/>
			  
			  </div>
			</div>
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label style="margin-left:4px">Report date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'FinalAsmntDate',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate?.html" disabled ="text" style="border:none;width:94%"/>-->
			  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.FinalAsmntDate"><br>
				<p *ngIf="contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate"style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.FinalAsmntDate|date:"MMMM dd, yyyy"}}</p>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.FinalAsmntDate" disabled ="text" style="border:none;width:94%"/>
			</div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			   <label style="margin-left:4px">Property name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AsReportedName',0,0)"><i class="far fa-list-alt"></i></a>
			   <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AsReportedName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			   <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AsReportedName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
				<label style="margin-left:4px">Seller/Servicer name</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AccountName',0,0)"><i class="far fa-list-alt"></i></a>
				<div *ngIf="contents[0].SUB_SECTIONS[0].data?.AccountName?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AccountName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AccountName?.html" disabled ="text" style="border:none;width:100%"/>
			  </div>
			</div>
			
			<div style="width:49.5%; display:inline-block;">
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">Address</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'AddressLineText',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.AddressLineText?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.AddressLineText?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			 <label  style="margin-left:4px" for="frmloanNo">Seller/Servicer number</label><a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'PartyBusinessAccountId',0,0)"><i class="far fa-list-alt"></i></a>
			 <div *ngIf="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			 <input *ngIf="!contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId?.html" disabled ="text" style="border:none;width:100%"/>
			</div>
			</div>
			<div style="width:49.5%;display:inline-block">
			  <div style="height:4px; border:none"></div>
			  <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <label for="frmloanNo"  style="margin-left:4px">Inspection date</label><!--<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'VisitDate',0,0)"><i class="far fa-list-alt"></i></a>
			  <div *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate?.html" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.VisitDate?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
			  <input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate?.html" type="text" style="border:none;width:100%" />-->
			  <input type="date" style="width:15px; height:20px; outline:none; border:none;float: right;padding:0" [(ngModel)]="contents[0].SUB_SECTIONS[0].data.VisitDate"><br>
				<p *ngIf="contents[0].SUB_SECTIONS[0].data.VisitDate" style="padding-left: 10px;">{{contents[0].SUB_SECTIONS[0].data.VisitDate|date:"MMMM dd, yyyy"}}</p>
				<input *ngIf="!contents[0].SUB_SECTIONS[0].data.VisitDate" type="text" style="border:none;width:100%" />
			  </div>
			</div>
			</div>
			<div style="width:49.5%; display:inline-block;">
		   <div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
			  <div style="height:4px"></div>
			  <label style="margin-left:4px">City, State, Zip</label>
			  <div>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.CityName?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.CityName?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'CityName',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.StateUspsCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'StateUspsCode',0,0)"><i class="far fa-list-alt"></i></a>
				<span *ngIf="contents[0].SUB_SECTIONS[0].data?.PostalCode?.html" style="display: inline-table;" [innerHTML]="contents[0].SUB_SECTIONS[0].data?.PostalCode?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></span><a href="javascript:void(0)" style="width:5%;" title="Add Repeat Field" (click)="openPara($event, 'PostalCode',0,0)"><i class="far fa-list-alt"></i></a>
			</div>
		</div>
			</div>
		</div>
		<h6  [id]='contents[2].SUB_SECTIONS[0].id' [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[0].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[2].SUB_SECTIONS[0].SECTION_TITLE}}</h6>
		<div style="width: 100%">
			<table style="width:100%; border-collapse: collapse;text-align: center; border:none">
				<tbody>
				<ng-container *ngFor="let row of unitrow|fill; let i=index; trackBy:trackByFuntion">
				<tr style="vertical-align: bottom;">
					<td class='frmCell'>{{4*i+1}}</td>					
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:22%">
						<input type='text' (blur)="addUnitId($event, i, 0)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i]" class="frmInput2"/>
					</td>
					<td class='frmCell'>{{4*i+2}}</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:22%">
						<input type='text' (blur)="addUnitId($event, i, 1)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i+1]" class="frmInput2" />
					</td>
					<td class='frmCell'>{{4*i+3}}</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0; width:22%">
						<input type='text' (blur)="addUnitId($event, i, 2)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i+2]" class="frmInput2"/>
					</td>
					<td class='frmCell'>{{4*i+4}}</td>
					<td style="border:none; border-bottom:1px solid black; height:14px; padding:0;width:22%">
						<input type='text' (blur)="addUnitId($event, i, 3)" [(ngModel)]="contents[2].SUB_SECTIONS[0].data.units[4*i+3]" class="frmInput2"/>
					</td>
					
				</tr>
			</ng-container>			
				</tbody>
			</table>
			<div style="position:relative; height:20px">
				<button class="frmBtn" style="float:right" (click)="insertUnitRow()">Insert</button>
				<button class="frmBtn" *ngIf="unitrow>5" style="float:right"(click)="deleteUnitRow()">Delete</button>		  
			   </div>
		</div>
		<h6  [id]='contents[2].SUB_SECTIONS[1].id' [ngStyle]="{'color':listid==contents[2].SUB_SECTIONS[1].id?'rgb(195, 212, 47)':'white'}" style="background-color:black;padding:4px; margin-top: 20px;">{{contents[2].SUB_SECTIONS[1].SECTION_TITLE}}</h6>
		<div style="width: 100%">
			<div style="width:100%">
				<p>On behalf of the environmental consultant, the undersigned hereby certifies that:</p>
				<ul>
					<li>The attached environmental report was prepared by the consultant in accordance with all applicable requirements in the Freddie Mac <i>Multifamily Seller/Servicer Guide</i>.</li>
					<li>The report was prepared in a manner consistent with generally accepted industry practices and standards.</li>
					<li>All information is true and correct, to the best of the undersigned's knowledge, and reflects the consultant's best professional opinion and judgment.</li>
					<li>No changes or additions have been made to the standard provisions of this form other than those expressly approved in writing by Freddie Mac.</li>
				</ul>
			</div>
			<div style="width:100%; display:inline; position:relative">
				<div style="width:49%;display:inline-block;">
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<div style="height:4px;"></div>
						<label style="margin-left:4px">Consulting firm name</label><br>
						<a href="javascript:void(0)" style="width:5%; margin-top:4px; float:right" title="Add Repeat Field" (click)="openPara($event, 'firm', 2, 1 )"><i class="far fa-list-alt"></i></a>
						<div *ngIf="contents[2].SUB_SECTIONS[1].data?.firm?.html" [innerHTML]="contents[2].SUB_SECTIONS[1].data?.firm?.secHtml?.changingThisBreaksApplicationSecurity|safeHtml"></div>
						<input *ngIf="!contents[2].SUB_SECTIONS[1].data?.firm?.html" disabled ="text" style="border:none;width:94%"/>						
					</div>
				</div><br>
				<div style="width:49%; display:inline-block;">
					<div style="display:inline-block;;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
						<div style="height:4px;"></div>
						<label style="margin-left:4px">Signature of authorized representative</label><br>
						<input type="text" style="border:none;width:90%"/>				
					</div>
				</div>
				
				<div style="width:49%; display:inline-block;;margin-left:10px">
				<div style="display:inline-block;;margin:0;width:100%;">
					<div style="height:4px; border:none; "></div>
					<label style="margin-left:4px">Date</label><br>
					<input type="text" disabled style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
				</div>
				</div>
				<div style="width:49%; display:inline-block;">
				<div style="display:inline-block;margin:0;border-left:4px solid black;border-bottom:1px solid black;width:100%;">
					<div style="height:4px;"></div>
					<label style="margin-left:4px">Name (typed or printed)</label><br>
					<input type="text" style="border:none;width:100%"/>
					
				</div>
				</div>
				<div style="width:49%; display:inline-block;margin-left:10px">
				<div style="display:inline-block;margin:0;width:100%;">
					<div style="height:4px; border:none; "></div>
					<label style="margin-left:4px">Title</label><br>
					<input type="text"style="border:none; border-left:4px solid black;border-bottom:1px solid black;width:100%"/>
				</div>
				</div>
			</div>
		</div>
		</div>
</div>
</ng-container>
	<div style="visibility:none">
		<app-pdfdata [content]='contents' [appe]="appendices" [front]="frontpages" [rptInfo]="tempInfo" 
		  [pdfgroup]="pdfs" [slot]="slots" [rdata]="r" [toPrint]="pdfType" (spinToggle)="pdfSpin($event)" (errorInfo)="showErrMsg($event)"></app-pdfdata>
	  </div>
</div>
</div>
</div>
<div class="col-md-2 toolContainer" [style.pointer-events]="tableShow ? 'none' : 'auto'">
<!-- Nav tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#home">Tools</a>
    </li>
    <li class="nav-item">
		<a *ngIf="current" class="nav-link" data-toggle="tab" href="#menu1" (click)="getTemplateHistory()">Template Info</a>
    </li>    
  </ul>
  <!-- Tab panes -->
  <div class="tab-content">
    <div id="home" class="container tab-pane active">
	<div class="toolGroup">
		<div class="row mt-2 mb-1 p-0">
	<button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn"   style="border:1px solid #C2D63F" title="New Template" (click)=startNew()>New Template</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" title="Save Template" (click)='saveTemplate()'>Save Template</button>
		<hr class="line">
	<button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" [disabled]="(tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103')&&selectedEditor=='O'" (click)='addTable()'>Add Table Section</button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn"[disabled]="(tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103')&&selectedEditor=='O'"  (click)='addPara()'>Add Text Section</button>
		<button [disabled]='selectedEditor=="F"||((tempInfo?.PCA_INDICATOR=="frm1104"||tempInfo?.PHASE1_TYPE=="1103")&&selectedEditor=="O")' class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" (click)='addPhotos()'>Add Photo Section</button>
		<button [disabled]="selectedEditor=='F'||((tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103')&&selectedEditor!='F')" class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn"  (click)='addPdfSec()'>Add PDF Section</button>
		<!--<button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" (click)='addImage()'>Add Image</button>-->
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="(tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103')&&selectedEditor=='O'" (click)='addSeal("signature")'>Add Signature </button>
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 toolBtn" [disabled]="(tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103')&&selectedEditor=='O'" (click)='addSeal("seal")'>Add Seal</button>
		<hr class="line">
		<button class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" [disabled]="(tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103')&&selectedEditor=='O'" data-toggle="modal" data-target="#fileModal" (click)='uploadType="IMAGE"'>Upload Image</button>
		<hr *ngIf="tempInfo?.PCA_INDICATOR=='Y'||tempInfo?.PCA_INDICATOR=='4099e'||tempInfo?.PCA_INDICATOR=='frm1105'" class="line mt-2">
		<button *ngIf="tempInfo?.PCA_INDICATOR=='Y'&&pcaType&&pcaType.length>0" class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn line-clamp" [disabled]="selectedEditor=='F'" (click)="selectedCell=null; op91.toggle($event);addCost(pcaType)">Add Cost Rec</button>
		<p-overlayPanel #op91 [appendTo]="'body'">
            <ng-template pTemplate>
				<label *ngIf="!hasPca" style="color:orange">Please add Cost table first.</label>
	        </ng-template>
        </p-overlayPanel>
		<button *ngIf="(tempInfo?.PCA_INDICATOR=='4099e'&&pcaType)||(tempInfo?.PCA_INDICATOR=='frm1105'&&pcaType)" class="btn-block btn btn-black btn-small m-1 p-1 toolBtn line-clamp" [disabled]="selectedEditor=='F'" style="width:86%" (click)="selectedCell=null; addCostTable2();">Add Cost Rec</button>
		<button *ngIf="tempInfo?.PCA_INDICATOR=='Y'&&(!pcaType)" class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn line-clamp" [disabled]="selectedEditor=='F'" (click)="selectedCell=null; op90.toggle($event);checkPca()">Add Cost Rec</button>
		<p-overlayPanel #op90 [appendTo]="'body'">
            <ng-template pTemplate>
			<label *ngIf="!hasPca" style="color:orange">Please add Cost table first.</label>
				<ng-container *ngIf="hasPca">
					<button (click)="addCostTable()" class="btn mr-2 uploadBtn">Type 1</button>
					<button (click)="addCostTable2()" class="btn uploadBtn">Type 2</button>
				</ng-container>
            </ng-template>
        </p-overlayPanel>
		<button *ngIf="tempInfo?.PCA_INDICATOR=='Y'" class="col-md-5 btn-block btn btn-black btn-small m-1 p-1 toolBtn" (click)='selectedCell=null;addPCATable()'>Add Cost Table</button>
		<button *ngIf="tempInfo?.PROPOSAL_TYPE=='N'"  [disabled]='selectedEditor=="F"||(allowPhase1PS=="N"&&this.tempInfo?.PCA_INDICATOR!="Y")' class="btn-block btn btn-black btn-small m-1 toolBtn" (click)='preSetSummary()'  style="width:86%">Add Project Summary</button>
		
		<hr>
		<button  [disabled]="noPrint" class="btn-block btn btn-black btn-small m-1 toolBtn" style="width:86%" (click)="preview()">Generate PDF</button>
		<span #pdfspin class="fa fa-spinner fa-spin " style="font-size:20px;color:rgb(195,212,47); display:none"></span>
		<a *ngIf="errMsg.length>0" class="" [title]="errMsg"><i class="fas fa-info-circle" style="font-size:12px; margin:3px 5px 0 0; color:#F78181;"></i></a>
		<!--<button (click)="getbase64fromhtml()"></button>-->
	</div>
	<input #file type="file" style="display: none;" (change)="uploadImage()"  accept='.png,.PNG,.jpg,.JPG, .jpeg,.JPEG' />
	<input #file3 type="file" style="display: none;" (change)="uploadFile1()" accept=".jpg,.png,.jpeg,.xlsx,.csv,.txt,.docx,.doc, .pdf, .ppt,.pptx,.kml,.dwg">
	<input #file4 type="file" style="display: none;" (change)="uploadPdf()" accept='.pdf,.PDF'>
	<div class="row mb-2 p-0 mt-0">
	<hr class="line">
		
		<label class="savedLabel col-md-5">Cover Page</label>
		<select class="savedPage col-md-6" [(ngModel)]="selectedCover" (change)='updateTmp("cover")'>
			<option></option>
			<option *ngFor="let cover of covers; trackBy:trackByFuntion" [value]="cover.COVERPAGE_ID">{{cover.COVERPAGE_TITLE}}</option>
		</select>
	
	<label class="savedLabel col-md-5">Header</label>
		<select class="savedPage col-md-6" [(ngModel)]="selectedHeader" (change)='updateTmp("header")'>
			<option></option>
			<option *ngFor="let header of headers; trackBy:trackByFuntion" [value]="header.HEADERFOOTER_ID">{{header.HF_TITLE}}</option>
		</select>
	
	<label class="savedLabel col-md-5">Footer</label>
		<select class="savedPage col-md-6" [(ngModel)]="selectedFooter" (change)='updateTmp("footer")'>
			<option></option>
			<option *ngFor="let footer of footers; trackBy:trackByFuntion" [value]="footer.HEADERFOOTER_ID">{{footer.HF_TITLE}}</option>
		</select>
	<label class="savedLabel col-md-8">Print Table of Content: </label>
		<select class="col-md-3" style="padding:0; font-size:11px" (change)="setToc($event)">
		<option value='Y' [selected]="tempInfo?.TOC_IND=='Y'">Yes</option>
		<option value='N' [selected]="tempInfo?.TOC_IND=='N'">No</option>
		</select>	
	<label class="savedLabel col-md-10">PDF File Name<a class="ml-1 mb-1" (click)="op85.toggle($event);" title="Edit PDF File Name"><i class="fas fa-edit"></i></a>
	</label>
	<!--<span class="col-md-6" [innerHTML]="pdfFname.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></span>
	<span class="col-md-6"></span>	-->
	
	<p-overlayPanel #op85 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
			<ng-template pTemplate>
				<div style="padding:4px; max-height:400px; overflow:auto; width:300px" class="ckContainer">
					<app-paragraph [srcViewer]="'N'" [editorType]="'lite'" (click)="selectedEditor='P'" [addedSlot]="pdfFname['addedItem']"  class="docItem"  [content]="pdfFname.text"  [getText]="pdfFname['index']"  (selected)="selectedRow=-1;selectedCell=null;addLib=true; selectedEditor='P'" (outText)="pdfPara($event)" (onExit)='pdfData($event);'></app-paragraph>															
				</div>
				<button type="button" class="btn btn-outline-light btn-sm float-md-right m-1" (click)="savepdf(); op85.hide()">Save</button>
			</ng-template>
		</p-overlayPanel>
	<span class="col-md-12"  style="color:#C2D63F">{{pdfFname.name}}</span>
	<div class="pl-3"><input type="checkbox" [(ngModel)]="blackText" (change)="saveBlack()"><label class="savedLabel">Print PDF with Black Text Sections</label></div>	
	<br><label class="savedLabel1 col-md-12" >* Amazon will automatically convert spaces, punctuation marks including commas, or symbols (e.g., #, @, /, *, -) to an underscore (_).</label>
	<hr  class="line mt-2">
	<label class="savedLabel col-md-7">PhotoLog Header: </label>
	<select class="savedPage col-md-4" [(ngModel)]="selectedPHeader" (change)='updateTmp("pheader")'>
		<option></option>
		<option *ngFor="let header of headers; trackBy:trackByFuntion" [value]="header.HEADERFOOTER_ID">{{header.HF_TITLE}}</option>
	</select>
	<label class="savedLabel col-md-7">PhotoLog Footer: </label>
		<select class="savedPage col-md-4" [(ngModel)]="selectedPFooter" (change)='updateTmp("pfooter")'>
		<option></option>
		<option *ngFor="let footer of footers; trackBy:trackByFuntion" [value]="footer.HEADERFOOTER_ID">{{footer.HF_TITLE}}</option>
	</select>
	<hr  class="line mt-2">
	<label class="savedLabel col-md-7">TOC Header: </label>
	<select class="savedPage col-md-4" [(ngModel)]="selectedTHeader" (change)='updateTmp("Theader")'>
		<option></option>
		<option *ngFor="let header of headers; trackBy:trackByFuntion" [value]="header.HEADERFOOTER_ID">{{header.HF_TITLE}}</option>
	</select>
	<label class="savedLabel col-md-7">TOC Footer: </label>
		<select class="savedPage col-md-4" [(ngModel)]="selectedTFooter" (change)='updateTmp("Tfooter")'>
		<option></option>
		<option *ngFor="let footer of footers; trackBy:trackByFuntion" [value]="footer.HEADERFOOTER_ID">{{footer.HF_TITLE}}</option>
	</select>
	<div *ngIf="tempInfo?.PCA_INDICATOR=='frm1105'||tempInfo?.PCA_INDICATOR=='frm1104'||tempInfo?.PHASE1_TYPE=='1103'">
		<hr  class="line mt-2">
		<!--<label class="savedLabel col-md-7">Freddie Mac Header: </label>
		<select class="savedPage col-md-4" [(ngModel)]="selectedFrmHeader" (change)='updateTmp("Fheader")'>
			<option></option>
			<option *ngFor="let header of headers; trackBy:trackByFuntion" [value]="header.HEADERFOOTER_ID">{{header.HF_TITLE}}</option>
		</select>-->
		<label class="savedLabel col-md-7">Freddie Mac Footer: </label>
		<select class="savedPage col-md-4" [(ngModel)]="selectedFrmFooter" (change)='updateTmp("Ffooter")'>
			<option></option>
			<option *ngFor="let footer of footers; trackBy:trackByFuntion" [value]="footer.HEADERFOOTER_ID">{{footer.HF_TITLE}}</option>
		</select>
	</div>
	<hr  class="line mt-2">
	<label class="savedLabel col-md-7">Company Profile: </label>
	<select class="savedPage col-md-4" (change)='updateTmp("Profile", $event)'>
		<option *ngFor="let profile of profiles; trackBy:trackByFuntion" [value]="profile.COMP_PROFILE_ID" [selected]="selectedProfile==profile.COMP_PROFILE_ID">{{profile.REPORT_STYLE_NAME}}</option>
	</select>
	<div class="pl-3"><input type="checkbox" [(ngModel)]="contentIndent" (change)="saveIndent()"><label class="savedLabel">Text to follow the header indent</label></div>	
	<hr  class="line mt-2">
	<label class="savedLabel col-md-7">Signature Profile: </label>
	<select *ngIf="defaultSign" class="savedPage col-md-4" (change)='updateTmp("Signature", $event)' [disabled]='!allowProfileChange' (click)="checkProfile()">
		<option *ngFor="let item of signStyles; trackBy:trackByFuntion" [value]="item.SIGNATURE_STYLE_ID" [selected]="defaultSign.SIGNATURE_STYLE_ID==item.SIGNATURE_STYLE_ID">{{item.SIGNATURE_STYLE_NAME}}</option>
	</select>
	<!--<label class="savedLabel col-md-7">FME Profile: </label>
		<select class="savedPage col-md-4">
			<option >Default Profile</option>
			<option >Company Profile</option>
		</select>-->
	</div>
	<div class="row mb-3 p-0 mt-0">
		<hr class="line mt-0">
		<app-reportinfo [user]="tempInfo" (info)="onInfo($event)" (getLogo)="onSavedLogo($event)">
		</app-reportinfo>
	</div>
	</div>
      </div>
    <div id="menu1" class="container tab-pane fade"><br>
		<div *ngIf='tempInfo?.TEMPLATE_TYPE' style="color:white; text-align:left; padding:6px;">
			<span style="display: inline-block; font-size:11px"><strong
					style="color:#c2d63e">Template Name: </strong>
				{{tempInfo?.TEMPLATE_TITLE}}</span>
			<br>
	
			<span style="display: inline-block; font-size:11px"><strong
					style="color:#c2d63e">Template Category: </strong>
				{{tempInfo?.TEMPLATE_TYPE[0].CATEGORY_NAME}}</span>
			<span style="display: inline-block; font-size:11px"><strong
					style="color:#c2d63e">Template Identifier: </strong>
				{{tempInfo?.TEMPLATE_TYPE[0].SUBCATEGORY_NAME}}</span>
				<br>
				<hr class="m-2" style="background:white; z-index:9999999;">
				<strong
					style="color:#c2d63e ; width:100%; font-size:11px;  text-align:center;">Editing History  </strong> 
				<div style="height:76vh; overflow:auto"> 
				<table  style="padding:1px; font-size:11px" style="width:90%; border: 1px solid black;  border-collapse: collapse; max-height:50vh">
					<thead>
					  <tr style="color:rgb(195,212,47); font-size:12px">
	
					  <th style="padding:1px; font-size:11px">Edited By</th>
					  <th style="padding:1px; font-size:11px">Edit Date</th>
					 <!-- <th style="padding:1px; font-size:11px">Version No#</th>-->
					  </tr>
					</thead>
					<tbody>
					  <ng-container *ngFor="let history of tempInfo.RW_TEMPLATE_HISTORY; let i=index; trackBy:trackByFuntion">
						<tr style="color:white; font-size:12px">
						<td style="padding:1px; font-size:11px">{{history.UPDATED_BY}}</td>
						<td style="padding:1px; font-size:11px">{{history.DATE_UPDATED}}</td>
						<!--<td style="padding:1px; font-size:11px">{{history.TEMPLATE_VERSION_NO}}</td>-->
						</tr>
					  </ng-container>
					</tbody>
					</table>
					</div>
							
		</div>
    </div>    
  </div>
	
</div>
</div>
</div>
 <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]" (didClosed)="showLogo = null">
    <ng-container name="body">
      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo' (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel>
</div>
 	<div id="marginModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-md modal-dialog-centered " style="max-width: 40%;">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Set Margin Size</h6>
		  <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<div class="row" style="font-size: 14px; width:100%; ">
				<div class="col-md-6" style="text-align: right;">
					<label class="col-md-8">Margin Top</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.top"/>px<br>
					<label class="col-md-8">Margin Bottom</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.bottom"/>px<br>	
					<label class="col-md-8">Margin Left</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.left"/>px<br>
					<label class="col-md-8">Margin Right</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="pageMargin.right"/>px<br>		
					
				</div>
				<div class="col-md-6"  style="text-align: right;">
					<label class="col-md-8">TOC Margin Top</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.top"/>px<br>
					<label class="col-md-8">TOC Margin Bottom</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.bottom"/>px<br>	
					<label class="col-md-8">TOC Margin Left</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.left"/>px<br>
					<label class="col-md-8">TOC Margin Right</label><input  class="col-md-3 p-0" min="0" max="1000" type='number' [(ngModel)]="tocMargin.right"/>px<br>		
					<button class="btn m-0 p-2 btn-op float-right" (click)="saveMargin()">Save</button>
				</div>
			</div>
		</div>

	</div>
	</div>
	</div>

	<div id="tempModal" class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered ">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Create New Template</h6>
		  <!--<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>-->
			<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<label class="col-md-4  ml-2">Template Name: <span [ngStyle]="{'color':tempName.trim()=== '' ? 'red' : 'white' }">*</span></label><input class="col-md-7 ml-4" type="text" [(ngModel)]="tempName"/>
			<br>
	
			<label class="col-md-4  ml-2">Template Type : <span [ngStyle]="{'color':selectedType.length==0 ? 'red' : 'white' }">*</span></label>
			<select class="col-md-7  ml-4" (change)="selCate($event)" [(ngModel)]="selectedType">
				<option></option>
				<ng-container *ngFor="let cat of categories; trackBy:trackByFuntion">
					<option [value]=cat.CATEGORY>{{cat.CATEGORY}}</option>				
				</ng-container>
			</select><br>
			<label class="col-md-4  ml-2">Template Identifier : <span [ngStyle]="{'color':selectedIden.length==0 ? 'red' : 'white' }">*</span></label>
			<select class="col-md-7  ml-4" (change)="selTemp($event)"  [(ngModel)]="selectedIden">
				<option></option>
				<ng-container *ngFor="let temp of temps; trackBy:trackByFuntion">
					<option [value]="temp.TEMPLATE_TYPE_ID">{{temp.SUB_CATEGORY}}</option>				
				</ng-container>
			</select>
			<ng-container *ngIf="companyGroupIndicator">
				<label class="col-md-4  ml-2" style="vertical-align: top;">Group : <span [ngStyle]="{'color':groupList.length==0 ? 'red' : 'white' }">*</span></label>
				<!--<select class="col-md-7  ml-4" (change)="selGroup($event)"  [(ngModel)]="groupList" (click)="getUserGroups()">
					<option></option>
					<ng-container *ngFor="let group of groups; trackBy:trackByFuntion">
						<option [value]="group.GROUP_ID">{{group.GROUP_NAME}}</option>				
					</ng-container>
				</select>-->
				<!--<ng-select
					[items]="groups"
					[multiple]="true"
					bindLabel="GROUP_NAME"
					class="col-md-7 ml-4 groupInfo"
					style="display: inline-block" 
					[closeOnSelect]="false"
					bindValue="GROUP_ID"
					[(ngModel)]="groupList"
					[ngModelOptions]="{standalone: true}">
					<ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
						<input [id]="item.GROUP_ID" type="checkbox" [ngModel]="item$.selected" /> {{ item.GROUP_NAME }}
					</ng-template>
				</ng-select>-->
				
				<div class="col-md-7 ml-4" style="max-height:300px; border: #C2D63F 1px solid;overflow: auto;display: inline-block;">
						<ng-container *ngFor="let group of groups">
							<label class="savedLabel"><input type="checkbox" class="ml-1" [disabled]="groupAll" [checked]="groupList.indexOf(group.GROUP_ID)>-1" (change)="setGroupList($event, group.GROUP_ID)"> {{group.GROUP_NAME}}</label><br>
						</ng-container>
					</div>		
				<div class="col-md-4  ml-2" style="display: inline-block;"></div>
				<label class="col-md-3 ml-4 savedLabel p-0"><input type="checkbox" [(ngModel)]="groupAll" (change)="setGroupList($event, 'all')">Select All</label>
				<label class="col-md-3 savedLabel p-0 ml-3"><input type="checkbox" [(ngModel)]="groupNone" (change)="setGroupList($event, 'none')">Unselect  All</label><br>
				
							
								
			</ng-container>
			<span *ngIf="!companyGroupIndicator&&(tempName.trim().length==0||selectedType.length==0||selectedIden.length==0)" style="color:orange; font-size:11px">Template Name, Type and Identifier are mandatory.</span>
			<span *ngIf="companyGroupIndicator&&(tempName.trim().length==0||selectedType.length==0||selectedIden.length==0||groupList.length==0)" style="color:orange; font-size:11px">Template Name, Type, Identifier and Group are mandatory.</span>
			<button type="button" class="btn uploadBtn pl-2 pr-2 pt-1 pb-1 float-right" (click)='newTemplate()'>Create New Template</button>
			<span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>			
			
			
        </div>

	</div>
	</div>
	</div>
	
	<div id="addSlotModal" #addSlotModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered "  style="max-width:40%">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Add Repeat Field</h6>
		  <!--<a href='javascript:void(0)' class="btn btn-outline-success btn-sm  pr-1 pl-1 pt-0 pb-0 ml-3" title="Insert Image" (click)='insertImage()'><i class="fas fa-check"></i></a>-->
			<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>
        
        <!-- Modal body -->
        <div class="modal-body">
		<div class="row p-2">
			<div style="height:400px; overflow:auto;width:55%; padding-left:10px">
			<p-table #dt1 [value]="slots" [paginator]="false" [globalFilterFields]="['KEY','CONTENT']"  (onFilter)="onFilter($event, dt1)">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th>
							<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="20" placeholder="Filter" (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width:auto">
			
						</th>
					</tr>		
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.KEY">
						<td>
							<div class="card"  [ngClass]="{'active':curSlotId?.indexOf(rowData.SLOT_ID)>-1}" (click)="selSlot(rowData)"> 						
									<div class="row">
										<p style="width:85%; margin-left:16px;color:rgb(195,212,47);">{{rowData.KEY}}<span style="color:#04B486; margin:0 2px">({{rowData.TYPE}})</span></p>
										<a *ngIf="rowData.CONTENT.length>0" href="javascript:void(0)" class="float-md-right" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op131.toggle($event);"><i class="fas fa-eye"></i></a>					
									</div>
									<span style="color:white">{{rowData.SHORT_CONTENT}}</span>
									<p-overlayPanel #op131 [appendTo]="addSlotModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}">
                                                <ng-template pTemplate>
                                                    <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
													<strong>{{rowData.KEY}}</strong><br>
													<strong>Category : </strong> 
													<span style="color:white">{{rowData.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{rowData.TYPE}}</span><br>
														<strong  *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')">Content :</strong>
														<span  *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')">{{rowData.CONTENT}}</span>
														<div *ngIf="rowData.TYPE=='Selection'">
															<strong>Options</strong><br>
															<ng-container *ngFor="let item of tableContent; trackBy:trackByFuntion">
																<span>. {{item}}</span><br>
															</ng-container>
														</div>	
														<div *ngIf="rowData.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index; trackBy:trackByFuntion">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>		
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>	
		</div>
		<div class="d-flex flex-column justify-content-center p-2" style="width:9%">
					<button type="button" class="btn btn-outline-light btn-sm" title="Add" (click)="addSelSlot()">></button>
					<div style="height:30px"></div>
					<button type="button" [disabled]="(slots?.length>10&&!filteredData)||(filteredData&&filteredData.length>10)" class="btn btn-outline-light btn-sm" title="Add All when total=<10" (click)="addAllSelSlot()">>></button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm" title="Remove" (click)="rmvAddedSlot()"><</button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm" title="Clear All" (click)="clearAddedSlot()"><<</button>
					<div style="height:30px"></div>
					<button *ngIf="!slotToLib" type="button" class="btn btn-outline-success btn-sm" title="Add to Repeat Field" (click)='addSlot()'><i class="fas fa-plus"></i></button>
					<button *ngIf="slotToLib" type="button" class="btn btn-outline-success btn-sm" title="Add to Repeat Field" (click)='addSlotToLib()'><i class="fas fa-plus"></i></button>
					<div style="height:30px"></div>
					<span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
				
				</div>
		<div class="rounded" style="height:400px; overflow:auto;width:35%; border:solid 1px rgb(195,212,47)">
			<ng-container *ngFor="let slot of selectedSlot; trackBy:trackByFuntion">
				<div class="card row m-1" style="width:95%" [ngClass]="{'active':curSlotId?.indexOf(slot.SLOT_ID)>-1}" (click)="selSlot(slot)"> 						
					<span style="color:rgb(195,212,47); margin-bottom:0">{{slot.KEY}}</span><br>
					<p style="word-break: break-all">{{slot.CONTENT}}	<p>
							
				</div>
			</ng-container>
		</div>
		</div>
				
		</div>

	</div>
	</div>
	</div>
	
	<div id="libraryModal" #libraryModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:40%">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">Library</h6>
		 	<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>        
        <!-- Modal body -->
        <div class="modal-body">				
			<div class="row p-1">
			<div style="height:400px; overflow:auto;width:55%; padding-left:10px">
			<p-table #dt3 [value]="libraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']" (onFilter)="onFilter($event, dt3)">
				<!--<ng-template pTemplate="caption">
					<div style="text-align: right">        
						<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
						<input type="text" pInputText size="20" placeholder="Filter" (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width:auto">
			
					</div>
				</ng-template>-->
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th>
							<span *ngIf="loading" class="fa fa-spinner fa-spin" style="font-size:16px;color:rgb(195,212,47)"></span>
							<input type="text" pInputText size="10" placeholder="Filter" (change)="filterLibs($event)" style="width:auto">
							<i class="pi pi-search" style="margin:4px 4px 0 0" (click)='filterLibs($event)'></i>	
							
							<!--<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
							<input type="text" pInputText size="10" placeholder="Filter" (input)="dt3.filterGlobal($event.target.value, 'contains')" style="width:auto">
							<p-dropdown [options]="libLabels"  placeholder="Filter by Identifier" [style]="{'width':'40%','minWidth':'30px', 'margin-left':'6px'}" (onChange)="dt3.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>-->
							<select style=" margin-left:2px; margin-bottom:2px;margin-top:4px; width:90px;min-width:50px;  padding:0;font-size:14px; background-color:rgb(28, 36, 51); color:#ccc" (change)="filterLibs($event)">
								<option value="">Identifier
								</option>
								<ng-container *ngFor="let label of libLabels">
									<option [value]="label.value">{{label.value}}
									</option>
								</ng-container>
							</select>
						</th>
				
					</tr>		
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr>
						<td>
							<div class="card"  [ngClass]="{'active':curLibId.indexOf(rowData.LIBRARY_ID)>-1}" (click)="selLib(rowData)"> 						
								<div class="row"><p style="width:75%; margin-left:16px; color:#C2D63F">{{rowData.ITEM_TITLE}}</p>
									<a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op4.toggle($event);"><i class="pi pi-eye"></i></a>					
								</div>
								<span>{{rowData.IDENTIFIERS}}</span>
								<p-overlayPanel #op4 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '440px'}"  (onShow)="getSftContent(rowData)">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:11px"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<ng-container *ngFor="let label of rowData.LABELS.split(';'); trackBy:trackByFuntion">
												<label class="tag">{{label}}</label>
											</ng-container>
											<div>
												<strong>Instruction : </strong><span style="color:white">{{rowData.INSTRUCTIONS}}</span>
											</div>										
											<div>
												<strong>Content : </strong>
												<span *ngIf="!rowData.CONTENT_HTML||rowData.CONTENT_HTML.length==0" style="color:white">{{rowData.CONTENT}}</span>
												<div *ngIf="rowData.CONTENT_HTML&&rowData.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="rowData.htmltext?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
											</div>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>	
		</div>
		<div class="d-flex flex-column justify-content-center p-3" style="width:9%">
					<button type="button" class="btn btn-outline-light btn-sm" title="Add Selected Library to Repeat Field" (click)="addSelLib()">></button>
					<div style="height:30px"></div>
					<button type="button" [disabled]="(libraries.length>10&&!filteredData)||(filteredData&&filteredData.length>10)" class="btn btn-outline-light btn-sm" title="Add More than one Library to Repeat Field ( Max 10)" (click)="addAllSelLib()">>></button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm" title="Remove Selected Library from Repeat Field" (click)="rmvAddedLib()"><</button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm" title="Remove All Library from repeat Field" (click)="clearAddedLib()"><<</button>
					<div style="height:30px"></div>
					<!--<button type="button" class="btn btn-outline-light btn-sm" title="Clear and Exit" (click)='cancleLib()'><i class="fas fa-sign-out-alt"></i></button>
					<div style="height:30px"></div>-->
					<button *ngIf="libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add Library to Repeat Field" (click)='addLibToSlot()'><i class="fas fa-plus"></i></button>
					<button *ngIf="!libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add Library to Page" (click)='addLibToDoc()'><i class="fas fa-plus"></i></button>
					<div style="height:30px"></div>
					<span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
				
				</div>
		<div class="rounded" style="height:400px; overflow:auto;width:35%; border:solid 1px rgb(195,212,47)">
			<ng-container *ngFor="let lib of addedLib; trackBy:trackByFuntion">
				<div class="card row m-1" style="width:94%" [ngClass]="{'active':curLibId.indexOf(lib.LIBRARY_ID)>-1}" (click)="selLib(lib)"> 						
								Title : {{lib.ITEM_TITLE}}<br>
								<div class="row">
									<ng-container *ngFor="let label of lib.LABELS.split(';'); trackBy:trackByFuntion">
										<label class="tag">{{label}}</label>
									</ng-container>
								</div>
								<p style="word-break: break-all">{{lib.CONTENT}}</p>
				</div>
			</ng-container>
		</div>
		</div>

	</div>
	</div>
	</div>	
</div>
<div id="costLibModal" #costLibModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:45%">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
          <h6 id="" class="modal-title">PCA Cost Library</h6>
		 	<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>        
        <!-- Modal body -->
        <div class="modal-body">				
			<div class="row p-1">
			<div style="height:400px; overflow:auto;width:45%; padding-left:10px">
			<p-table #dt5 [value]="pcaLibraries" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','IDENTIFIERS', 'UNIT', 'EUL', 'COST']">
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th style="padding:2px; padding:0">
							<!--<p-dropdown [options]="pcaIdentifiers"  [(ngModel)]="filterText" placeholder="Identifier" [style]="{'width':'40%','minWidth':'30px', 'margin-left':'0','font-size':'11px'}"  [panelStyle]="{'font-size':'10px'}" (onChange)="dt5.filterGlobal($event.value,'contains')"  [showClear]="true"></p-dropdown>
							--><select style="margin-right:4px; margin-bottom:2px;margin-top:4px; width:90px;min-width:50px;  padding:0;font-size:14px; background-color:rgb(28, 36, 51); color:#ccc" (change)="dt5.filterGlobal($event.target.value, 'contains')">
								<option value="">Identifier
								</option>
								<ng-container *ngFor="let label of pcaIdentifiers">
									<option [value]="label">{{label}}
									</option>
								</ng-container>
							</select>
							<span *ngIf="pcaLibraries.length==0" class="fa fa-spinner fa-spin" style="font-size:20px;"></span>
							<input type="text" pInputText size="12" [(ngModel)]="filterText" placeholder="Filter" (input)="dt5.filterGlobal($event.target.value, 'contains')" style="width:auto; margin-left:4px">
							
							<!--<button pButton label="Clear Filters"  class="p-button-outlined" icon="pi pi-filter-slash" (click)="dt5.reset()"></button>-->
						</th>
				
					</tr>		
				</ng-template>
				<ng-template pTemplate="body" let-rowData>
					<tr *ngIf="rowData.STATUS=='Active'">
						<td>
							<div class="card"  [ngClass]="{'active':curCostId.indexOf(rowData.COST_LIBRARY_ID)>-1}" (click)="selCost(rowData)"> 						
								<div class="row"><p style="width:75%; margin-left:16px; color:#C2D63F">{{rowData.ITEM_TITLE}}
									<span *ngIf="rowData.STATUS!='Active'" class="inaciveMsg">( {{rowData.STATUS}} )</span>
								</p>									
									<a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op4.toggle($event);"><i class="pi pi-eye"></i></a>					
								</div>
								<span>Cost: {{rowData.COST}}</span>
								<p-overlayPanel #op4 [appendTo]="costLibModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '340px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>{{rowData.ITEM_TITLE}}</h6>
											<ng-container *ngFor="let label of rowData.IDENTIFIERS.split(';'); trackBy:trackByFuntion">
												<label class="tag">{{label}}</label>
											</ng-container>
											<div>
												<strong>Cost: </strong> <span style="color:white">{{rowData.COST}}</span><br>
												<strong>EUL: </strong> <span style="color:white">{{rowData.EUL}}</span><br>
												<strong>Unit: </strong> <span style="color:white">{{rowData.UNIT}}</span><br>
											</div>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
							</div>			
						</td>
					</tr>            
				</ng-template>
	
			</p-table>	
		</div>
		<div class="d-flex flex-column justify-content-center" style="width:9%">
					<button type="button" class="btn btn-outline-light btn-sm m-2" title="Add Cost Library" (click)="addSelCost()">></button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm m-2" title="Remove Cost Library" (click)="rmvAddedCost()"><</button>
					<div style="height:30px"></div>
					<button type="button" class="btn btn-outline-light btn-sm m-2 p-1" title="Remove All Cost Libraries" (click)="clearAddedCost()"><<</button>
					<div style="height:30px"></div>
					<!--<button type="button" class="btn btn-outline-light btn-sm" title="Clear and Exit" (click)='cancleLib()'><i class="fas fa-sign-out-alt"></i></button>
					<div style="height:30px"></div>-->
					<button type="button" class="btn btn-outline-success btn-sm m-2" title="Add Cost Library to Recommendation" (click)='addLibToCost();filterText=""'><i class="far fa-save"></i></button>
					<div style="height:30px"></div>
					<span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
				
				</div>
		<div class="rounded" style="height:400px; overflow:auto;width:45%; border:solid 1px rgb(195,212,47); background-color:#222" (mouseenter)="dragStop()" (mouseleave)='dragRevise()'>
			<div *ngIf="addedCost"  cdkDropList [cdkDropListData]="addedCost" (cdkDropListDropped)="dropLib($event,addedCost)">
				<div *ngFor="let lib of addedCost; trackBy:trackByFuntion" 
					cdkDrag [cdkDragData]="lib">
					<div class="card row" style="width:90%; margin:30px 10px" [ngClass]="{'active':curCostId.indexOf(lib.COST_LIBRARY_ID)>-1}" (click)="selCost(lib)"> 						
								<p style="color:#C2D63F;">Title : {{lib.ITEM_TITLE}}<p>
								<div class="row pl-1">
									<ng-container *ngFor="let label of lib.IDENTIFIERS.split(';'); trackBy:trackByFuntion">
										<label class="tag" style="color:#ccc">{{label}}</label>
									</ng-container>
								</div>
								<p *ngIf="lib.COST&&lib.COST.length>0" style="word-break: break-all">Cost : {{lib.COST}}</p>
				</div>
			</div></div>
		</div>
		</div>

	</div>
	</div>
	</div>	
</div>

	<div id="tableModal" #tableModal class="modal fade" data-backdrop='false'>
	<div class="modal-dialog modal-lg modal-dialog-centered " style="min-width:30%">
	<div class="modal-content" style="background:#444; color:#ccc">
		<!-- Modal Header -->
        <div class="modal-header">
			<h6 *ngIf='curTableData?.rows.length==0' class="modal-title" style="color:rgb(195,212,47)">Create New Table</h6>
			<h6 *ngIf='curTableData?.rows.length>0' class="modal-title" style="color:rgb(195,212,47)">Table Property</h6>
			
			<div class="form-check-inline ml-4">
				<label class="form-check-label">
					<input type="checkbox" [checked]="isEven" (change)="isEven=!isEven" class="form-check-input" value="">Even Cell Size
				</label>
			</div>			
			<button type="button" class="close" data-dismiss="modal">&times;</button>
		</div>
        
        <!-- Modal body -->
        <div class="modal-body">
			<div class="row m-0 p-0">
			<label class="ml-4">
			 <input type="radio" [disabled]="curTableData?.rows.length>0"  name="tableSrc" class="m-0" [checked]="slotTableType==0||!(curTableData?.src&&curTableData?.src==0)" (change)="setTableSrc(0)"> 
				New Customized Table
			</label>
			<div *ngIf="slotTableType==0||(curTableData?.src&&curTableData?.src==0)" class="col-md-6">
					<label>Columns:</label>
					<input [disabled]='curTableData?.rows.length>0' min="0" max="1000000000" type="number" style="margin-left:4px; padding:2px; font-size:.8em" [(ngModel)]="colNo" min="0" max="10" (input)='setCol()'/>
					<label class="ml-2">Rows: </label>
					<input type="number" min="0" max="1000000000" [disabled]="curTableData?.rows.length>0"  style="margin-left:4px;  padding:2px; font-size:.8em" [(ngModel)]="rowNo" min="0" max="10"/>				
					<a class="btn btn-outline-light btn-sm float-md-right" (click)="addCol()">Add Column</a>
				</div>
			<!--<label class="ml-4">
			<input type="radio" [disabled]="curTableData?.rows.length>0"  name="tableSrc" class="m-0" [checked]="slotTableType==2||curTableData?.slotName" (change)="setTableSrc(2)"> 
				Customized Table From Repeat Fields
			</label><br>-->
			</div>
			<div class="row m-0 p-0">
			<label class="radio-inline ml-4"> 
				<input type="radio" [disabled]="curTableData?.rows.length>0||selectedEditor=='F'"  name="tableSrc" [checked]="slotTableType==1||curTableData?.erisName" (change)="setTableSrc(1)">
				ERIS Data
			</label>
			<!--<div  *ngIf="slotTableType==2" class="col-md-7">
				<select (change)="getSlotTable($event)" class="col-md-9" (click)="getTables('rf')">
				<option value='-1'>Select Repeat Field Table</option>
				<option *ngFor="let s of tableSlots; let i=index; trackBy:trackByFuntion" [value]="i" [selected]='curTableData.erisName==s.KEY'>{{s.KEY}}</option>
				</select>
				<label class="ml-2">Rows: </label>
				<input type="number" min="0" max="1000000000" [disabled]="curTableData?.rows.length>0"  style="margin-left:4px;  padding:2px; font-size:.8em" [(ngModel)]="rowNo" min="0" max="10"/>				
					
			</div>-->
			<div  *ngIf="slotTableType==1" class="col-md-6">
				<select [disabled]="curTableData?.rows.length>0||selectedEditor=='F'" (change)="getErisTable($event)" class="col-md-11" (click)="getTables('eris')">
				<option value='-1'>Select ERIS Table</option>
				<option *ngFor="let s of erisSlots; let i=index; trackBy:trackByFuntion" [value]="i" [selected]='curTableData.erisName==s.KEY'>{{s.KEY}}</option>
				</select>
			</div>
				
			</div>
			<div (mouseleave)='dragEnd($event)' (mouseenter)="dragStart($event)">
			<div *ngIf="curTableData?.cols.length>0||curTableData?.SLOT_ID">
			<div *ngIf="colNo>0" #dropList  cdkDropList [cdkDropListData]="curTableData.cols" (cdkDropListDropped)="dropCol($event)">
					<div class="dragItem" style="width:100%;text-align:left">
						<div style="flex-basis:5%;">No.</div>
						<div style="flex-basis:30%;">Name*</div>
						<!--<div style="width:80px;">Type</div>-->
						<div style="flex-basis:10%;">Column Width</div>
						<div style="flex-basis:5%;padding-left: 4px;">Unit</div>
						<div style="flex-basis:6%;">
							<ng-container *ngIf="!curTableData.cols[0].hide&&curTableData.cols[0].text">
								Lock<i class="fas fa-info-circle ml-1" title="Lock content, background from editing"></i>
							</ng-container>							
						</div>
						<div style="flex-basis:9%;">
							<ng-container *ngIf="!curTableData.cols[0].hide&&curTableData.cols[0].text">
								V-Header<i class="fas fa-info-circle ml-1" title="Set Vertical Header style in PDF"></i>
							</ng-container>							
						</div>
						<div style="flex-basis:10%;">Header Alignment</div>
						<div style="flex-basis:10%;">Cell Alignment</div>
						<div style="flex-basis:5%;"></div>
					</div>
					<ng-container *ngFor="let item of curTableData.cols; let i=index; trackBy:trackByFuntion">
						<div *ngIf="!item.hide&&(!item.text)" cdkDrag class="drag-box">
							<div style="flex-basis:5%; padding:4px">
							<span>{{i}}</span>
							</div>
							<div style="flex-basis:26%">
							<app-editable [text]="item.NAME" (edited)="changeLabel($event, i)" (focused)="addLib=false" [defaultText]='"Header"'></app-editable>
							</div>
							<div style="flex-basis:5%">
								<a class="btnRound1 float-right" [ngStyle]="{'color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999','border-color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" (click)="toDefaultEdit(item)">FO</a>
								<!--<a class="btnRound1 float-right" [ngStyle]="{'color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.length>0)?'#c2d63e':'#999','border-color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.length>0)?'#c2d63e':'#999'}" title="Field Options" (click)="op0.toggle($event)">FO</a>
								<p-overlayPanel #op0 [appendTo]="tableModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px 0; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>Define Field Options:</h6>
												<label class="col-md-4 savedLabel1">Field Option</label>
												<input type="text" class="col-md-7" placeholder="Input your Field Options here"/>
												<i class="fas fa-plus iconBtn" title="Add Item to Field Options" (click)="addFOItem($event, item)"></i>
												<div *ngIf='item.FO&&item.FO.length>0' class="col-md-11 mt-2">
													<ng-container *ngFor="let label of item.FO; let i=index; trackBy:trackByFuntion">
														<label class="col-md-9" *ngIf="label.trim().length>0">{{label}}</label>
														<i class="fas fa-times iconBtn mr-3" title='Remove Item' (click)='removeFOItem(item, i)'></i>
														<i class="fas fa-plus iconBtn " title='Add to default value' (click)='toDefault(label)'></i><br>
													</ng-container>
												</div>
												<label  class="col-md-4 savedLabel1">Default Value:</label>
												<input type="text" id='defaultFO' class="col-md-7" placeholder="Default Value"/>
												<i class="fas fa-check iconBtn" title="Save Default Value" (click)="addFODefaultItem(item)"></i>
												<label *ngIf='item.DefaultFO' class="col-md-12" >{{item.DefaultFO}}</label>
																						
											
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>-->
							</div>
							<div style="flex-basis:8%">
							<input [disabled]='isEven' type="number" min="0" max="1000000000" [(ngModel)]="curTableData.cols[i].width" min="0" max="50"/>
							</div>
							<div style="flex-basis:23%">
							<select [disabled]='isEven' [(ngModel)]="curTableData.cols[i].unit">				
								<option>%</option>
								<option>px</option>								
							</select>
							</div>
							<!--<select style="width:100px" [(ngModel)]="curTableData.cols[i].dir">				
								<option>Default</option>
								<option>Vertical</option>								
							</select>-->
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].colAlign">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>								
							</select>
							</div>
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].celAllign">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>							
							</select>
							</div>
							<div style="flex-basis:5%">
							<a class="btn btn-small btn-link" (click)="deleteCol(i)">
								<i class="fas fa-trash"></i>
							</a>
							</div>							
						</div>
						<div *ngIf="!item.hide&&item.text" class="drag-box" style="cursor:default">
							<div style="flex-basis:5%; padding:4px">
							<span>{{i}}</span>
							</div>
							<div style="flex-basis:25%">
							<span>{{item.text}}</span>
							</div>
							<div style="flex-basis:5%">
								<a class="btnRound1 float-right" [ngStyle]="{'color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999','border-color':(item.FO&&item.FO.length>0)||(item.DefaultFO&&item.DefaultFO.html)?'#c2d63e':'#999'}" title="Field Options" (click)="toDefaultEdit(item)">FO</a>
								<!--<p-overlayPanel #op0 [appendTo]="tableModal" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1100" [style]="{'width': '340px'}">
                                    <ng-template pTemplate>
                                        <div style="margin: 10px; color:#C2D63F;max-height:300px; overflow:auto; font-size:11px"> 
											<h6>Define Field Options</h6>
												<label class="col-md-4 savedLabel1">Field Option</label>
												<input type="text" class="col-md-7" placeholder="Input your Field Options here"/>
												<i class="fas fa-plus iconBtn" title="Add Item to Field Options" (click)="addFOItem($event, item)"></i>
												<div *ngIf='item.FO&&item.FO.length>0' class="col-md-11 mt-2">
													<ng-container *ngFor="let label of item.FO; let i=index; trackBy:trackByFuntion">
														<label class="col-md-9" *ngIf="label.trim().length>0">{{label}}</label>
														<i class="fas fa-times iconBtn mr-3" title='Remove Item' (click)='removeFOItem(item, i)'></i><br>
													</ng-container>
												</div>
												<label  class="savedLabel1">Default Value:</label><i class="far fa-edit iconBtn ml-1" (click)="toDefaultEdit(item)"></i><br>
												<div *ngIf='item.DefaultFO&&item.DefaultFO.html' style="background-color: #eeeeee;color:black; margin: 0;" [innerHTML]="item.DefaultFO.secHtml?.changingThisBreaksApplicationSecurity|highlighter:searchText:caseOn:allMatchtext:'full'|safeHtml"></div>
						
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>-->
							</div>
							<div style="flex-basis:8%">
							<input [disabled]="isEven||curTableData.cols[i]['lock']" type="number" min="0" max="1000000000" [(ngModel)]="curTableData.cols[i].width" min="0" max="50"/>
							</div>
							<div style="flex-basis:5%">
							<select [disabled]="isEven||curTableData.cols[i]['lock']" [(ngModel)]="curTableData.cols[i].unit">				
								<option>%</option>
								<option>px</option>								
							</select>
							</div>
							<div style="flex-basis:6%; vertical-align: middle;padding-left: 10px;">
								<input type="checkbox" [checked]="curTableData.cols[i]['lock']" (change)="curTableData.cols[i]['lock']=!curTableData.cols[i]['lock']">
							</div>
							<div style="flex-basis:9%; vertical-align: middle;padding-left: 10px;">
								<!--<input type="checkbox" [(ngModel)]="ifVH" (change)="secVH($event)">-->
								<input type="checkbox" [checked]="curTableData.cols[i]['VH']" (change)="curTableData.cols[i]['VH']=!curTableData.cols[i]['VH']">

							</div>
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].colAlign" [disabled]="curTableData.cols[i]['lock']">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>								
							</select>
							</div>
							<div style="flex-basis:10%">
							<select [(ngModel)]="curTableData.cols[i].celAllign" [disabled]="curTableData.cols[i]['lock']">				
								<option>Left</option>
								<option>Center</option>
								<option>Right</option>							
							</select>
							</div>
							<div style="flex-basis:5%">
							<a class="btn btn-small btn-link" (click)="deleteCol(i)" [ngClass]="{'disabled':curTableData.cols[i]['lock']||(curTableData['locked']&&curTableData['locked']['header'])}">
								<i class="fas fa-trash"></i>
							</a>
							</div>							
						</div>						
					</ng-container>
				</div>				
			</div>
			</div>
				<button *ngIf="curTableData?.rows.length==0" type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createTable($event)">Create Table</button>
				<button *ngIf="curTableData?.rows.length>0"type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="createTable($event)">Save</button>
			
		</div>

	</div>
	</div>
	</div>
	<!--<div id="costDetailModal" #costDetailModal class="modal fade" data-backdrop='false'>
		<div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:40%">
			<div class="modal-content" style="background:#444; color:#ccc">
				
				<div class="modal-header">
					<h6 *ngIf="!rowItem['edit']" class="modal-title">Add Cost Recommendation</h6>
					<h6 *ngIf="rowItem['edit']" class="modal-title">Edit Cost Recommendation</h6>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>        
				
				<div class="modal-body" style="font-size:12px;">				
					<div class="row costRow" style="padding-left:10px">
						<div style="width:49%;">
							<label class="costLabel">Immediate Repaire Category</label>
							
							<select class="costInput" style="width:99%" (change)="selFmeCost('immi', $event)">
								<option></option>
								<option *ngFor="let item of immiCategory; let i=index" [value]="i" [selected]="item.id==fmeItem.short">{{item.label}}</option>
							</select>
							
						</div>
						<div style="width:50%;">
							<label class="costLabel">Captical Item categroy </label>
							
							<select class="costInput" style="width:99%" (change)="selFmeCost('capital', $event)">
								<option></option>
								<option *ngFor="let item of capitalCategory; let i=index" [value]="i" [selected]="item.id==fmeItem.long">{{item.label}}</option>
							</select>
							
						</div>
						<a href='javascript:void(0)' class="btn pcaBtn float-right m-1" (click)="addFmeCat();">Save</a>
						</div>
			</div>
		</div>	
	</div>-->
	<div *ngIf="defaultShow" class="task-box1"  style="width:610px; top:30vh;right: 30vw;position: absolute;" cdkDrag [cdkDragDisabled]="intext">
		<div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.8em"> 
			<label>Define Field Options</label>
			<i class="iconBtn far fa-window-close mr-3 mt-2" style="float:right" (click)="defaultShow=false;"></i>
			<hr class="line1">
			<label class="col-md-4 savedLabel1">Field Option</label>			
			<input type="text" class="col-md-7" placeholder="Input your Field Options here"/>
			<i class="fas fa-plus iconBtn" title="Add Item to Field Options" (click)="addFOItem($event, eriscurcol)"></i>
			<div *ngIf='eriscurcol.FO&&eriscurcol.FO.length>0' class="mt-2" style="max-height: 100px; overflow: auto;">
					<ng-container *ngFor="let label of eriscurcol.FO; let i=index; trackBy:trackByFuntion">
						<label class="col-md-9" *ngIf="label.trim().length>0">{{label}}</label>
						<i class="fas fa-times iconBtn mr-3" title='Remove Item' (click)='removeFOItem(eriscurcol, i)'></i>
						<i class="fas fa-plus iconBtn" title='Add to default value' (click)='addRepeat("FO", label)'></i><br>
					</ng-container>
			</div>
			<hr class="line1">
			<label  class="savedLabel1">Default Value:</label><i class="far fa-edit iconBtn ml-1" (click)="toDefaultEdit(eriscurcol)"></i><br>
			<div style="margin:0; color:#C2D63F;font-size:.9em"> 
				<div class="ckContainer" [ngStyle]="{'cursor':intext? 'context-menu':'default'}" (mouseenter)='intext=true' (mouseleave)='intext=false' style="min-height:300px; max-height:400px; overflow:auto; cursor:auto; width:100%;">
					<app-paragraph [addedSlot]="eriscurcol.DefaultFO.addedItem" [editorType]="'lite'" class="docItem"  [content]="eriscurcol.DefaultFO.html" [getText]="eriscurcol.DefaultFO['reqIndex']"  (selected)="selectedRow=-1;" (onExit)='defaultData($event)' (outText)="defaultText($event)"></app-paragraph>
					<!--<button  class="btn btn-outline-light rf-btn ml-1" (click)="slotToLib=false; selectedRow=-1;showSlots()">Repeat Fields</button>-->				
				</div>
				<button type="button" class="btn btn-outline-light btn-sm float-sm-right mr-1 mt-1 mb-1 pt-0 pb-0 pl-1 pr-1" style="font-size:.9em;" (click)="updateErisHeader(); defaultShow=false">Save</button>
												
			</div>	
		</div>					
</div>

